import { getFullDateTime, parseDate, parseDateWithWeekDay, parseTimeForDate, parseDateForInputField, parseDateForPlannerCard, parseTimeForInputField, parseDateWithMonthOnly, parseDateIST, parseDateWithWeekDayIST } from '../utilities/DateTimeUtils';
import { Log, IsObjectEmpty, IsStringEmpty, IsListEmpty, calcPercentage, toTitleCase } from '../utilities/CommonMethods';
import { ParsedErrorObject } from './ErrorParser';

import iconDefaultAvatar from '../assets/default-avatar.png';
import notificationBellIcon from '../assets/icons/notification-bell-icon.svg'
import notificationBellIconGray from '../assets/icons/notification-bell-icon-gray.svg'
import notificationAnnouncementIcon from '../assets/icons/notification-announcement-icon.svg'
import notificationAnnouncementIconGray from '../assets/icons/notification-announcement-icon-gray.svg'
import SortHelper from '../utilities/SortHelper';
import RouteEndPoints from '../utilities/RouteEndPoints';

// Notification Icons
import AssignmentReminder from '../assets/icons/Notif - Assignment Reminder.svg';
import CertificationUpdate from '../assets/icons/Notif - Certification Update.svg';
import CommunityUpdate from '../assets/icons/Notif - Community Update.svg';
import JobPostUpdate from '../assets/icons/Notif - Job Post Update.svg';
import LiveSession from '../assets/icons/Notif - Live Session.svg';
import LiveSessionNotif from '../assets/icons/Notif - POSTPONED.svg';
import ProgramFee from '../assets/icons/Notif - Program Fee.svg';

import MDCourseLogo from '../assets/logo-md-course.png'
import MECourseLogo from '../assets/logo-mock-exam.png'
import ProgramLogo from '../assets/logo-program.png'

const ParsedError = (error, url, apiCode) => {
	Log("Error Response => ", error);
	if (!error.response) {
		// alert('Cant connect to server');
		const errorMsg = error.toString();
		// DumpErrorLog(url, !IsStringEmpty(errorMsg) ? errorMsg : 'No response from server');
		if (errorMsg === 'Error: Network Error') {
			return {
				status: 888,
				message: 'No Internet Found',
				errorList: null
			};
		} else {
			return {
				status: 500,
				message: 'Something went wrong',
				errorList: null
			};
		}
	} else {
		Error(error.response);
		// Log('Parsed Error => ', error.response.data.detail);
		switch (error.response.status) {
			case 400:
				const errorResponse = ParsedErrorObject(error, apiCode);
				Log('Parsed Error => ', errorResponse);
				return (errorResponse);
			case 401:
				// alert('Unauthorized');
				const msg = !IsStringEmpty(error.response.data.detail) || error.response.data.detail === 'Invalid token.' ? error.response.data.detail : 'Sorry! You are unauthorized';
				return {
					status: 401,
					message: msg,
					errorList: null
				};
			case 404:
				// alert('Not Found');
				return {
					status: 404,
					message: 'Page not found',
					errorList: null
				};
			case 500:
				// alert('Something went wrong at server.');
				// DumpErrorLog(url, 'Something went wrong at server');
				return {
					status: 500,
					message: 'Something went wrong at server',
					errorList: null
				};
			default:
				// alert('Something went wrong');
				// DumpErrorLog(url, 'Something went wrong at server');
				return {
					status: 500,
					message: 'Something went wrong',
					errorList: null
				};
		}
	}
}


// ----------------- Newly Added ---------------

const calculateProgress = (completed, total, forFraction) => {
	const completedCount = !IsStringEmpty(completed) ? completed : 0;
	const totalCount = !IsStringEmpty(total) ? total : 0;

	let percentage = 0;
	if (completedCount !== 0 && totalCount !== 0) {
		percentage = calcPercentage(completedCount, totalCount);
	}

	let updatedData = {}
	if (forFraction) {
		updatedData = {
			label: [completedCount, totalCount],
			value: Math.round(percentage)
		}
	} else {
		updatedData = {
			label: completedCount + '/' + totalCount,
			value: Math.round(percentage)
		}
	}


	return updatedData
}

const normaliseString = (str) => {

	const toReplace = '_'
	const replaceWith = " "

	str.replaceAll(toReplace, replaceWith);
	// console.log(str)

	return str;
}

const ParsedContinueLearningData = (obj) => {
	// -------------- Live Session Progress -------------- 
	const liveSessionProgress = !IsObjectEmpty(obj.ongoing_module.live_session_progress)
		? calculateProgress(obj.ongoing_module.live_session_progress.live_session_attended, obj.ongoing_module.live_session_progress.live_session_completed,) : { value: 0, label: '0/0' };

	// -------------- Assignment Progress -------------- 
	const assignmentProgress = !IsObjectEmpty(obj.ongoing_module.assignment_progress)
		? calculateProgress(obj.ongoing_module.assignment_progress.assignment_submitted, obj.ongoing_module.assignment_progress.assignment_completed,) : { value: 0, label: '0/0' };

	// -------------- Quiz Progress -------------- 
	const quizProgress = !IsObjectEmpty(obj.ongoing_module.quiz_progress)
		? calculateProgress(obj.ongoing_module.quiz_progress.quiz_submitted, obj.ongoing_module.quiz_progress.quiz_completed,) : { value: 0, label: '0/0' };


	let date = '';

	const allTopicsList = !IsObjectEmpty(obj.todays_plan) && !IsListEmpty(obj.todays_plan.todays_topics)
		? obj.todays_plan.todays_topics.map((item) => {
			date = !IsStringEmpty(obj.todays_plan.todays_topics[0].schedule_date)
				? parseDate(obj.todays_plan.todays_topics[0].schedule_date) : '';

			let itemData = null;
			if (item.type === 'topic') {
				itemData = {
					topicId: item.id,
					moduleId: item.module_id,
					moduleName: item.module_name,
					topicName: !IsStringEmpty(item.name) ? item.name : '',
					type: item.type
				};
			} else if (item.type === 'daily' || item.type === 'new daily' || item.type === 'weekly') {
				itemData = {
					topicId: item.topic,
					feedbackId: item.id,
					feedbackName: item.name,
					scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
					type: item.type
				};
			} else if (item.type === 'live') {
				itemData = {
					scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
					status: !IsStringEmpty(item.status) ? item.status : '',
					started: !IsStringEmpty(item.status) && item.status === 'started' ? true : false,
					sessionEnded: !IsStringEmpty(item.status) && item.status === 'ended' ? true : false,
					meetingNumber: !IsStringEmpty(item.meet_id) ? item.meet_id : '',
					password: !IsStringEmpty(item.meet_id) ? item.password : '',
					role: 0,
					signature: !IsStringEmpty(item.signature) ? item.signature : '',
					apiKey: !IsStringEmpty(item.api_key) ? item.api_key : '',
					liveSessionId: !IsStringEmpty(item.id) ? item.id : '',
					topicName: !IsStringEmpty(item.topic_name) ? item.topic_name : '',
					topicId: !IsStringEmpty(item.topic) ? item.topic : '',
					type: item.type
				}
			}
			return itemData;

		}) : [];

	const quizList = !IsObjectEmpty(obj.todays_plan) && !IsListEmpty(obj.todays_plan.todays_quiz)
		? obj.todays_plan.todays_quiz.map(item => {
			return ({
				topicId: item.id,
				moduleId: item.module_id,
				moduleName: item.module_name,
				quizName: item.name,
				scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
				type: item.type
			});
		}) : [];

	const assignmentList = !IsObjectEmpty(obj.todays_plan) && !IsListEmpty(obj.todays_plan.todays_assignment)
		? obj.todays_plan.todays_assignment.map(item => {
			return ({
				topicId: item.id,
				moduleId: item.module_id,
				moduleName: item.module_name,
				assignmentName: item.name,
				scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
				type: item.type
			});
		}) : [];

	const liveSessionList = !IsObjectEmpty(obj.todays_plan) && !IsListEmpty(obj.todays_plan.todays_live_session)
		? obj.todays_plan.todays_live_session.map(liveSession => {
			return ({
				scheduleTime: !IsStringEmpty(liveSession.schedule_date) ? parseTimeForDate(liveSession.schedule_date) : '',
				status: !IsStringEmpty(liveSession.status) ? liveSession.status : '',
				started: !IsStringEmpty(liveSession.status) && liveSession.status === 'started' ? true : false,
				sessionEnded: !IsStringEmpty(liveSession.status) && liveSession.status === 'ended' ? true : false,
				meetingNumber: !IsStringEmpty(liveSession.meet_id) ? liveSession.meet_id : '',
				password: !IsStringEmpty(liveSession.meet_id) ? liveSession.password : '',
				role: 0,
				signature: !IsStringEmpty(liveSession.signature) ? liveSession.signature : '',
				apiKey: !IsStringEmpty(liveSession.api_key) ? liveSession.api_key : '',
				liveSessionId: !IsStringEmpty(liveSession.id) ? liveSession.id : '',
				topicName: !IsStringEmpty(liveSession.topic_name) ? liveSession.topic_name : '',
				topicId: !IsStringEmpty(liveSession.topic) ? liveSession.topic : '',
			});
		}) : [];

	let currentLiveSessionPos = -1;
	if (liveSessionList.length === 1) {
		currentLiveSessionPos = 0;
	} else if (liveSessionList.length > 1) {
		currentLiveSessionPos = !IsListEmpty(liveSessionList) ? liveSessionList.findIndex(liveSession => (liveSession.status === 'upcoming' || liveSession.status === 'started')) : -1;
	}

	if (currentLiveSessionPos === -1 && liveSessionList.length > 1) {
		currentLiveSessionPos = liveSessionList.length - 1;
	}

	const currentTopicId = currentLiveSessionPos !== -1 ? liveSessionList[currentLiveSessionPos].topicId : '';


	const currentTopic = !IsListEmpty(allTopicsList) ? allTopicsList.filter(topic => topic.topicId === currentTopicId && topic.type === 'topic')[0] : {};
	const currentDailyFeedback = !IsListEmpty(allTopicsList) ? allTopicsList.filter(topic => topic.topicId === currentTopicId && (topic.type === 'daily' || topic.type === 'new daily'))[0] : {};
	const currentWeeklyFeedback = !IsListEmpty(allTopicsList) ? allTopicsList.filter(topic => topic.topicId === currentTopicId && topic.type === 'weekly')[0] : {};
	const currentLiveSession = !IsListEmpty(allTopicsList) ? allTopicsList.filter(topic => topic.topicId === currentTopicId && topic.type === 'live')[0] : {};

	// -------------- Final Object for todaysPlan --------------
	const updatedObject = {
		module: {
			id: obj.ongoing_module.id,
			logo: !IsStringEmpty(obj.ongoing_module.thumbnail) ? obj.ongoing_module.thumbnail : iconDefaultAvatar,
			name: obj.ongoing_module.name,
			moduleProgress: { value: obj.ongoing_module.progress, label: obj.ongoing_module.progress + '%' },
			liveSessionProgress: {
				value: liveSessionProgress.value,
				label: liveSessionProgress.label
			},
			assignmentProgress: {
				value: assignmentProgress.value,
				label: assignmentProgress.label
			},
			quizProgress: {
				value: quizProgress.value,
				label: quizProgress.label
			},
		},
		instructor: {
			name: obj.ongoing_module.current_instructor.first_name + ' ' + obj.ongoing_module.current_instructor.last_name,
			profilePic: !IsStringEmpty(obj.ongoing_module.current_instructor.profilepicture_url) ?
				obj.ongoing_module.current_instructor.profilepicture_url : iconDefaultAvatar
		},
		todaysPlan: {
			date: date,

			quizList: quizList,
			assignmentList: assignmentList,

			allTopicsList: allTopicsList,
			currentLiveSession: currentLiveSession,
			currentSessionData: [currentTopic, currentDailyFeedback, currentWeeklyFeedback, currentLiveSession]
		},
		liveSession: liveSessionList,
		overallProgress: {
			grade: !IsStringEmpty(obj.overall_grades) ? obj.overall_grades : 0,
			attendance: !IsStringEmpty(obj.overall_attendance) ? obj.overall_attendance : 0
		}
	};

	return updatedObject;
}

export const ParsedTodaysPlanData = (list) => {

	let date = '', updatedList = [];

	if (!IsListEmpty(list)) {
		updatedList = list.map(todaysPlan => {
			const allTopicsList = !IsObjectEmpty(todaysPlan) && !IsListEmpty(todaysPlan.todays_topics)
				? todaysPlan.todays_topics.map((item) => {
					date = !IsStringEmpty(todaysPlan.todays_topics[0].schedule_date)
						? parseDate(todaysPlan.todays_topics[0].schedule_date) : '';

					let itemData = null;
					if (item.type === 'topic') {
						itemData = {
							topicId: item.id,
							moduleId: item.module_id,
							moduleName: item.module_name,
							topicName: !IsStringEmpty(item.name) ? item.name : '',
							type: item.type
						};
					} else if (item.type === 'daily' || item.type === 'new daily' || item.type === 'weekly') {
						itemData = {
							topicId: item.topic,
							feedbackId: item.id,
							feedbackName: item.name,
							scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
							type: item.type
						};
					} else if (item.type === 'live') {
						itemData = {
							scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
							status: !IsStringEmpty(item.status) ? item.status : '',
							started: !IsStringEmpty(item.status) && item.status === 'started' ? true : false,
							sessionEnded: !IsStringEmpty(item.status) && item.status === 'ended' ? true : false,
							meetingNumber: !IsStringEmpty(item.meet_id) ? item.meet_id : '',
							password: !IsStringEmpty(item.meet_id) ? item.password : '',
							role: 0,
							signature: !IsStringEmpty(item.signature) ? item.signature : '',
							apiKey: !IsStringEmpty(item.api_key) ? item.api_key : '',
							liveSessionId: !IsStringEmpty(item.id) ? item.id : '',
							topicName: !IsStringEmpty(item.topic_name) ? item.topic_name : '',
							topicId: !IsStringEmpty(item.topic) ? item.topic : '',
							type: item.type
						}
					}
					return itemData;

				}) : [];

			const quizList = !IsObjectEmpty(todaysPlan) && !IsListEmpty(todaysPlan.todays_quiz)
				? todaysPlan.todays_quiz.map(item => {
					return ({
						topicId: item.id,
						moduleId: item.module_id,
						moduleName: item.module_name,
						quizName: item.name,
						scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
						type: item.type
					});
				}) : [];

			const assignmentList = !IsObjectEmpty(todaysPlan) && !IsListEmpty(todaysPlan.todays_assignment)
				? todaysPlan.todays_assignment.map(item => {
					return ({
						topicId: item.id,
						moduleId: item.module_id,
						moduleName: item.module_name,
						assignmentName: item.name,
						scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
						type: item.type
					});
				}) : [];

			const liveSessionList = !IsObjectEmpty(todaysPlan) && !IsListEmpty(todaysPlan.todays_live_session)
				? todaysPlan.todays_live_session.map(liveSession => {
					return ({
						scheduleTime: !IsStringEmpty(liveSession.schedule_date) ? parseTimeForDate(liveSession.schedule_date) : '',
						status: !IsStringEmpty(liveSession.status) ? liveSession.status : '',
						started: !IsStringEmpty(liveSession.status) && liveSession.status === 'started' ? true : false,
						sessionEnded: !IsStringEmpty(liveSession.status) && liveSession.status === 'ended' ? true : false,
						meetingNumber: !IsStringEmpty(liveSession.meet_id) ? liveSession.meet_id : '',
						password: !IsStringEmpty(liveSession.meet_id) ? liveSession.password : '',
						role: 0,
						signature: !IsStringEmpty(liveSession.signature) ? liveSession.signature : '',
						apiKey: !IsStringEmpty(liveSession.api_key) ? liveSession.api_key : '',
						liveSessionId: !IsStringEmpty(liveSession.id) ? liveSession.id : '',
						topicName: !IsStringEmpty(liveSession.topic_name) ? liveSession.topic_name : '',
						topicId: !IsStringEmpty(liveSession.topic) ? liveSession.topic : '',
						batchCode: !IsStringEmpty(liveSession.batch_code) ? liveSession.batch_code : '',
					});
				}) : [];

			let currentLiveSessionPos = -1;
			if (liveSessionList.length === 1) {
				currentLiveSessionPos = 0;
			} else if (liveSessionList.length > 1) {
				currentLiveSessionPos = !IsListEmpty(liveSessionList) ? liveSessionList.findIndex(liveSession => (liveSession.status === 'upcoming' || liveSession.status === 'started')) : -1;
			}

			if (currentLiveSessionPos === -1 && liveSessionList.length > 1) {
				currentLiveSessionPos = liveSessionList.length - 1;
			}

			const currentTopicId = currentLiveSessionPos !== -1 ? liveSessionList[currentLiveSessionPos].topicId : '';

			const currentTopic = !IsListEmpty(allTopicsList)
				? allTopicsList.filter(topic => topic.topicId === currentTopicId && topic.type === 'topic')[0] : {};

			const currentDailyFeedback = !IsListEmpty(allTopicsList)
				? allTopicsList.filter(topic => topic.topicId === currentTopicId && (topic.type === 'daily' || topic.type === 'new daily'))[0] : {};

			const currentWeeklyFeedback = !IsListEmpty(allTopicsList)
				? allTopicsList.filter(topic => topic.topicId === currentTopicId && topic.type === 'weekly')[0] : {};

			const currentLiveSession = !IsListEmpty(allTopicsList)
				? allTopicsList.filter(topic => topic.topicId === currentTopicId && topic.type === 'live')[0] : {};

			if (!IsObjectEmpty(currentDailyFeedback) && !IsObjectEmpty(currentLiveSession)) {
				currentDailyFeedback.liveSessionId = currentLiveSession.liveSessionId;
			}

			// -------------- Final Object for todaysPlan --------------
			return {
				date: date,
				batchCode: todaysPlan.batch_code,
				programName: todaysPlan.program_name,

				quizList: quizList,
				assignmentList: assignmentList,

				allTopicsList: allTopicsList,
				currentLiveSession: currentLiveSession,
				currentSessionData: [currentTopic, currentDailyFeedback, currentWeeklyFeedback, currentLiveSession]
			}
		})
	}

	return updatedList;
}

const parsedProgram = (program) => {
	return ({
		programId: program.id,
		programBatchCode: program.batch_code,
		programName: program.name,
		programProgress: program.progress,
		type: program.type,
		isActive: program.is_active,
		isB2C: program.is_b2c,
		community: program.community,
		startDate: parseDate(program.start_date),
		endDate: parseDate(program.end_date),
		logo: program.thumbnail,
		placements: program.placements,
		JRSEnabled: program.enable_jrs,
		JRSValue: program.jrs_score
	});
}

const parsedPreviousTopicFeedback = (feedback) => {
	return ({
		feedbackSubmitted: feedback.feedback_submitted,
		topicId: !IsStringEmpty(feedback.topic_id) ? feedback.topic_id : "",
		feedbackId: !IsStringEmpty(feedback.feedback_id) ? feedback.feedback_id : "",
		topicName: !IsStringEmpty(feedback.topic_name) ? feedback.topic_name : "",
		feedbackType: !IsStringEmpty(feedback.feedback_type) ? feedback.feedback_type : "",
		subtopicExist: !IsStringEmpty(feedback.subtopic_exist) ? feedback.subtopic_exist : false,
	});
}

const ParsedEnrolledPrograms = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map((program) => {
		return parsedProgram(program);
	}) : [];

	return updatedList
}

export const ParsedEnrolledMDs = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map((mdCourse) => {

		const parsedCohorts = !IsListEmpty(mdCourse.cohorts) ? mdCourse.cohorts.map(cohort => {

			const isEnrolled = mdCourse.enrolled_cohorts.findIndex(batchCode => batchCode === cohort.batch_code) > -1;

			return {
				batchCode: cohort.batch_code,
				startDate: parseDateIST(cohort.start_date),
				startTime: parseTimeForDate(cohort.start_date),
				enrolled: isEnrolled,
				status: cohort.status,
				upcomingSession: cohort.upcoming_session || null,
				upcomingSessionDate: cohort.upcoming_session ? parseDateIST(cohort.upcoming_session) : null,
				upcomingSessionTime: cohort.upcoming_session ? parseTimeForDate(cohort.upcoming_session) : null,
			}
		}) : [];

		return ({
			id: mdCourse.id,
			programName: mdCourse.title,
			// logo: mdCourse.thumbnail || MDCourseLogo,
			studyMaterial: { batchCode: mdCourse.self_study },
			type: 'micro_degree',
			isOldMD: mdCourse.id === 0,
			cohorts: parsedCohorts,
			status: mdCourse.course_status,
			enrolledCohorts: mdCourse.enrolled_cohorts,
			enrolledToOneCohort: mdCourse.enrolled_cohorts.length > 0
		});
	}) : [];

	return updatedList
}

export const ParsedEnrolledMEs = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map((meCourse) => {
		return ({
			id: meCourse.id,
			logo: meCourse.thumbnail || MECourseLogo,
			batchCode: meCourse.batch_code,
			programName: meCourse.title,
			type: "mock_exam",
		});
	}) : [];

	return updatedList
}

export const ParsedEnrolledProgramsForTabs = (list) => {
	let updatedList = [];
	if (!IsListEmpty(list)) {
		let programsData = {};
		list.forEach((program, index) => {
			if (program.type === 'edyoda') {
				if (programsData[program.name]) {
					let updatedCohorts = programsData[program.name].cohorts;
					updatedCohorts.push({
						id: program.id,
						batchCode: program.batch_code,
						startDate: parseDate(program.start_date)
					})
					programsData[program.name].cohorts = updatedCohorts;
				} else {
					programsData[program.name] = {
						programId: index,
						programName: program.name,
						// logo: program.thumbnail || ProgramLogo,
						cohorts: [
							{
								id: program.id,
								batchCode: program.batch_code,
								startDate: parseDate(program.start_date)
							}
						]
					};
				}
			}
		})

		updatedList = Object.values(programsData);
	}

	return updatedList
}

const parsedUpcomingModuleCard = (module) => {
	const profilPic = !IsStringEmpty(module.current_instructor.profilepicture_url) ? module.current_instructor.profilepicture_url : iconDefaultAvatar;

	const name = !IsStringEmpty(module.current_instructor.first_name) ? module.current_instructor.first_name + " " + module.current_instructor.last_name : module.current_instructor.username;
	return ({
		moduleId: module.id,
		moduleName: module.name,
		moduleLogo: module.thumbnail,
		instructorPIc: profilPic,
		instructorName: toTitleCase(name),
		stats: [!IsStringEmpty(module.duration) ? module.duration : 0,
		!IsStringEmpty(module.assignment_count) ? module.assignment_count : 0,
		!IsStringEmpty(module.quiz_count) ? module.quiz_count : 0,
		]
	});
}

const parsedCompletedModuleCard = (module) => {
	const profilPic = !IsStringEmpty(module.current_instructor.profilepicture_url) ? module.current_instructor.profilepicture_url : iconDefaultAvatar;

	const name = !IsStringEmpty(module.current_instructor.first_name) ? module.current_instructor.first_name + " " + module.current_instructor.last_name : module.current_instructor.username;

	const liveSessionProgress = !IsObjectEmpty(module.live_session_progress)
		? calculateProgress(module.live_session_progress.live_session_attended, module.live_session_progress.live_session_completed,) : { value: 0, label: '0/0' };

	// -------------- Assignment Progress -------------- 
	const assignmentsProgress = !IsObjectEmpty(module.assignment_progress)
		? calculateProgress(module.assignment_progress.assignment_submitted, module.assignment_progress.assignment_completed,) : { value: 0, label: '0/0' };

	// -------------- Quiz Progress -------------- 
	const quizProgress = !IsObjectEmpty(module.quiz_progress)
		? calculateProgress(module.quiz_progress.quiz_submitted, module.quiz_progress.quiz_completed,) : { value: 0, label: '0/0' };

	return ({
		moduleId: module.id,
		moduleName: module.name,
		moduleLogo: module.thumbnail,
		instructorPIc: profilPic,
		instructorName: toTitleCase(name),
		stats: {
			progress: !IsStringEmpty(module.progress) ? module.progress : 0,
			liveSessions: [liveSessionProgress.value, liveSessionProgress.label],
			assignments: [assignmentsProgress.value, assignmentsProgress.label],
			quiz: [quizProgress.value, quizProgress.label],
		}
	});
}

const ParsedHomepageModulesData = (list, type) => {

	let updatedList = [];

	if (type === 'upcoming') {
		updatedList = !IsListEmpty(list) ? list.map((module) => {
			return parsedUpcomingModuleCard(module);
		}) : [];
	} else if (type === 'completed') {
		updatedList = !IsListEmpty(list) ? list.map((module) => {
			return parsedCompletedModuleCard(module);
		}) : [];
	}
	return updatedList;
}

const ParseNavigationTopicsList = (list) => {
	const updatedList = !IsListEmpty(list)
		? list.map(topic => {
			return {
				topicId: topic.id,
				label: topic.name,
				type: topic.type,
				title: topic.name,
				date: !IsStringEmpty(topic.schedule_date) ? parseDateWithWeekDay(topic.schedule_date) : ''
			}
		}) : []

	return updatedList;
}
const ParseNavigationBatchCodeList = (list) => {
	const updatedList = !IsListEmpty(list)
		? list.map(topic => {
			return {
				label: topic,
				title: topic,
			}
		}) : []

	return updatedList;
}

const ParsePMNavigationTopicsList = (list) => {
	const overViewTab = { label: "Overview", type: "overview", currentTopic: { completed: 0, ongoing: 0, upcoming: 0 }, topicId: "overview", title: "overview", date: '18-06-2021' }

	const parsedList = !IsListEmpty(list)
		? list.map(topic => {
			return {
				topicId: topic.id,
				label: topic.name,
				type: topic.type,
				title: topic.name,
				date: !IsStringEmpty(topic.schedule_date) ? parseDateWithWeekDay(topic.schedule_date) : ''
			}
		}) : []

	let updatedList = [overViewTab, ...parsedList]
	return updatedList;
}


const ParsedModulesPageModulesList = (responseData) => {
	let modulesList = !IsListEmpty(responseData.modules_list.modules)
		? responseData.modules_list.modules.map((item, index) => {
			const topicsList = !IsListEmpty(responseData.topics_list.topics)
				? responseData.topics_list.topics.map(topic => {
					return {
						topicId: topic.id,
						title: topic.name,
						type: topic.type,
						date: !IsStringEmpty(topic.schedule_date) ? parseDateWithWeekDay(topic.schedule_date) : '',
						rawDate: topic.schedule_date || ''
					}
				}) : []

			if (item.type === "module") {
				return {
					id: item.id,
					title: item.name,
					moduleLogo: item.thumbnail,
					topics: topicsList,
					loadingTopics: false,
					type: item.type
				}
			}
			else {
				return {
					id: item.certification_id,
					title: item.certification,
					certificationCode: item.certification_code,
					scheduledDate: item.scheduled_date,
					type: item.type,
					loadingTopics: false,
				}
			}
		}) : [];

	return modulesList;
}

const ParsedTopicsList = (topicsList) => {
	let updatedTopicsList = !IsListEmpty(topicsList)
		? topicsList.map((topic) => {
			// console.log('Parsed Topics List Before => ', topic, topicsList)
			return {
				topicId: topic.id,
				moduleId: !IsStringEmpty(topic.module_id) ? topic.module_id : '',
				moduleName: !IsStringEmpty(topic.module_name) ? topic.module_name : '',
				date: !IsStringEmpty(topic.schedule_date) ? parseDateWithWeekDayIST(topic.schedule_date) : '',
				rawDate: topic.schedule_date || '',
				title: topic.name,
				completed: topic.completed,
				dueDate: !IsStringEmpty(topic.due_date) ? parseDateWithWeekDayIST(topic.due_date) : '',
				score: !IsStringEmpty(topic.score) ? topic.score : '',
				status: !IsStringEmpty(topic.status) ? topic.status : '',
				totalPoints: !IsStringEmpty(topic.total_points) ? topic.total_points : 0,
				type: topic.type
			}
		}) : [];
	return updatedTopicsList;
}
const ParsedModulesList = (topicsList) => {
	let updatedTopicsList = !IsListEmpty(topicsList)
		? topicsList.map((topic) => {
			// console.log('Parsed Topics List Before => ', topic, topicsList)
			return {
				id: topic.id,
				batchCode: !IsStringEmpty(topic.batch_code) ? topic.batch_code : '',
				programId: !IsStringEmpty(topic.program_id) ? topic.program_id : '',
				name: !IsStringEmpty(topic.name) ? topic.name : '',
				startDate: !IsStringEmpty(topic.start_date) ? parseDateWithWeekDayIST(topic.start_date) : '',
				thumbnail: !IsStringEmpty(topic.thumbnail) ? topic.thumbnail : '',
				moduleDetails: topic.module_details

			}
		}) : [];
	return updatedTopicsList;
}

const ParsedTopicDetails = (topicData) => {

	const subTopicsList = !IsObjectEmpty(topicData) && !IsListEmpty(topicData.subtopic)
		? topicData.subtopic.map((subtopic) => {
			return {
				name: subtopic.name,
				id: subtopic.id
			}
		}) : [];

	let sessionsList = [];
	const liveSessionList = !IsListEmpty(topicData.live_session) ? topicData.live_session.map((liveSession) => {

		const scheduledTime = localStorage.getItem("isLearner") === true ? new Date(liveSession.schedule_date).getTime() : new Date(liveSession.schedule_date).getTime() - 10 * 60 * 1000;

		const enableButton = scheduledTime < Date.now() ? true : false;

		let liveSessionDetails = {
			videoTitle: !IsStringEmpty(liveSession.name) ? liveSession.name : '',
			duration: !IsStringEmpty(liveSession.duration) ? liveSession.duration : '00:00',
			scheduledDate: !IsStringEmpty(liveSession.schedule_date) ? parseDateIST(liveSession.schedule_date) : '',
			scheduledTime: !IsStringEmpty(liveSession.schedule_date) ? parseTimeForDate(liveSession.schedule_date) : '',
			createdDate: !IsStringEmpty(liveSession.created_at) ? parseDate(liveSession.created_at) : '',
			createdTime: !IsStringEmpty(liveSession.created_at) ? parseTimeForDate(liveSession.created_at) : '',
			startDateTime: !IsStringEmpty(liveSession.start_time) ? liveSession.start_time : '',
			endDateTime: !IsStringEmpty(liveSession.end_time) ? liveSession.end_time : '',
			scheduledAt: !IsStringEmpty(liveSession.schedule_date) ? liveSession.schedule_date : '',
			createdAt: !IsStringEmpty(liveSession.created_at) ? liveSession.created_at : '',
			startTime: !IsStringEmpty(liveSession.start_time) ? parseTimeForDate(liveSession.start_time) : '',
			endTime: !IsStringEmpty(liveSession.end_time) ? parseTimeForDate(liveSession.end_time) : '',
			name: !IsStringEmpty(liveSession.name) ? liveSession.name : '',
			startURL: !IsStringEmpty(liveSession.start_url) ? liveSession.start_url : '',
			signature: !IsStringEmpty(liveSession.signature) ? liveSession.signature : '',
			liveSessionId: !IsStringEmpty(liveSession.id) ? liveSession.id : '',
			meetId: !IsStringEmpty(liveSession.meet_id) ? liveSession.meet_id : '',
			zoomAccount: !IsStringEmpty(liveSession.zoom_account) ? liveSession.zoom_account : '',
			encPassword: !IsStringEmpty(liveSession.enc_password) ? liveSession.enc_password : '',
			password: !IsStringEmpty(liveSession.password) ? liveSession.password : '',
			status: !IsStringEmpty(liveSession.status) ? liveSession.status : '',
			sessionEnded: !IsStringEmpty(liveSession.status) ? liveSession.status === 'ended' ? true : false : false,
			started: !IsStringEmpty(liveSession.status) && liveSession.status === 'started' ? true : false,
			enableButton: enableButton,
			attendanceMarked: !IsStringEmpty(liveSession.attendance_status) ? liveSession.attendance_status : false
		}

		if (!IsStringEmpty(liveSession.asset_id)) {
			const assetIdList = liveSession.asset_id.split(',');
			const accessTokensList = liveSession.access_token.split(',');

			for (var i = 0; i < assetIdList.length; i++) {
				sessionsList.push(
					{
						...liveSessionDetails,
						videoId: `${assetIdList[i]}/?access_token=${accessTokensList[i]}`,
					}
				)
			}
		} else if (!IsStringEmpty(liveSession.video_id)) {
			const videoIdList = liveSession.video_id.split(',');

			for (var i = 0; i < videoIdList.length; i++) {
				sessionsList.push({ ...liveSessionDetails, videoId: videoIdList[i] })
			}
		} else {
			sessionsList.push({ ...liveSessionDetails, videoId: '' })
		}

		return {
			videoId: !IsStringEmpty(liveSession.video_id) ? liveSession.video_id.split(',') : '',
			...liveSessionDetails
		}
	}) : [];

	// console.log("Live Sessions +=> ", liveSessionList, sessionsList)

	const preWatchVideosList = !IsListEmpty(topicData.video_file) ? topicData.video_file.map((video) => {
		let videoId = '';
		if (!IsStringEmpty(video.asset_id)) {
			videoId = `${video.asset_id}/?access_token=${video.access_token}`
		} else {
			videoId = !IsStringEmpty(video.video_id) ? video.video_id : ''
		}

		return {
			videoId: videoId,
			videoTitle: !IsStringEmpty(video.name) ? video.name : '',
			duration: !IsStringEmpty(video.duration) ? video.duration : '00:00'
		}
	}) : [];

	const feedbacksList = !IsListEmpty(topicData.feedback) ? topicData.feedback.map(feedback => {

		const show = !IsStringEmpty(feedback.schedule_date)
			? new Date(feedback.schedule_date).getTime() < Date.now() ? true : false : false;

		return {
			id: feedback.id,
			type: feedback.type,
			isActive: feedback.is_active,
			isSubmitted: feedback.is_submitted,
			dueDate: feedback.due_date,
			showFeedback: show,
		}
	}) : [];

	const pdfFiles = !IsListEmpty(topicData.pdf_file) ? topicData.pdf_file.map(pdfFile => {
		return {
			type: 'pdf',
			id: pdfFile.id,
			title: pdfFile.name,
			link: pdfFile.pdf_url
		}
	}) : [];

	const slideFiles = !IsListEmpty(topicData.slide_file) ? topicData.slide_file.map(slideFile => {
		return {
			type: 'slide',
			id: slideFile.id,
			title: slideFile.name,
			link: slideFile.slide_url
		}
	}) : [];

	const otherFiles = !IsListEmpty(topicData.other_file) ? topicData.other_file.map(otherFile => {
		return {
			type: 'other',
			id: otherFile.id,
			title: otherFile.name,
			link: otherFile.other_file_url,
			fileContent: otherFile.file_content
		}
	}) : [];

	const embedFiles = !IsListEmpty(topicData.embed_link) ? topicData.embed_link.map(embedLink => {
		return {
			type: 'embed',
			id: embedLink.id,
			title: embedLink.name,
			link: embedLink.link
		}
	}) : [];

	let updatedCurrentTopicDetails = !IsObjectEmpty(topicData)
		? {
			scheduleDate: !IsStringEmpty(topicData.topic.schedule_date) ? parseDateWithWeekDayIST(topicData.topic.schedule_date) : '',
			scheduleDateTime: !IsStringEmpty(topicData.topic.schedule_date)
				? [parseDateForInputField(topicData.topic.schedule_date), parseTimeForDate(topicData.topic.schedule_date)]
				: ['', ''],

			title: topicData.topic.name,
			description: topicData.topic.description,
			id: topicData.topic.id,
			moduleId: topicData.topic.module_id,
			moduleName: topicData.topic.module_name,
			active: false,
			feedbacks: feedbacksList,
			sessionTopics: subTopicsList,
			resources: {
				liveSession: sessionsList,
				preWatchVideos: preWatchVideosList,
				files: [...pdfFiles, ...slideFiles, ...otherFiles, ...embedFiles],
			},
			liveSessionList: liveSessionList
		} : {};

	return updatedCurrentTopicDetails;
}

const parsedNotification = (notif) => {

	const categoriesList = {
		'Live Session': { icon: IsStringEmpty(notif.tag) ? LiveSessionNotif : LiveSession, background: '#FFDED6', border: '#ff9b83' },
		'Certification Update': { icon: CertificationUpdate, background: '#fff7d6', border: '#ffe784' },
		'Community Update': { icon: CommunityUpdate, background: '#fff7d6', border: '#ffe784' },
		'Program Fee': { icon: ProgramFee, background: '#FFF9D6', border: '#ffed83' },
		'Upcoming EMI': { icon: ProgramFee, background: '#FFF9D6', border: '#ffed83' },
		'Payment Due': { icon: ProgramFee, background: '#FFF9D6', border: '#ffed83' },
		'Assignment Reminder': { icon: AssignmentReminder, background: '#d6ddff', border: '#8096ff' },
		'Quiz Reminder': { icon: AssignmentReminder, background: '#d6ddff', border: '#8096ff' },
		'PRM Update': { icon: JobPostUpdate, background: '#d6ffe8', border: '#80ffb8' }, // Need to update
		'Interview Update': { icon: JobPostUpdate, background: '#d6ffe8', border: '#80ffb8' },
		'Job Post Update': { icon: JobPostUpdate, background: '#d6ffe8', border: '#80ffb8' },
	}

	const parsedTag = !IsStringEmpty(notif.tag) ? notif.tag
		: notif.title.indexOf('Live Session') > -1 ? "Live Session"
			: notif.title.indexOf('Quiz') > -1 ? "Quiz Reminder"
				: notif.title.indexOf('Assignment') > -1 ? "Assignment Reminder" : '';

	notif.tag = parsedTag;

	const notificationIcon = !IsStringEmpty(notif.tag) && categoriesList[notif.tag] !== undefined
		? categoriesList[notif.tag].icon
		: notif.type === "announcement"
			? (notif.viewed === true ? notificationAnnouncementIconGray : notificationAnnouncementIcon)
			: notif.type === "notification"
				? (notif.viewed === true ? notificationBellIconGray : notificationBellIcon)
				: notificationBellIconGray;

	return (
		{
			id: notif.id,
			filterCategories: (notif.type === 'popup' || notif.type === 'toast') ? 'important' : notif.type,
			cta: notif.cta,
			type: notif.type,
			notificationIcon: notificationIcon,
			label: notif.title,
			time: !IsStringEmpty(notif.created_at) ? parseTimeForDate(notif.created_at) : '',
			date: !IsStringEmpty(notif.created_at) ? parseDateWithWeekDay(notif.created_at, true) : '',
			dueDate: !IsStringEmpty(notif.expired_at) ? notif.expired_at : '',
			dateTime: !IsStringEmpty(notif.created_at) ? notif.created_at : '',
			url: !IsStringEmpty(notif.url) && notif.url !== "None" ? notif.url : '',
			viewed: notif.viewed,
			message: !IsStringEmpty(notif.message) ? notif.message : '',
			tag: parsedTag,
		}
	)
}

const parsedNotificationDropdown = (notif) => {

	const categoriesList = {
		'Live Session': { icon: IsStringEmpty(notif.tag) ? LiveSessionNotif : LiveSession, background: '#FFDED6', border: '#ff9b83' },
		'Certification Update': { icon: CertificationUpdate, background: '#fff7d6', border: '#ffe784' },
		'Community Update': { icon: CommunityUpdate, background: '#fff7d6', border: '#ffe784' },
		'Program Fee': { icon: ProgramFee, background: '#FFF9D6', border: '#ffed83' },
		'Fee Application Pending': { icon: ProgramFee, background: '#FFF9D6', border: '#ffed83' },
		'Upcoming EMI': { icon: ProgramFee, background: '#FFF9D6', border: '#ffed83' },
		'Payment Due': { icon: ProgramFee, background: '#FFF9D6', border: '#ffed83' },
		'Assignment Reminder': { icon: AssignmentReminder, background: '#d6ddff', border: '#8096ff' },
		'Quiz Reminder': { icon: AssignmentReminder, background: '#d6ddff', border: '#8096ff' },
		'PRM Update': { icon: JobPostUpdate, background: '#d6ffe8', border: '#80ffb8' }, // Need to update
		'Interview Update': { icon: JobPostUpdate, background: '#d6ffe8', border: '#80ffb8' },
		'Job Post Update': { icon: JobPostUpdate, background: '#d6ffe8', border: '#80ffb8' },
	}

	const parsedTag = !IsStringEmpty(notif.tag) ? notif.tag
		: notif.title.indexOf('Live Session') > -1 ? "Live Session"
			: notif.title.indexOf('Quiz') > -1 ? "Quiz Reminder"
				: notif.title.indexOf('Assignment') > -1 ? "Assignment Reminder" : '';

	notif.tag = parsedTag;

	const notificationIcon = !IsStringEmpty(notif.tag) && categoriesList[notif.tag] !== undefined
		? categoriesList[notif.tag].icon
		: notif.type === "announcement"
			? (notif.viewed === true ? notificationAnnouncementIconGray : notificationAnnouncementIcon)
			: notif.type === "notification"
				? (notif.viewed === true ? notificationBellIconGray : notificationBellIcon)
				: notificationBellIconGray;


	return (
		{
			id: notif.id,
			filterCategories: (notif.type === 'popup' || notif.type === 'toast') ? 'important' : notif.type,
			cta: notif.cta,
			type: notif.type,
			notificationIcon: notificationIcon,
			label: notif.title,
			time: !IsStringEmpty(notif.created_at) ? parseTimeForDate(notif.created_at) : '',
			date: !IsStringEmpty(notif.created_at) ? parseDateWithWeekDay(notif.created_at, true) : '',
			dueDate: !IsStringEmpty(notif.expired_at) ? notif.expired_at : '',
			dateTime: !IsStringEmpty(notif.created_at) ? notif.created_at : '',
			url: !IsStringEmpty(notif.url) && notif.url !== "None" ? notif.url : '',
			viewed: notif.viewed,
			message: !IsStringEmpty(notif.message) ? notif.message : '',
			tag: !IsStringEmpty(notif.tag) ? notif.tag : '',

		}
	)
}

const ParsedNotificationList = (list, forDropdown) => {
	let notifList = [], updatedNotifList = [];
	if (forDropdown) {
		notifList = !IsListEmpty(list) ? list.map((item) => {
			return parsedNotificationDropdown(item);
		}) : [];
	} else {
		updatedNotifList = !IsListEmpty(list) ? list.map((item) => {
			return parsedNotification(item);
		}) : [];

		if (!IsListEmpty(updatedNotifList)) {
			let datesObj = {};
			let sortedNotifList = SortHelper.sortNotificationsByMostRecent(updatedNotifList);
			for (var i = 0; i < sortedNotifList.length; i++) {
				datesObj[sortedNotifList[i].date] = true;
			}
			var datesArray = Object.keys(datesObj);
			notifList = datesArray.map(date => {
				return {
					date: date,
					notificationsList: sortedNotifList.filter(listItem => {
						return listItem.date === date;
					})
				}
			});
		}
	}
	return notifList;
}

const ParsedQuizData = (data) => {
	let quizData = {};

	const scheduleDate = !IsStringEmpty(data.quiz.schedule_date) ? data.quiz.schedule_date : '';

	const isActive = new Date(scheduleDate).getTime() < new Date().getTime() ? true : false;

	let quizDetails = !IsObjectEmpty(data.quiz) ? {
		active: isActive,
		moduleId: !IsStringEmpty(data.quiz.module_id) ? data.quiz.module_id : '',
		moduleName: !IsStringEmpty(data.quiz.module_name) ? data.quiz.module_name : '',
		programId: !IsStringEmpty(data.program_id) ? data.program_id : '',
		programBatchCode: !IsStringEmpty(data.batch_code) ? data.batch_code : '',
		topicId: data.quiz.id,
		title: data.quiz.name,
		scheduleDate: !IsStringEmpty(data.quiz.schedule_date) ? parseDateWithWeekDayIST(data.quiz.schedule_date) : '',
		scheduleTime: !IsStringEmpty(data.quiz.schedule_date) ? parseTimeForDate(data.quiz.schedule_date) : '',

		startDate: !IsStringEmpty(data.quiz.schedule_date) ? parseDateIST(data.quiz.schedule_date, false, true) : '',
		startTime: !IsStringEmpty(data.quiz.schedule_date) ? parseTimeForDate(data.quiz.schedule_date) : '',
		dueDate: !IsStringEmpty(data.quiz.due_date) ? parseDate(data.quiz.due_date, false, true) : '',
		dueTime: !IsStringEmpty(data.quiz.due_date) ? parseTimeForDate(data.quiz.due_date) : '',

		type: data.quiz.type,
		status: data.quiz.status,
		isSubmitted: !IsStringEmpty(data.quiz.status) && data.quiz.status !== 'overdue' && data.quiz.status !== 'pending' && data.quiz.status !== 'upcoming' ? true : false,
		duration: !IsStringEmpty(data.quiz.timer) ? data.quiz.timer : '',
		score: !IsStringEmpty(data.quiz.score) ? (data.quiz.score).toFixed(0) : '0',
		passingScore: data.quiz.passing_score,
		totalPoints: data.quiz.total_points,
	} : {};

	let questionIdList = [];

	let quizProblems = !IsListEmpty(data.problems) ? data.problems.map((problem, index) => {

		let correctOptionsCount = 0;
		const optionsList = !IsListEmpty(problem.problem_options) ? problem.problem_options.map(optionItem => {
			correctOptionsCount = !IsStringEmpty(optionItem.is_correct) && optionItem.is_correct === true ? correctOptionsCount + 1 : correctOptionsCount;
			return {
				optionId: !IsStringEmpty(optionItem.id) ? optionItem.id : '',
				optionData: !IsStringEmpty(optionItem.option) ? optionItem.option : '',
				value: '',
				type: !IsStringEmpty(optionItem.option) && optionItem.option.indexOf('https://edyodalms.s3.amazonaws.com/media/thumbnails/') !== -1 ? "image" : "text",
				selected: false,
				correct: !IsStringEmpty(optionItem.is_correct) ? optionItem.is_correct : false
			}
		}) : [];

		questionIdList.push({ id: !IsStringEmpty(problem.id) ? problem.id : '', active: index === 0 ? true : false, attempted: false });

		return {
			questionId: !IsStringEmpty(problem.id) ? problem.id : '',
			title: !IsStringEmpty(problem.description) ? problem.description : '',
			type: correctOptionsCount <= 1 ? 'single' : 'multiple',
			options: optionsList,
			selectedResponse: ''
		}
	}) : [];

	quizData = {
		questionIdList: questionIdList,
		quizDetails: quizDetails,
		questionsList: quizProblems,
		totalQuestions: quizProblems.length
	}

	return quizData;
}

const getName = (first, last, username) => {
	const firstName = !IsStringEmpty(first) ? first : '';
	const lastName = !IsStringEmpty(last) ? last : '';
	const name = !IsStringEmpty(firstName) || !IsStringEmpty(lastName) ? firstName + ' ' + lastName : username;

	return toTitleCase(name);
}

const ParsedInstructorsList = (list) => {

	const updatedList = !IsListEmpty(list.instructors) ? list.instructors.map(instructor => {

		const profilePic = !IsStringEmpty(instructor.user.profilepicture_url) ?
			instructor.user.profilepicture_url : iconDefaultAvatar;

		const modulesList = !IsListEmpty(instructor.module) ? instructor.module.map(module => module.name) : [];

		return {
			id: !IsStringEmpty(instructor.id) ? instructor.id : '',
			name: getName(instructor.user.first_name, instructor.user.last_name, instructor.user.username),
			userId: instructor.user.username,
			profilePic: profilePic,
			modulesList: modulesList,
			active: false
		}
	}) : [];


	return updatedList;
}

const ParsedInstructorDetails = (data, totalHrs, totalStudents, overallRating, feedbacksRecieved) => {

	const profilePic = !IsStringEmpty(data.user.profilepicture_url) ?
		data.user.profilepicture_url : iconDefaultAvatar;

	const modulesList = !IsListEmpty(data.module) ? data.module.map(module => {
		return {
			title: module.name,
			image: module.logo_url
		}
	}) : [];

	const updatedDetails = {
		basicInfo: {
			id: !IsStringEmpty(data.id) ? data.id : '',
			fullName: getName(data.user.first_name, data.user.last_name, data.user.username),
			videoId: !IsStringEmpty(data.user.videoId) ? data.user.videoId : '',
			profilePic: profilePic,
			linkedIn: !IsStringEmpty(data.linkedin) ? data.linkedin : '',
			github: !IsStringEmpty(data.github) ? data.github : '',
			website: !IsStringEmpty(data.website) ? data.website : '',
			tagline: !IsStringEmpty(data.tagline) ? data.tagline : '',
			about: !IsStringEmpty(data.bio) ? data.bio : '',
			pricePoint: data.hourly_payment,
			poolInfo: data.instructor_status,
		},
		modulesList: modulesList,

		stats: {
			hoursCount: !IsStringEmpty(totalHrs) ? totalHrs : '-',
			studentsCount: !IsStringEmpty(totalStudents) ? totalStudents : '-',
			overallRating: !IsStringEmpty(overallRating) ? overallRating : '-',
			feedbacksRecieved: !IsStringEmpty(feedbacksRecieved) ? feedbacksRecieved : '-',
		}
	}

	return updatedDetails;
}

const parsedQuizProblems = (problemsList, forCurriculumPage) => {
	const quizProblems = !IsListEmpty(problemsList) ? problemsList.map(problem => {

		const problemStatus = !IsStringEmpty(problem.status)
			? problem.status === 'passed'
				? 'CORRECT' : problem.status === 'failed' ? 'INCORRECT' : 'NOT ATTEMPTED' : 'NOT ATTEMPTED';

		let correctAnsCount = 0;

		const optionsList = !IsListEmpty(problem.problem_options) ? problem.problem_options.map(optionItem => {

			let optionStatus = '';
			if (problem.status === 'not attempted') {
				optionStatus = 'not attempted';
			} else if (optionItem.is_correct === true && !IsListEmpty(problem.submitted_option) && problem.submitted_option.indexOf(`${optionItem.id}`) !== -1) {
				optionStatus = 'correct';
			} else if (optionItem.is_correct === false && !IsListEmpty(problem.submitted_option) && problem.submitted_option.indexOf(`${optionItem.id}`) !== -1) {
				optionStatus = 'incorrect';
			}

			correctAnsCount = optionItem.is_correct ? correctAnsCount + 1 : correctAnsCount;

			return {
				id: optionItem.id,
				option: optionItem.option,
				isCorrect: optionItem.is_correct,
				correct: optionItem.is_correct,
				optionStatus: optionStatus,
				selected: !IsListEmpty(problem.submitted_option) && problem.submitted_option.indexOf(`${optionItem.id}`) !== -1 ? true : false,
				type: !IsListEmpty(optionItem.option) ? optionItem.option.indexOf('https://edyodalms.s3.amazonaws.com/media/thumbnails/') !== -1 ? 'image' : 'text' : 'text',
			};
		}) : [];

		let updatedProblemObj = {
			id: problem.id,
			status: problemStatus,
			maxScore: !IsStringEmpty(problem.total_points) ? problem.total_points : 0,
			problem: !IsStringEmpty(problem.description) ? problem.description : '',
			options: optionsList,
			selectedOptions: !IsListEmpty(problem.submitted_option) && problemStatus !== 'NOT ATTEMPTED' ? problem.submitted_option : [],
			type: correctAnsCount < 2 ? 'single' : 'multiple'
		}

		if (forCurriculumPage) {
			updatedProblemObj['showEditForm'] = false;
			updatedProblemObj['level'] = !IsStringEmpty(problem.difficulty_level) ? problem.difficulty_level : 'easy';
		}

		return updatedProblemObj;

	}) : [];
	return quizProblems;
}

const ParsedQuizResult = (data, forCurriculumPage) => {

	const not_attempted = !IsStringEmpty(data.not_attempted) ? data.not_attempted : 0;
	const incorrect = !IsStringEmpty(data.incorrect) ? data.incorrect : 0;
	const correct = !IsStringEmpty(data.correct) ? data.correct : 0;
	const total = correct + incorrect + not_attempted;

	const dueDate = !IsStringEmpty(data.quiz.due_date) ? data.quiz.due_date : '';
	const submittedDate = !IsStringEmpty(data.submission_date) ? data.submission_date : '';
	const startDate = !IsStringEmpty(data.quiz.schedule_date) ? data.quiz.schedule_date : '';
	const lateSubmission = !IsStringEmpty(dueDate) && !IsStringEmpty(submittedDate)
		? ((new Date(dueDate)).getTime() > (new Date(submittedDate)).getTime() ? false : true)
		: false;
	const submissionData = calculateProgress(data.quiz.submissions, data.quiz.total_students, true);

	let updatedData = {
		quizResult: {
			id: !IsStringEmpty(data.quiz.id) ? data.quiz.id : '',
			topicId: !IsStringEmpty(data.quiz.id) ? data.quiz.id : '',
			notAttempted: not_attempted,
			incorrect: incorrect,
			correct: correct,
			total: total,
			totalProblems: !IsListEmpty(data.problems) ? data.problems.length !== 0 ? data.problems.length : '-' : '-',
			quizTime: !IsStringEmpty(data.duration) ? data.duration : '00',
			score: !IsStringEmpty(data.quiz.score) ? (data.quiz.score).toFixed(0) : '-',
			totalScore: !IsStringEmpty(data.quiz.total_points) ? data.quiz.total_points : '-',
			passingScore: !IsStringEmpty(data.quiz.passing_score) ? data.quiz.passing_score : '-',
			passingPercentage: !IsStringEmpty(data.quiz.passing_percentage) ? data.quiz.passing_percentage : '0',
			timeLimit: !IsStringEmpty(data.quiz.timer) ? data.quiz.timer : '-',
			result: !IsStringEmpty(data.quiz.status) ? data.quiz.status : 'PENDING',
			submitDate: !IsStringEmpty(submittedDate) ? parseDate(submittedDate, false, true) : '--', // '11 Mar 2021'
			submitTime: !IsStringEmpty(submittedDate) ? parseTimeForDate(submittedDate) : '-- PM', // '02:39 PM'
			dueDate: !IsStringEmpty(dueDate) ? parseDate(dueDate, false, true) : '--',
			dueTime: !IsStringEmpty(dueDate) ? parseTimeForDate(dueDate) : '-- PM',
			startDate: !IsStringEmpty(startDate) ? parseDate(startDate, false, true) : '--',
			startTime: !IsStringEmpty(startDate) ? parseTimeForDate(startDate) : '-- PM',
			submissionProgress: {
				value: submissionData.value,
				label: submissionData.label
			},
			classGrades: !IsStringEmpty(data.quiz.grades) ? data.quiz.grades : '-',
			date: !IsStringEmpty(startDate) ? parseDateWithWeekDay(startDate) : '',
			title: !IsStringEmpty(data.quiz.name) ? data.quiz.name : '',
			type: 'quiz',

			lateSubmission: lateSubmission
		},
		quizProblems: parsedQuizProblems(data.problems, forCurriculumPage)
	}

	return updatedData;
}

const ParsedBasicInfo = (data) => {

	const linkedIn = !IsStringEmpty(data.linkedin) ? data.linkedin.indexOf('http') !== 0
		? 'http://' + data.linkedin : data.linkedin : "",

		twitter = !IsStringEmpty(data.twitter) ? data.twitter.indexOf('http') !== 0
			? 'http://' + data.twitter : data.twitter : "",

		website = !IsStringEmpty(data.website) ? data.website.indexOf('http') !== 0
			? 'http://' + data.website : data.website : "",

		github = !IsStringEmpty(data.github) ? data.github.indexOf('http') !== 0
			? 'http://' + data.github : data.github : "",

		hackerrank = !IsStringEmpty(data.hackerrank) ? data.hackerrank.indexOf('http') !== 0
			? 'http://' + data.hackerrank : data.hackerrank : "",

		codepen = !IsStringEmpty(data.codepen) ? data.codepen.indexOf('http') !== 0
			? 'http://' + data.codepen : data.codepen : "";


	const updatedData = {
		id: data.id,
		fullName: getName(data.user.first_name, data.user.last_name, data.user.username),
		email: !IsStringEmpty(data.user.email) ? data.user.email : '',
		phoneNumber: !IsStringEmpty(data.phonenumber) ? data.phonenumber : '',
		whatsappNumber: !IsStringEmpty(data.whatsapp_number) ? data.whatsapp_number : '',
		videoId: !IsStringEmpty(data.videoId) ? data.videoId : '',
		profilePic: !IsStringEmpty(data.user.profilepicture_url) ? data.user.profilepicture_url : iconDefaultAvatar,
		linkedIn: linkedIn,
		twitter: twitter,
		website: website,
		github: github,
		hackerrank: hackerrank,
		codepen: codepen,
		about: !IsStringEmpty(data.bio) ? data.bio : '',
	};
	return updatedData;
}

const parseEducationItem = (obj) => {
	if (IsObjectEmpty(obj)) return null;

	return {
		id: obj.id,
		degreeName: obj.graduation_name,
		instituteName: obj.institute_name,
		score: obj.score,
		yearOfCompletion: obj.year_of_completion
	}
}

const ParsedEducationSummaryList = (data) => {
	const educationSummaryList = !IsListEmpty(data.education_details) && data.education_details.length > 0
		? data.education_details.map((item) => {
			return parseEducationItem(item);
		}) : [];
	return educationSummaryList;
}


const parseWorkExperienceItem = (obj) => {
	if (IsObjectEmpty(obj)) return null;

	return {
		id: obj.id,
		companyName: obj.company_name,
		role: obj.role,
		responsibilities: obj.responsibilities,
		startDate: !IsStringEmpty(obj.start_date) ? parseDateForInputField(obj.start_date) : '',
		endDate: !IsStringEmpty(obj.end_date) ? parseDateForInputField(obj.end_date) : '',
		ongoingCurrently: obj.currently_working,
		projectLink: obj.project_url
	}
}

const ParsedWorkExperienceList = (workList) => {
	if (!IsListEmpty(workList) && workList.length > 0) {

		const workExperiences = workList.map((item, pos) => {
			return parseWorkExperienceItem(item);
		});
		return workExperiences;
	} else {
		// Log('returning empty work experience list')
		return [];
	}
}

const ParsedCoursesAndCertifications = (certifications) => {
	if (!IsListEmpty(certifications) && certifications.length > 0) {

		const parsedData = certifications.map((item, pos) => {
			if (IsObjectEmpty(item)) return null;
			return {
				id: item.id,
				name: item.certification_name,
				link: item.certificate
			};
		});
		return parsedData;
	} else {
		// Log('returning empty list')
		return [];
	}
}

const ParsedHonorsAndAccomplishments = (honorsList) => {
	if (!IsListEmpty(honorsList) && honorsList.length > 0) {

		const parsedData = honorsList.map((item, pos) => {
			if (IsObjectEmpty(item)) return null;
			return {
				id: item.id,
				description: item.description,
				link: item.url
			};
		});
		return parsedData;
	} else {
		// Log('returning empty list')
		return [];
	}
}


const ParsedAssignmentNewProblem = (problem) => {

	const gradingGuidesList = !IsObjectEmpty(problem) && !IsListEmpty(problem.grading_criterias)
		? problem.grading_criterias.map(criteria => {
			return {
				id: criteria.id,
				value: criteria.name,
				maxScore: criteria.total_points
			}
		}) : [];

	const parsedProblem = !IsObjectEmpty(problem) ? {
		id: problem.id,
		name: !IsStringEmpty(problem.name) ? problem.name : '',
		description: !IsStringEmpty(problem.description) ? problem.description : '',
		level: !IsStringEmpty(problem.difficulty_level) ? problem.difficulty_level : '',
		score: !IsStringEmpty(problem.total_points) ? problem.total_points : '',
		status: !IsStringEmpty(problem.status) ? problem.status : 'pending',
		isSubmitted: !IsStringEmpty(problem.status) && problem.status !== 'pending' ? true : false,
		showEditForm: false,
		gradingGuidesList: gradingGuidesList
	} : {};

	return parsedProblem;
}

const ParsedAssignmentDetails = (data) => {

	let updatedData = {};

	const dueDate = !IsStringEmpty(data.assignment.due_date) ? data.assignment.due_date : '';
	const scheduleDate = !IsStringEmpty(data.assignment.schedule_date) ? data.assignment.schedule_date : '';
	const submittedDate = !IsStringEmpty(data.assignment.submission_date) ? data.assignment.submission_date : '';
	const lateSubmission = !IsStringEmpty(dueDate) && !IsStringEmpty(submittedDate)
		? ((new Date(dueDate)).getTime() > (new Date(submittedDate)).getTime() ? false : true)
		: false;
	const submissionData = calculateProgress(data.assignment.submissions, data.assignment.total_students, true);

	let totalAssignmentScore = 0;

	const isActive = new Date(scheduleDate).getTime() < new Date().getTime();

	const problemsList = !IsListEmpty(data.problems) ? data.problems.map(problem => {
		totalAssignmentScore = totalAssignmentScore + (!IsStringEmpty(problem.total_points) ? problem.total_points : 0);

		const gradingGuidesList = !IsListEmpty(problem.grading_criterias)
			? problem.grading_criterias.map(criteria => {
				return {
					id: criteria.id,
					value: criteria.name,
					maxScore: criteria.total_points
				}
			}) : [];


		return {
			id: problem.id,
			name: !IsStringEmpty(problem.name) ? problem.name : '',
			description: !IsStringEmpty(problem.description) ? problem.description : '',
			level: !IsStringEmpty(problem.difficulty_level) ? problem.difficulty_level : '',
			score: !IsStringEmpty(problem.total_points) ? problem.total_points : '',
			status: !IsStringEmpty(problem.status) ? problem.status : 'pending',
			isSubmitted: !IsStringEmpty(problem.status) && problem.status !== 'pending' && problem.status !== 'upcoming' ? true : false,
			showEditForm: false,
			gradingGuidesList: gradingGuidesList,
		}
	}) : [];

	const assignmentDetails = !IsObjectEmpty(data.assignment) ? {
		active: isActive,
		date: !IsStringEmpty(scheduleDate) ? parseDateWithWeekDayIST(scheduleDate) : '',
		title: !IsStringEmpty(data.assignment.name) ? data.assignment.name : '',
		// type: data.assignment.type,
		type: 'assignment',

		dailyFeedback: false,
		weeklyFeedback: false,

		topicId: data.assignment.id,
		moduleId: !IsStringEmpty(data.assignment.module_id) ? data.assignment.module_id : '',
		moduleName: !IsStringEmpty(data.assignment.module_name) ? data.assignment.module_name : '',

		scheduleDate: !IsStringEmpty(scheduleDate) ? parseDateIST(scheduleDate) : '',
		scheduleTime: !IsStringEmpty(scheduleDate) ? parseTimeForDate(scheduleDate) : '',
		dueDate: !IsStringEmpty(dueDate) ? parseDateIST(dueDate) : '',
		dueTime: !IsStringEmpty(dueDate) ? parseTimeForDate(dueDate) : '',
		submittedDate: !IsStringEmpty(submittedDate) ? parseDateIST(submittedDate) : '',
		submittedTime: !IsStringEmpty(submittedDate) ? parseTimeForDate(submittedDate) : '',

		status: data.assignment.status,
		isSubmitted: !IsStringEmpty(data.assignment.status) && data.assignment.status !== 'overdue' && data.assignment.status !== 'pending' && data.assignment.status !== 'upcoming' ? true : false,
		lateSubmission: lateSubmission,

		score: !IsStringEmpty(data.assignment.score) ? (data.assignment.score).toFixed(0) : '-',
		problemsCount: !IsListEmpty(data.problems) ? data.problems.length : '-',
		totalScore: totalAssignmentScore !== 0 ? totalAssignmentScore : '-',
		passingScore: !IsStringEmpty(data.assignment.passing_score) ? data.assignment.passing_score : '-',
		passingPercentage: !IsStringEmpty(data.assignment.passing_score)
			? Math.floor(calcPercentage(data.assignment.passing_score, totalAssignmentScore)) : 0,
		submissionProgress: {
			value: submissionData.value,
			label: submissionData.label
		},
		classGrades: !IsStringEmpty(data.assignment.grades) ? data.assignment.grades : '-',
		totalProblems: problemsList.length !== 0 ? problemsList.length : '-'
	} : {};


	updatedData = {
		assignmentDetails: assignmentDetails,
		assignmentProblems: problemsList,
	}

	return updatedData;
}

const ParsedSubmissionsList = (list) => {

	const updatedList = !IsListEmpty(list) ? list.map(submission => {
		return {
			id: submission.id,
			moduleName: !IsStringEmpty(submission.module_name) ? submission.module_name : '',
			name: !IsStringEmpty(submission.name) ? toTitleCase(submission.name) : '',
			problemsCount: !IsStringEmpty(submission.problems_count) ? submission.problems_count : '-',
			time: !IsStringEmpty(submission.timer) ? submission.timer : '',
			status: submission.status,
			dateTime: !IsStringEmpty(submission.due_date) ? parseDate(submission.due_date) + ', ' + parseTimeForDate(submission.due_date) : '',
			score: (!IsStringEmpty(submission.score) ? submission.score : 0) + '/' + (!IsStringEmpty(submission.total_points) ? submission.total_points : 0),
			type: submission.type
		}
	}) : [];

	return updatedList;
}

const ParsedFeedbackDetails = (data) => {

	const updatedData = {
		id: data.id,
		isSubmitted: !IsStringEmpty(data.is_submitted) ? data.is_submitted : false,
		name: !IsStringEmpty(data.name) ? data.name : '',
		description: !IsStringEmpty(data.description) ? data.description : '',
		isActive: !IsStringEmpty(data.is_active) ? data.is_active : '',
		type: !IsStringEmpty(data.type) ? data.type : '',
		scheduleDate: !IsStringEmpty(data.schedule_date) ? parseDateWithWeekDayIST(data.schedule_date) : '',
		dueDate: !IsStringEmpty(data.due_date) ? data.due_date : '',
		module: !IsStringEmpty(data.module) ? data.module : ''
	}
	return updatedData;
}

const ParsedFeedbackQuestions = (questionsList, feedbackType) => {
	const updatedQuestionsList = !IsListEmpty(questionsList) ? questionsList.map((question, index) => {

		let questionType = '';

		if (feedbackType === 'daily') {
			questionType = !IsListEmpty(question.problem_options) ? 'topic'
				: question.description.indexOf('doubts') !== -1 ? 'doubt' : 'rating';
		} else if (feedbackType === 'weekly') {

			questionType = index < 4 ? 'agreement'
				: index === 4 ? 'like' : 'rating';
		}

		let topicsList = !IsListEmpty(question.problem_options)
			? question.problem_options.map(optionItem => {
				let topics = {};
				if (feedbackType === 'daily') {
					topics = {
						id: optionItem.id,
						label: !IsStringEmpty(optionItem.option) ? optionItem.option : '',
						value: '',
						options: [
							{ name: 'Yes', id: 0, selected: false },
							{ name: 'No', id: 1, selected: false }
						]
					}
				} else if (feedbackType === 'weekly') {
					topics = {
						id: optionItem.id,
						label: !IsStringEmpty(optionItem.option) ? optionItem.option : '',
						value: `${optionItem.id}`,
						selected: false
					}
				}
				return topics;
			})
			: questionType === 'doubt' ? [
				{ label: 'Yes', value: 'Yes', selected: false },
				{ label: 'No', value: 'No', selected: false }
			]
				: questionType === 'rating' ? [
					{ label: 1, value: '1', selected: false },
					{ label: 2, value: '2', selected: false },
					{ label: 3, value: '3', selected: false },
					{ label: 4, value: '4', selected: false },
					{ label: 5, value: '5', selected: false },
					{ label: 6, value: '6', selected: false },
					{ label: 7, value: '7', selected: false },
					{ label: 8, value: '8', selected: false },
					{ label: 9, value: '9', selected: false },
					{ label: 10, value: '10', selected: false }
				] : [];

		return {
			id: question.id,
			questionNumber: (index + 1),
			title: !IsStringEmpty(question.description) ? question.description : '',
			type: questionType,
			subTitle: '',
			topics: topicsList,
			errorMessage: 'Please select at least one option',
			response: [],
			touched: false
		}
	}) : [];
	return updatedQuestionsList;
}

const ParsedAssignmentResult = (data) => {

	const problemsList = !IsListEmpty(data.result) ? data.result.map(problem => {

		const gradingObjectivesList = !IsListEmpty(problem.submissions) ? problem.submissions.map(objective => {
			return {
				id: objective.grading_criteria_id,
				name: objective.grading_criteria_name,
				totalMarks: objective.grading_criteria_total_points,
				allotedMarks: objective.score,
				comments: objective.comments
			}
		}) : [];

		return {
			id: problem.id,
			name: !IsStringEmpty(problem.name) ? problem.name : '',
			description: !IsStringEmpty(problem.description) ? problem.description : '',
			level: !IsStringEmpty(problem.difficulty_level) ? problem.difficulty_level : '',
			score: !IsStringEmpty(problem.score) ? problem.score : '',
			totalPoints: !IsStringEmpty(problem.total_points) ? problem.total_points : '',
			submissionLinks: !IsListEmpty(problem.submission_links) ? problem.submission_links : [],
			gradingObjectivesList: gradingObjectivesList,
		}
	}) : [];


	return problemsList;
}

const ParsedOverallPerformanceData = (data) => {

	const liveSessionsData = calculateProgress(data.attendance.session_attended, data.attendance.total_sessions, true);
	const weeksCompletedData = calculateProgress(data.attendance.weeks_completed, data.attendance.total_weeks, true);

	const quizzesCompletedData = calculateProgress(data.submission.quiz_submitted, data.submission.total_quizzes, true);
	const assignmentsCompletedData = calculateProgress(data.submission.assignment_submitted, data.submission.total_assignments, true);

	// const projectsCompletedData = calculateProgress(data.submission.session_attended, data.submission.total_sessions);

	const updatedData = {
		overallGradePercentage: !IsStringEmpty(data.grades.overall_grade) ? Math.floor(data.grades.overall_grade) : 0,
		classRank: !IsStringEmpty(data.grades.class_rank) ? data.grades.class_rank : 0,

		attendancePercentage: !IsStringEmpty(data.attendance.average_attendance) ? Math.floor(data.attendance.average_attendance) : 0,
		liveSessions: {
			value: liveSessionsData.value,
			label: liveSessionsData.label
		},
		weeksCompleted: {
			value: weeksCompletedData.value,
			label: weeksCompletedData.label
		},

		quizzesCompleted: {
			value: quizzesCompletedData.value,
			label: quizzesCompletedData.label
		},
		assignmentsCompleted: {
			value: assignmentsCompletedData.value,
			label: assignmentsCompletedData.label
		},
		// projectsCompleted: {
		// 	value: liveSessionsData.value,
		// 	label: liveSessionsData.label
		// },
	}

	const modulesList = !IsListEmpty(data.modules) ? data.modules.map(module => {
		return {
			id: module.id,
			label: !IsStringEmpty(module.name) ? module.name : '',
			logo: !IsStringEmpty(module.thumbnail) ? module.thumbnail : ''
		}
	}) : [];

	modulesList.unshift({
		id: '',
		label: 'Overall Program',
		logo: null
	})

	const parsedData = {
		performanceData: updatedData,
		modulesList: modulesList
	}

	return parsedData;
}

const ParsedOverallAttendanceData = (data) => {
	const updatedData = !IsListEmpty(data.live_sessions) ? data.live_sessions.map((session, index) => {

		const isFutureSession = !IsStringEmpty(session.schedule_date) ? new Date(session.schedule_date).getTime() > Date.now() ? true : false : false;

		return {
			id: session.id,
			moduleLogo: session.module_logo,
			topicName: !IsStringEmpty(session.topic_name) ? session.topic_name : '-',
			scheduledDate: !IsStringEmpty(session.schedule_date) ? parseDate(session.schedule_date) + ', ' + parseTimeForDate(session.schedule_date) : '-',
			isAttended: IsStringEmpty(session.is_attended) || isFutureSession ? '-' : session.is_attended === true ? 'Attended' : 'Missed',
			moduleName: !IsStringEmpty(session.module_name) ? session.module_name : '',
			topicId: !IsStringEmpty(session.topic_id) ? session.topic_id : '',
			batchCode: !IsStringEmpty(session.batch_code) ? session.batch_code : '',
			sessionCompleted: new Date(session.schedule_date).getTime() < new Date().getTime() ? true : false
		}
	}) : [];
	return updatedData;
}

const ParsedOverallGradesData = (data) => {
	const updatedData = !IsListEmpty(data.students) ? data.students.map((student, index) => {
		return {
			rankDifference: !IsStringEmpty(student.rank_difference) ? student.rank_difference : '-',
			rankStatus: !IsStringEmpty(student.rank_difference) && student.rank_difference > 0 ? 'RankUp' : "RankDown",
			profilePic: !IsStringEmpty(student.profilepicture_url) ? student.profilepicture_url : iconDefaultAvatar,
			learnerName: !IsStringEmpty(student.name) ? toTitleCase(student.name) : '-',
			learnerRank: !IsStringEmpty(student.rank) ? student.rank : 0,
			overallGrade: !IsStringEmpty(student.overall_grades) ? student.overall_grades : 0,
		}
	}) : [];
	return updatedData;
}
const ParsedJRSData = (data) => {
	const updatedData = !IsListEmpty(data.students) ? data.students.map((student, index) => {
		return {
			name: !IsStringEmpty(student.name) ? toTitleCase(student.name) : '-',
			email: !IsStringEmpty(student.email) ? toTitleCase(student.email) : '-',
			userName: !IsStringEmpty(student.username) ? toTitleCase(student.username) : '-',
			jrsScore: !IsStringEmpty(student.jrs_score) ? Math.round(student.jrs_score) : 0,
		}
	}) : [];
	data = {
		students: updatedData,
		isEnable: data.enable_jrs
	};
	return data;
}

const ParsedOverallSubmissionsData = (data) => {


	const updatedData = !IsListEmpty(data.submissions) ? data.submissions.map((submission) => {
		let score = (!IsStringEmpty(submission.score) ? (submission.score).toFixed(0) : 0) + ' / ' + (!IsStringEmpty(submission.total_points) ? submission.total_points : 0);

		let overallGrade = '-'
		if (submission.score && submission.total_points) {
			overallGrade = (submission.score / submission.total_points * 100).toFixed(2)
		}

		if (submission.score === null) {
			score = '-';
		}

		return {
			rankDifference: !IsStringEmpty(submission.grades_difference) ? Math.abs(submission.grades_difference) : '-',
			rankStatus: !IsStringEmpty(submission.grades_difference) && submission.grades_difference >= 0 ? 'RankUp' : "RankDown",
			name: !IsStringEmpty(submission.name) ? toTitleCase(submission.name) : '-',
			score: score,
			status: !IsStringEmpty(submission.status) ? submission.status : '-',
			// overallGrade: !IsStringEmpty(submission.overall_grades) ? submission.overall_grades : '-'
			overallGrade: overallGrade,
			startDate: submission.start_date,
			dueDate: submission.due_date,
			isSubmitted: submission.is_submitted,
			topicId: submission.topic_id,
			type: submission.type,
			moduleName: submission.module_name,
			moduleLogo: submission.module_logo
		}
	}) : [];
	return updatedData;
}

const ParsedModuleOverviewData = (data) => {

	let hoursTaught = calculateProgress(data.ongoing_module.module_details.hours_taught, data.ongoing_module.module_details.total_hours_taught, false);

	let liveSessionProgress = calculateProgress(data.ongoing_module.module_details.live_sessions_happened, data.ongoing_module.module_details.live_sessions_scheduled, false);

	let assignmentProgress = calculateProgress(data.ongoing_module.module_details.assignment_happened, data.ongoing_module.module_details.assignment_scheduled, false);

	let quizProgress = calculateProgress(data.ongoing_module.module_details.quiz_happened, data.ongoing_module.module_details.quiz_scheduled, false);


	let liveSessionDataList = !IsObjectEmpty(data) && !IsObjectEmpty(data.ongoing_module) && !IsListEmpty(data.ongoing_module.module_details.live_session_upcoming) ? data.ongoing_module.module_details.live_session_upcoming : [];

	let liveSessionsList = !IsListEmpty(liveSessionDataList) ? liveSessionDataList.map(liveSessionData => {
		const enableButton = new Date(liveSessionData.schedule_date).getTime() - 10 * 60 * 1000 < Date.now() ? true : false;

		return {
			date: !IsStringEmpty(liveSessionData.schedule_date) ? parseDate(liveSessionData.schedule_date) : '',
			name: !IsStringEmpty(liveSessionData.topic_name) ? liveSessionData.topic_name : '',
			scheduleDate: !IsStringEmpty(liveSessionData.schedule_date) ? parseDate(liveSessionData.schedule_date) : '',
			scheduleTime: !IsStringEmpty(liveSessionData.schedule_date) ? parseTimeForDate(liveSessionData.schedule_date) : '',
			topicId: !IsStringEmpty(liveSessionData.topic) ? liveSessionData.topic : '',
			started: !IsStringEmpty(liveSessionData.status) && liveSessionData.status === 'started' || enableButton ? true : false,

			startURL: !IsStringEmpty(liveSessionData.start_url) ? liveSessionData.start_url : '',
			signature: !IsStringEmpty(liveSessionData.signature) ? liveSessionData.signature : '',
			liveSessionId: !IsStringEmpty(liveSessionData.id) ? liveSessionData.id : '',
			status: !IsStringEmpty(liveSessionData.status) ? liveSessionData.status : '',
			sessionEnded: !IsStringEmpty(liveSessionData.status) ? liveSessionData.status === 'ended' ? true : false : false,
			enableButton: enableButton,
			showLoader: false
		}
	}) : [];

	const updatedModuleData = {
		module: {
			name: data.ongoing_module.name,
			logo: data.ongoing_module.thumbnail,
			hoursTaught: {
				value: hoursTaught.value,
				label: hoursTaught.label
			},
			liveSessionProgress: {
				value: liveSessionProgress.value,
				label: liveSessionProgress.label
			},
			assignmentProgress: {
				value: assignmentProgress.value,
				label: assignmentProgress.label
			},
			quizProgress: {
				value: quizProgress.value,
				label: quizProgress.label
			}
		},
		upcomingSessionPlan: liveSessionsList
	}
	return updatedModuleData;
}

const ParsedEnrolledModules = (modulesList) => {
	const parsedList = !IsListEmpty(modulesList) ? modulesList.map((module) => {
		return {
			programId: module.program_id,
			batchCode: module.batch_code,
			moduleId: module.id,
			moduleName: module.name,
			startDate: !IsStringEmpty(module.start_date) ? parseDate(module.start_date) : '',
			startDateRaw: !IsStringEmpty(module.start_date) ? module.start_date : '',
			moduleLogo: module.thumbnail,
		}
	}) : [];
	let updatedList = SortHelper.sortEnrolledModulesByMostRecent(parsedList)

	return updatedList;
}

const ParsedOngoingModuleData = (data) => {

	const updatedData = !IsObjectEmpty(data) ? {
		programId: data.ongoing_module.program_id,
		batchCode: data.ongoing_module.batch_code,
		moduleId: data.ongoing_module.id,
		community: (data.ongoing_module.community === null) ? false : data.ongoing_module.community,
		moduleName: data.ongoing_module.name,
		startDate: !IsStringEmpty(data.ongoing_module.start_date) ? parseDate(data.ongoing_module.start_date) : '',
		moduleLogo: data.ongoing_module.thumbnail,
		moduleProgress: !IsStringEmpty(data.ongoing_module.module_details.progress) ? data.ongoing_module.module_details.progress : 0,
		moduleStatus: !IsStringEmpty(data.ongoing_module.module_details.status) ? data.ongoing_module.module_details.status : 0,
		moduleMetaData: {
			activeStudents: !IsStringEmpty(data.active_students) ? data.active_students : 0,
			totalStudents: !IsStringEmpty(data.total_students) ? data.total_students : 0,
			classGrade: !IsStringEmpty(data.overall_grades) ? Math.floor(data.overall_grades) : 0,
			rating: !IsStringEmpty(data.overall_rating) ? Math.floor(data.overall_rating) : 0,
		}
	} : {};

	return updatedData;
}

const ParsedBadgeData = (data) => {
	const badge = {
		currentBadge: !IsObjectEmpty(data.badge.current_badge) ? data.badge.current_badge : {},
		upcomingBadge: !IsObjectEmpty(data.badge.upcoming_badge) ? data.badge.upcoming_badge : {},
		numberOfSessionRemaining: data.badge.number_of_session_remaining_for_next_badge,
		numberOfSessionRequired: data.badge.number_of_session_required_for_next_badge,
		showGamificationCard: data.badge.gamification_added === true,
		batchmates: !IsObjectEmpty(data.badge.batchmates) ? Object.values(data.badge.batchmates).map(student => {
			return {
				badge: !IsObjectEmpty(student.badge) ? student?.badge : {},
				name: student.name,
				profilePicture: !IsStringEmpty(student.profile_picture) ? student.profile_picture : iconDefaultAvatar
			}
		})
			: [],
		claimedStatus: data.badge.claimed_status,
		upcomingBadgeActive: data.badge.upcoming_badge_active,
		upcomingLearnerRewardId: data.badge.upcoming_learner_reward_id,
		lastBadge: data.badge.last_badge
	}
	return badge
}

const ParsedMyRewardsData = (data) => {
	if (!IsListEmpty(data)) {
		const parsedMyRewards = data.map(reward => {
			return {
				rewardName: reward.reward_name,
				badge: !IsStringEmpty(reward.badge) ? reward.badge[0].toUpperCase() + reward.badge.slice(1) : '',
				rewardType: reward.reward_type,
				badgeIcon: reward.badge_icon,
				numberOfSessionNeeded: reward.no_of_session_needed,
				sessionForBadge: reward.no_of_session_for_badge,
				status: reward.reward_status,
				learnerRewardId: reward.learner_reward_id
			}
		})
		return parsedMyRewards
	}
	return []
}

const ParsedEditRewardsData = (data) => {
	const ParsedEditRewardData = {
		badgesList: data.badges_list.map(badge => {
			return {
				badgeId: badge.badge_id,
				badgeIcon: badge.badge_icon,
				badgeName: badge.badge_name,
				label: badge.badge_name
			}
		}),
		gamificationData: typeof (data.gamification_data) === 'string'
			? []
			: !IsListEmpty(data.gamification_data) ?
				data.gamification_data.map(gamification => {
					return {
						badgeIcon: gamification.badge_icon,
						badgeId: gamification.badge_id,
						badgeName: gamification.badge_name,
						rewardId: gamification.reward_id,
						rewardName: gamification.reward_name,
						upgradeCriteria: gamification.upgrade_criteria,
						badgeDropdown: false,
						rewardDropdown: false
					}
				}) : [],
		rewardsList: data.rewards_list.map(reward => {
			return {
				rewardId: reward.reward_id,
				rewardName: reward.reward_name,
				label: reward.reward_name
			}
		}),
		gamificationList: data.gamification_list.map(gamification => {
			return {
				id: gamification.gamification_id,
				name: gamification.gamification_name,
				label: gamification.gamification_name
			}
		}),
		currentProgramGamification: data.current_program_gamification,
		gamificationEnable: !IsStringEmpty(data.gamification_flag) ? data.gamification_flag : false,
		gamificationIsActive: !IsStringEmpty(data.gamification_active) ? data.gamification_active : false,
		currentProgramGamificationId: data.current_program_gamification_id,

	}
	return ParsedEditRewardData
}

const ParsedSubmissionData = (data) => {

	const submissionsReceived = calculateProgress(data.submissions, data.total_students, true);

	let updatedData = {};
	if (!IsObjectEmpty(data) && IsStringEmpty(data.message)) {
		updatedData = {
			id: data.meta_data.id,
			title: data.meta_data.name,
			dueDate: !IsStringEmpty(data.meta_data.due_date) ? parseDate(data.meta_data.due_date, false, true) : '-',
			dueTime: !IsStringEmpty(data.meta_data.due_date) ? parseTimeForDate(data.meta_data.due_date) : '-',
			submissionsReceived: {
				value: submissionsReceived.value,
				fraction: submissionsReceived.label
			},
			type: data.type
		}
	}
	return updatedData;
}

const ParsedPlannerData = (weeksData) => {

	let weeksList = [];

	if (!IsObjectEmpty(weeksData)) {
		for (let week in weeksData) {
			let updatedWeekData = [];
			if (!IsObjectEmpty(weeksData[week])) {
				for (let day in weeksData[week]) {
					const dayData = weeksData[week][day];

					const topicsList = !IsListEmpty(dayData.topics_list) ? dayData.topics_list.map(topic => {
						let updatedTopoic = {};
						if (topic.type === 'topic') {
							updatedTopoic = {
								id: topic.id,
								name: !IsStringEmpty(topic.name) ? topic.name : '-',
								type: topic.type,
								scheduledDate: !IsStringEmpty(topic.schedule_date) ? parseDate(topic.schedule_date, false, true) : '-'
							}
						} else if (topic.type === 'quiz' || topic.type === 'assignment') {
							updatedTopoic = {
								id: topic.id,
								name: !IsStringEmpty(topic.name) ? topic.name : '-',
								type: topic.type,
								scheduledDate: !IsStringEmpty(topic.schedule_date) ? parseDate(topic.schedule_date, false, true) : '-',
								grades: !IsStringEmpty(topic.grades) ? topic.grades : 0,
								dueDate: !IsStringEmpty(topic.due_date) ? parseDate(topic.due_date, false, true) : '-',
								dueTime: !IsStringEmpty(topic.due_date) ? parseTimeForDate(topic.due_date) : '-',
								submissionsReceived: !IsStringEmpty(topic.submissions) ? topic.submissions : 0,
								totalStudents: !IsStringEmpty(topic.total_students) ? topic.total_students : 0
							}
						}
						return updatedTopoic
					}) : [];

					updatedWeekData.push({
						date: parseDateForPlannerCard(day),
						fullDate: day,
						dayOff: dayData.day_off && IsListEmpty(topicsList),
						moduleStart: false, // ----->>>>>> Need to make a proper condition for this
						sessionNumber: 1,
						topicsList: topicsList
					});
					// console.log('Day => ', day, updatedWeekData);
				}
			}
			weeksList.push(updatedWeekData);
		}
	}
	// console.log('Updated Weeks List => ', weeksList);

	return weeksList;
}

const ParsedAllModulesPageData = (modulesList) => {

	const parsedList = !IsListEmpty(modulesList) ? modulesList.map((module) => {


		let assignmentData = { value: 0, label: "0/0" },
			liveSessionsData = { value: 0, label: "0/0" },
			quizData = { value: 0, label: "0/0" };


		if (!IsObjectEmpty(module.module_details)) {
			const data = module.module_details;
			assignmentData = calculateProgress(data.assignment_happened, data.assignment_scheduled);
			liveSessionsData = calculateProgress(data.live_sessions_happened, data.live_sessions_scheduled);
			quizData = calculateProgress(data.quiz_happened, data.quiz_scheduled);
		}

		return {
			startDate: !IsStringEmpty(module.start_date) ? parseDate(module.start_date, false, true) : '',
			moduleId: module.id,
			moduleLogo: module.thumbnail,
			moduleName: module.name,
			programBatchCode: module.batch_code,
			programId: module.program_id,
			stats: {
				assignments: [assignmentData.value, assignmentData.label],
				liveSessions: [liveSessionsData.value, liveSessionsData.label],
				progress: !IsStringEmpty(module.module_details.progress) ? module.module_details.progress : 0,
				quiz: [quizData.value, quizData.label],
			},
			type: module.module_details.status
		}
	}) : [];
	let updatedList = SortHelper.sortEnrolledModulesByMostRecent(parsedList)

	return updatedList;
}

const ParsedEvaluationCardsData = (cardsList, forPMPage) => {

	let parsedData = [];

	if (forPMPage === true) {

		let parsedCardsList = !IsListEmpty(cardsList) ? cardsList.map(cardItem => {
			const type = !IsStringEmpty(cardItem.type) ? cardItem.type : '-';
			return {
				id: cardItem.id,
				title: cardItem.name,
				dueDate: !IsStringEmpty(cardItem.due_date) ? parseDate(cardItem.due_date) + ', ' + parseTimeForDate(cardItem.due_date) : '',
				submissions: {
					pending: !IsStringEmpty(cardItem.submissions.pending) ? cardItem.submissions.pending : '0',
					turnedIn: type === 'quiz'
						? !IsStringEmpty(cardItem.submissions.total_submitted) ? cardItem.submissions.total_submitted : '0'
						: !IsStringEmpty(cardItem.submissions.turned_in) ? cardItem.submissions.turned_in : '0',
					late: !IsStringEmpty(cardItem.submissions.late_submission) ? cardItem.submissions.late_submission : '0',
				},
				grades: {
					passed: !IsStringEmpty(cardItem.grades_report.passed_students) ? cardItem.grades_report.passed_students : '-',
					failed: !IsStringEmpty(cardItem.grades_report.failed_students) ? cardItem.grades_report.failed_students : '-',
					score: !IsStringEmpty(cardItem.grades_report.class_average_percentage) ? cardItem.grades_report.class_average_percentage : '-',
				},
				status: !IsStringEmpty(cardItem.status) ? cardItem.status : '-',
				type: type
			}
		}) : [];

		let categories = { all: 0, completed: 0, pending: 0, ongoing: 0, upcoming: 0 };

		let parsedNavigationList = !IsListEmpty(cardsList) ? cardsList.map((cardItem, index) => {
			const type = !IsStringEmpty(cardItem.type) ? cardItem.type : '-';
			categories[cardItem.status] = categories[cardItem.status] + 1;
			return {
				id: index + 1,
				topicId: cardItem.id,
				label: cardItem.name,
				dueDate: !IsStringEmpty(cardItem.due_date) ? parseDate(cardItem.due_date) + ', ' + parseTimeForDate(cardItem.due_date) : '',
				status: !IsStringEmpty(cardItem.status) ? cardItem.status : '-',
				type: type
			}
		}) : [];

		parsedNavigationList.unshift({ id: 0, label: "Overview", topicId: 'overview', type: 'overview' });

		const parsedFilterCategories = [
			{ id: 0, label: `All (${parsedCardsList.length})`, type: 'all' },
			{ id: 1, label: `Completed (${categories.completed})`, type: 'completed' },
			{ id: 2, label: `Evaluation Pending (${categories.pending})`, type: 'pending' },
			{ id: 2, label: `Ongoing (${categories.ongoing})`, type: 'ongoing' },
			{ id: 2, label: `Upcoming (${categories.upcoming})`, type: 'upcoming' }
		];

		parsedData = {
			navigationList: parsedNavigationList,
			cardsList: parsedCardsList,
			filterCategories: parsedFilterCategories
		}

	} else {
		parsedData = !IsListEmpty(cardsList) ? cardsList.map(cardItem => {
			const type = !IsStringEmpty(cardItem.type) ? cardItem.type : '-';
			return {
				id: cardItem.id,
				title: cardItem.name,
				dueDate: !IsStringEmpty(cardItem.due_date) ? parseDate(cardItem.due_date) + ', ' + parseTimeForDate(cardItem.due_date) : '',
				submissions: {
					pending: !IsStringEmpty(cardItem.submissions.pending) ? cardItem.submissions.pending : '0',
					turnedIn: type === 'quiz'
						? !IsStringEmpty(cardItem.submissions.total_submitted) ? cardItem.submissions.total_submitted : '0'
						: !IsStringEmpty(cardItem.submissions.turned_in) ? cardItem.submissions.turned_in : '0',
					late: !IsStringEmpty(cardItem.submissions.late_submission) ? cardItem.submissions.late_submission : '0',
				},
				grades: {
					passed: !IsStringEmpty(cardItem.grades_report.passed_students) ? cardItem.grades_report.passed_students : '-',
					failed: !IsStringEmpty(cardItem.grades_report.failed_students) ? cardItem.grades_report.failed_students : '-',
					score: !IsStringEmpty(cardItem.grades_report.class_average_percentage) ? cardItem.grades_report.class_average_percentage : '-',
				},
				status: !IsStringEmpty(cardItem.status) ? cardItem.status : '-',
				type: type
			}
		}) : [];
	}

	return parsedData;
}

const ParsedQuizSubmissionMetadata = (data) => {
	let updatedObj = {
		id: data.id,
		title: !IsStringEmpty(data.name) ? data.name : '-',
		dueDate: !IsStringEmpty(data.due_date) ? parseDateWithWeekDay(data.due_date) : '',
		type: data.type,
		details: {
			problems: !IsStringEmpty(data.problems_count) ? data.problems_count : '-',
			totalScore: !IsStringEmpty(data.total_score) ? data.total_score : '-',
			passScore: !IsStringEmpty(data.passing_score) ? data.passing_score : '-'
		},
		submissions: {
			pending: !IsStringEmpty(data.submissions.pending) ? data.submissions.pending : '0',
			turnedIn: data.type === 'quiz'
				? !IsStringEmpty(data.submissions.total_submitted) ? data.submissions.total_submitted : '0'
				: !IsStringEmpty(data.submissions.turned_in) ? data.submissions.turned_in : '0',
			late: !IsStringEmpty(data.submissions.late_submission) ? data.submissions.late_submission : '0',
		},
		grades: {
			passed: !IsStringEmpty(data.grades_report.passed_students) ? data.grades_report.passed_students : '-',
			failed: !IsStringEmpty(data.grades_report.failed_students) ? data.grades_report.failed_students : '-',
			score: !IsStringEmpty(data.grades_report.class_average_percentage) ? data.grades_report.class_average_percentage : '-',
		},
		submissionsList: []
	}
	return updatedObj;
}
const ParsedQuizStudentSubmissionsList = (list, type) => {

	let updatedList = !IsListEmpty(list) ? list.map(item => {

		const action = item.status === 'submitted'
			? 'Evaluate'
			: (item.status === 'passed' || item.status === 'failed') ? 'Completed' : '-';

		return {
			studentName: !IsStringEmpty(item.user_details.name) ? toTitleCase(item.user_details.name) : '',
			studentId: !IsStringEmpty(item.user_details.id) ? item.user_details.id : '',
			status: item.status,
			submissionDateTime: !IsStringEmpty(item.submission_date) ? parseDate(item.submission_date) + ' - ' + parseTimeForDate(item.submission_date) : '-',
			grade: !IsStringEmpty(item.score) && item.status !== 'submitted' ? item.score : '-',
			action: type === 'quiz' ? 'View Submission' : action,
			isLate: item.is_late
		}
	}) : [];

	return updatedList;
}

const ParseAssignmentStudentSubmissionData = (data) => {

	const studentId = !IsListEmpty(data.problems_submitted) && !IsObjectEmpty(data.problems_submitted[0].user_details) ? data.problems_submitted[0].user_details.id : null,

		name = !IsListEmpty(data.problems_submitted) && !IsObjectEmpty(data.problems_submitted[0].user_details) ? toTitleCase(data.problems_submitted[0].user_details.name) : '-',

		profilePic = !IsListEmpty(data.problems_submitted) && !IsObjectEmpty(data.problems_submitted[0].user_details) ? data.problems_submitted[0].user_details.profile_pic : iconDefaultAvatar,

		status = !IsListEmpty(data.problems_submitted) && !IsObjectEmpty(data.problems_submitted[0]) ? data.problems_submitted[0].status : null,

		isLate = !IsListEmpty(data.problems_submitted) && !IsObjectEmpty(data.problems_submitted[0]) ? data.problems_submitted[0].is_late : null,

		submissionDate = !IsListEmpty(data.problems_submitted) && !IsObjectEmpty(data.problems_submitted[0]) ? data.problems_submitted[0].submission_date : '';


	const assignmentDetails = {
		id: data.assignment_id,
		name: !IsStringEmpty(data.assignment_name) ? data.assignment_name : '-',
		studentDetails: {
			id: studentId,
			name: toTitleCase(name),
			profilePic: !IsStringEmpty(profilePic) ? profilePic : iconDefaultAvatar,
			status: status,
			isLate: isLate,
			submissionDateTime: !IsStringEmpty(submissionDate) ? parseDate(submissionDate, false, true) + ' - ' + parseTimeForDate(submissionDate) : '-'
		}
	};

	let totalAllotedScore = 0, totalScore = 0;

	const problemsList = !IsListEmpty(data.problems_submitted) ? data.problems_submitted.map(problem => {
		totalScore = !IsStringEmpty(problem.total_points) ? (totalScore + problem.total_points) : totalScore;
		let gradingGuidesList = !IsListEmpty(problem.submissions) ? problem.submissions.map(submission => {
			totalAllotedScore = !IsStringEmpty(submission.score) ? (totalAllotedScore + submission.score) : totalAllotedScore;
			return {
				id: submission.grading_criteria_id,
				objective: submission.grading_criteria_name,
				totalMarks: submission.grading_criteria_total_points,
				marksAlloted: !IsStringEmpty(submission.score) ? submission.score : '',
				comments: !IsStringEmpty(submission.comments) ? submission.comments : '',
				errorMessage: '',
				scoreErrorMessage: '',
				valid: false
			}
		}) : [];

		let submittedLinksList = !IsListEmpty(problem.submission_links) ? problem.submission_links.map(link => {

			const trimmedLink = !IsStringEmpty(link) ? link.trim() : link;

			const updatedLink = !IsStringEmpty(trimmedLink)
				? trimmedLink.indexOf('http') !== 0 ? 'http://' + trimmedLink : trimmedLink : '';

			return updatedLink
		}) : [];

		return {
			id: problem.id,
			title: !IsStringEmpty(problem.name) ? problem.name : '-',
			submittedLinks: submittedLinksList,
			gradingGuidesList: gradingGuidesList
		}
	}) : [];

	const overallScoreData = {
		score: totalAllotedScore,
		totalScore: !IsStringEmpty(totalScore) ? totalScore : '-',
		status: status
	}


	let updatedData = {
		assignmentDetails: assignmentDetails,
		problemsList: problemsList,
		overallScoreData: overallScoreData
	};
	return updatedData;
}

const ParsedFeedbackData = (data) => {
	const overallRatingData = !IsObjectEmpty(data.feedback) ? calculateProgress(data.feedback.rating, 10, true) : {};
	const overallSessionRatingObject =
	{
		value: overallRatingData.value,
		fraction: overallRatingData.label,
		label: 'OVERALL SESSION RATING'
	}
	const subtopicsList = !IsObjectEmpty(data) && !IsObjectEmpty(data.feedback) && !IsListEmpty(data.feedback.subtopics) ? data.feedback.subtopics.map(subtopic => {

		const progressValue = calculateProgress(subtopic.responses, data.feedback.total_no_of_responses, false);

		return ({
			title: subtopic.name,
			progressValue: progressValue.value,
			progressLabel: progressValue.label
		});
	}) : [];

	const areasOfImprovementObject = data.feedback.areas_of_improvement;

	const areasOfImprovement = !IsObjectEmpty(data) && !IsObjectEmpty(data.feedback) && !IsObjectEmpty(data.feedback.areas_of_improvement) ? Object.keys(areasOfImprovementObject).map(item => {

		const responseData = calculateProgress(areasOfImprovementObject[item], data.feedback.total_no_of_responses, false);

		return ({
			title: item.toUpperCase().replaceAll('_', ' '),
			progressValue: responseData.value,
			progressLabel: responseData.label
		});
	}) : [];

	const overallSessionRating = {
		value: IsObjectEmpty(areasOfImprovement) ? !IsStringEmpty(data.feedback.rating) ? Math.round(data.feedback.rating) * 10 : '0' : !IsStringEmpty(data.feedback.rating) ? Math.round(data.feedback.rating) * 20 : '0',
		label: 'Overall Session Rating',
		fraction: IsListEmpty(areasOfImprovement)
			? [!IsStringEmpty(data.feedback.rating)
				? (data.feedback.rating / 2).toFixed(1) : 0, 5]
			: [!IsStringEmpty(data.feedback.rating)
				? data.feedback.rating.toFixed(1) : 0, 5]
	};

	const updatedData = {
		date: !IsObjectEmpty(data.live_session) && !IsStringEmpty(data.live_session.schedule_date) ? parseDate(data.live_session.schedule_date) : '',
		topicName: !IsObjectEmpty(data.live_session) && !IsStringEmpty(data.live_session.topic_name) ? data.live_session.topic_name : '',
		topicId: !IsObjectEmpty(data.feedback) && !IsStringEmpty(data.feedback.topic_id) ? data.feedback.topic_id : '',
		receivedResponsesCount: !IsObjectEmpty(data.feedback) ? !IsStringEmpty(data.feedback.total_no_of_responses) ? data.feedback.total_no_of_responses : 0 : 0,
		subtopics: subtopicsList,
		clearedDoubts: {
			value: !IsObjectEmpty(data.feedback) && !IsStringEmpty(data.feedback.percentage_doubts_solved) ? parseInt(data.feedback.percentage_doubts_solved, 10) : 0,
			label: 'CLEARED THEIR DOUBTS'
		},
		overallSessionRating: overallSessionRating,
		areasOfImprovement: areasOfImprovement,
		feedbackAvailable: !IsObjectEmpty(data.feedback) ? true : false
	};
	return updatedData;
}

const ParsedInstructorDailyTopicFeedbackReport = (data) => {

	const subtopicsList = !IsListEmpty(data.subtopics_understood) ? data.subtopics_understood.map(subtopic => {

		const responseData = calculateProgress(subtopic.responses, data.total_submissions, false);

		return {
			title: subtopic.name,
			progressValue: responseData.value,
			progressLabel: responseData.label
		}
	}) : [];

	const areasOfImprovementObject = data.areas_of_improvement;

	const areasOfImprovement = !IsObjectEmpty(areasOfImprovementObject) ? Object.keys(areasOfImprovementObject).map(item => {
		const responseData = calculateProgress(areasOfImprovementObject[item], data.total_submissions, false);

		return {
			title: item.toUpperCase().replaceAll('_', ' '),
			progressValue: responseData.value,
			progressLabel: responseData.label
		}
	}) : [];

	let chartData = [];

	if (!IsObjectEmpty(data.pie_chart_data) && !IsObjectEmpty(data.pie_chart_data.submission)) {
		const statsData = data.pie_chart_data.submission;
		chartData = [
			["Students", "Percentage"],
			["Completely Understood", !IsStringEmpty(statsData.completely_understood) ? statsData.completely_understood : 0],
			["Partially Understood", !IsStringEmpty(statsData.partially_understood) ? statsData.partially_understood : 0],
			["Did Not Understand", !IsStringEmpty(statsData.not_understood_at_all) ? statsData.not_understood_at_all : 0],
		];
	}

	const feedbackResponses = {
		feedbackAvailable: true,
		subtopics: !IsListEmpty(areasOfImprovement) ? areasOfImprovement : subtopicsList
	};
	const clearedDoubts = {
		value: !IsStringEmpty(data.doubts_cleared) ? parseInt(data.doubts_cleared, 10) : '0',
		label: 'Doubt Cleared'
	};
	const overallSessionRating = {
		value: IsListEmpty(areasOfImprovement) ? !IsStringEmpty(data.overall_rating) ? Math.round(data.overall_rating) * 10 : '0' : !IsStringEmpty(data.overall_rating) ? Math.round(data.overall_rating) * 20 : '0',
		label: 'Overall Session Rating',
		fraction: IsListEmpty(areasOfImprovement)
			? [!IsStringEmpty(data.overall_rating)
				? (data.overall_rating / 2).toFixed(1) : 0, 5]
			: [!IsStringEmpty(data.overall_rating)
				? data.overall_rating.toFixed(1) : 0, 5]
	};
	const pieChartData = chartData;
	const startDate = data.pie_chart_data.schedule_date;

	const currentTopicDetails = {
		topicName: !IsStringEmpty(data.pie_chart_data.name) ? data.pie_chart_data.name : '-',
		date: !IsStringEmpty(data.pie_chart_data.schedule_date) ? parseDateWithWeekDay(data.pie_chart_data.schedule_date) : '',
		responsesReceived: !IsStringEmpty(data.total_submissions) ? data.total_submissions : 0,
		feedbackType: !IsListEmpty(areasOfImprovement) ? 'new daily' : 'daily'
	};

	const updatedData = {
		feedbackResponses: feedbackResponses,
		clearedDoubts: clearedDoubts,
		overallSessionRating: overallSessionRating,
		pieChartData: pieChartData,
		currentTopicDetails: currentTopicDetails,
		areasOfImprovement: areasOfImprovement,
		startDate: startDate
	}

	return updatedData;
}

const ParsedInstructorDailyFeedbackReportData = (data) => {

	let startDate = '', endDate = '';
	let topicsList = !IsListEmpty(data.topics) ? data.topics.map((topic, index) => {
		if (index === 0) {
			startDate = parseDate(topic.schedule_date, false, true);
		} else if (index === (data.topics.length - 1)) {
			endDate = parseDate(topic.schedule_date, false, true);
		}

		let feedbackType = "", pos = -1;
		if (!IsListEmpty(topic.feedback_type)) {
			topic.feedback_type.forEach((type, index) => {
				pos = type === 'new daily' ? index : type === 'daily' ? index : -1;
			});
			feedbackType = pos > -1 ? topic.feedback_type[pos] : "";
		}
		return {
			id: topic.id,
			topicName: feedbackType === "new daily" ? 'N - ' + topic.name : topic.name,
			date: !IsStringEmpty(topic.schedule_date) ? parseDate(topic.schedule_date, false, true) : '',
			type: feedbackType
		}
	}) : [];



	let feedbacksList = !IsListEmpty(data.feedbacks) ? data.feedbacks.map(feedback => {
		const totalSubmissions = !IsStringEmpty(feedback.submission.total_submissions) ? feedback.submission.total_submissions : 0;

		const understoodPercentage = !IsObjectEmpty(feedback) && !IsObjectEmpty(feedback.submission) ? calcPercentage(feedback.submission.completely_understood, totalSubmissions) : 0;
		const notUnderstoodPercentage = !IsObjectEmpty(feedback) && !IsObjectEmpty(feedback.submission) ? calcPercentage(feedback.submission.not_understood_at_all, totalSubmissions) : 0;
		const partiallyUnderstoodPercentage = !IsObjectEmpty(feedback) && !IsObjectEmpty(feedback.submission) ? calcPercentage(feedback.submission.partially_understood, totalSubmissions) : 0;

		return {
			id: feedback.id,
			topicName: feedback.name,
			scheduledDateTime: !IsStringEmpty(feedback.schedule_date) ? parseDate(feedback.schedule_date, false, true) + ', ' + parseTimeForDate(feedback.schedule_date) : '-',
			submission: {
				completelyUnderstood:
					!IsStringEmpty(feedback.submission.completely_understood)
						? {
							percentage: Math.floor(understoodPercentage),
							value: feedback.submission.completely_understood
						} : { percentage: 0, value: 0 },

				notUnderstood:
					!IsStringEmpty(feedback.submission.not_understood_at_all)
						? {
							percentage: Math.floor(notUnderstoodPercentage),
							value: feedback.submission.not_understood_at_all
						} : { percentage: 0, value: 0 },

				partiallyUnderstood:
					!IsStringEmpty(feedback.submission.partially_understood)
						? {
							percentage: Math.floor(partiallyUnderstoodPercentage),
							value: feedback.submission.partially_understood
						} : { percentage: 0, value: 0 },

				totalSubmissions: totalSubmissions,
			}
		}
	}) : [];

	return {
		topicsList: topicsList,
		feedbacksList: feedbacksList
	};
}

const weeklyOrOverallReportCardData = (data, duration, end_date, start_date) => {
	const areasOfImprovementCW = !IsObjectEmpty(data) && !IsObjectEmpty(data.five_fields_data) ? Object.keys(data.five_fields_data).map(item => {
		const responseData = calculateProgress(data.five_fields_data[item], data.rating_boring_engaging.total_submissions, false);
		return {
			title: item.toUpperCase().replaceAll('_', ' '),
			progressValue: responseData.value,
			progressLabel: responseData.label
		}
	}) : [];

	const feedbackResponsesCW = {
		feedbackAvailable: true,
		subtopics: !IsListEmpty(areasOfImprovementCW) ? areasOfImprovementCW : []
	};

	let chartDataCW = [];

	let boringEngagingDataCW = data.rating_boring_engaging;

	if (!IsObjectEmpty(data) && !IsObjectEmpty(boringEngagingDataCW)) {
		const statsData = boringEngagingDataCW;
		chartDataCW = [
			["Students", "Percentage"],
			["Completely Understood", !IsStringEmpty(statsData.engaging_count) ? statsData.engaging_count : 0],
			["Partially Understood", !IsStringEmpty(statsData.boring_count) ? statsData.boring_count : 0],
			["Did Not Understand", 0],
		];
	}

	const overallSessionRatingCW = {
		value: !IsObjectEmpty(boringEngagingDataCW) && !IsStringEmpty(boringEngagingDataCW.rating)
			? boringEngagingDataCW.rating : '0',
		label: 'Overall Session Rating',
		fraction: !IsObjectEmpty(boringEngagingDataCW)
			? [!IsStringEmpty(boringEngagingDataCW.rating)
				? boringEngagingDataCW.rating > 5 ? (boringEngagingDataCW.rating / 2).toFixed(1) : boringEngagingDataCW.rating.toFixed(1) : 0, 5] : [0, 5]
	};

	let startDate = !IsStringEmpty(start_date) ? start_date : data.week_start_date,
		endDate = !IsStringEmpty(end_date) ? end_date : data.week_end_date;

	if (duration === 'current_month') {
		var date = new Date();
		startDate = parseDateWithMonthOnly(new Date(date.getFullYear(), date.getMonth(), 1)) + ' ' + date.getFullYear();
		endDate = parseDateWithMonthOnly(new Date(date.getFullYear(), date.getMonth() + 1, 0)) + ' ' + date.getFullYear();
	} else if (duration === 'last_month') {
		var date = new Date();
		startDate = parseDateWithMonthOnly(new Date(date.getFullYear(), date.getMonth() - 1, 1)) + ' ' + date.getFullYear();
		endDate = parseDateWithMonthOnly(new Date(date.getFullYear(), date.getMonth(), 0)) + ' ' + date.getFullYear();
	}

	const currentTopicDetailsCW = !IsObjectEmpty(data) && !IsObjectEmpty(boringEngagingDataCW) ? {
		topicName: !IsStringEmpty(duration) ? toTitleCase(duration.replaceAll('_', ' ')) : 'Current Week Report',
		date: startDate + ' - ' + endDate,
		responsesReceived: !IsObjectEmpty(boringEngagingDataCW) && !IsStringEmpty(boringEngagingDataCW.total_submissions)
			? boringEngagingDataCW.total_submissions : 0
	} : {};

	return ({
		feedbackResponsesCW,
		overallSessionRatingCW,
		chartDataCW,
		currentTopicDetailsCW
	})
}

const sevenDaysTrendsData = (data) => {
	let last7DaysRatings = { data: [], labels: [] },
		last7DaysSessionEngagement = {
			data: { engagingValues: [], boringValues: [] }, labels: []
		}

	if (!IsListEmpty(data)) {
		data.forEach(day => {
			last7DaysRatings.data.push(day.rating > 5 ? day.rating / 2 : day.rating);
			last7DaysRatings.labels.push(parseDateWithMonthOnly(day.schedule_date));

			last7DaysSessionEngagement.data.engagingValues.push(day.engaging_percentage);
			last7DaysSessionEngagement.data.boringValues.push(day.boring_percentage);
			last7DaysSessionEngagement.labels.push(parseDateWithMonthOnly(day.schedule_date));
		});
	} else {
		last7DaysRatings = {};
		last7DaysSessionEngagement = {};
	}

	return ({ last7DaysRatings, last7DaysSessionEngagement })
}

const weeklyTrendsData = (data) => {
	let weeklyRatings = { data: [], labels: [] }, weeklySessionEngagement = {
		data: { engagingValues: [], boringValues: [] }, labels: []
	}

	if (!IsListEmpty(data)) {
		data.forEach(week => {

			const weekDuration = !IsStringEmpty(week.week_range) ? week.week_range.split(' - ') : week.week_range;

			const weekRange1 = weekDuration[0].split(' ').splice(0, 2).join(' ') + '-' + weekDuration[1].split(' ').splice(0, 2).join(' ')

			weeklyRatings.data.push(week.rating > 5 ? week.rating / 2 : week.rating);
			weeklyRatings.labels.push(weekRange1);

			weeklySessionEngagement.data.engagingValues.push(week.engaging_percentage);
			weeklySessionEngagement.data.boringValues.push(week.boring_percentage);
			weeklySessionEngagement.labels.push(weekRange1);
		});
	} else {
		weeklyRatings = {};
		weeklySessionEngagement = {};
	}
	return ({ weeklyRatings, weeklySessionEngagement });
}
const ParsedInstructorDailyFeedbackReportDataOnPageLoadNew = (data) => {
	const mappedData = {
		avgReportCardData: data.average_report_card_data,
		fiveFieldsData: data.average_report_card_data.five_fields_data,
		boringEngaging: data.average_report_card_data.rating_boring_engaging,
		allTopicsList: data.all_topics_list
	}
	return mappedData;
}
const ParsedInstructorDailyFeedbackReportDataOnPageLoad = (data) => {

	let startDate = '', endDate = '',
		lastSessionObj = !IsObjectEmpty(data.last_session_card_data) ? data.last_session_card_data : {},
		lastSessionCardData = !IsObjectEmpty(data.last_session_card_data) ? data.last_session_card_data.last_session_data : {};

	let topicsList = !IsListEmpty(data.all_topics_list) ? data.all_topics_list.map((topic, index) => {
		if (index === 0) {
			startDate = parseDate(topic.schedule_date, false, true);
		} else if (index === (data.all_topics_list.length - 1)) {
			endDate = parseDate(topic.schedule_date, false, true);
		}

		let feedbackType = "", pos = -1;
		if (!IsListEmpty(topic.feedback_type)) {
			topic.feedback_type.forEach((type, index) => {
				pos = type === 'new daily' ? index : type === 'daily' ? index : -1;
			});
			feedbackType = pos > -1 ? topic.feedback_type[pos] : "";
		}
		return {
			id: topic.id,
			topicName: topic.name,
			date: !IsStringEmpty(topic.schedule_date) ? parseDate(topic.schedule_date, false, true) : '',
			type: feedbackType,
			startedBy: topic.started_by
		}
	}) : [];

	// Condition for filtering the sessions based on started by on frontend
	// let instructorUsername = GetFromLocalStorage(Constants.KEY_USERNAME);
	// let topicsList = topicsListAll.filter(topic => topic.startedBy === instructorUsername);

	let chartData = [];

	if (!IsObjectEmpty(lastSessionCardData.pie_chart_data) && !IsObjectEmpty(lastSessionCardData.pie_chart_data.submission)) {
		const statsData = lastSessionCardData.pie_chart_data.submission;
		chartData = [
			["Students", "Percentage"],
			["Completely Understood", !IsStringEmpty(statsData.completely_understood) ? statsData.completely_understood : 0],
			["Partially Understood", !IsStringEmpty(statsData.partially_understood) ? statsData.partially_understood : 0],
			["Did Not Understand", !IsStringEmpty(statsData.not_understood_at_all) ? statsData.not_understood_at_all : 0],
		];
	}

	let feedbackType = "", pos = -1;
	if (!IsObjectEmpty(lastSessionObj) && !IsListEmpty(lastSessionObj.feedback_type)) {
		lastSessionObj.feedback_type.forEach((type, index) => {
			pos = (type === 'new daily') ? index
				: (type === 'daily') ? index : -1;
		});
		feedbackType = (pos > -1) ? lastSessionObj.feedback_type[pos] : "";
	}

	const currentTopicDetails = !IsObjectEmpty(lastSessionCardData) && !IsObjectEmpty(lastSessionCardData.pie_chart_data) ? {
		id: !IsStringEmpty(lastSessionCardData.pie_chart_data.id)
			? lastSessionCardData.pie_chart_data.id : '-',
		topicName: !IsStringEmpty(lastSessionCardData.pie_chart_data.name)
			? lastSessionCardData.pie_chart_data.name : '-',
		date: !IsStringEmpty(lastSessionCardData.pie_chart_data.schedule_date)
			? parseDateWithWeekDay(lastSessionCardData.pie_chart_data.schedule_date) : '',
		responsesReceived: !IsStringEmpty(lastSessionCardData.total_submissions)
			? lastSessionCardData.total_submissions : 0,
		feedbackType: feedbackType
	} : {};



	const subtopicsList = !IsListEmpty(lastSessionCardData.subtopics_understood) ? lastSessionCardData.subtopics_understood.map(subtopic => {

		const responseData = calculateProgress(subtopic.responses, data.total_submissions, false);

		return {
			title: subtopic.name,
			progressValue: responseData.value,
			progressLabel: responseData.label
		}
	}) : [];

	const areasOfImprovementObject = lastSessionCardData.areas_of_improvement;

	const areasOfImprovement = !IsObjectEmpty(areasOfImprovementObject) ? Object.keys(areasOfImprovementObject).map(item => {
		const responseData = calculateProgress(areasOfImprovementObject[item], lastSessionCardData.total_submissions, false);

		return {
			title: item.toUpperCase().replaceAll('_', ' '),
			progressValue: responseData.value,
			progressLabel: responseData.label
		}
	}) : [];

	const feedbackResponses = {
		feedbackAvailable: true,
		subtopics: !IsListEmpty(areasOfImprovement) ? areasOfImprovement : subtopicsList
	};

	const overallSessionRating = {
		value: IsListEmpty(areasOfImprovement)
			? !IsStringEmpty(lastSessionCardData.overall_rating)
				? Math.round(lastSessionCardData.overall_rating) : '0'
			: !IsStringEmpty(lastSessionCardData.overall_rating)
				? Math.round(lastSessionCardData.overall_rating) : '0',
		label: 'Overall Session Rating',
		fraction: IsListEmpty(areasOfImprovement)
			? [!IsStringEmpty(lastSessionCardData.overall_rating)
				? (lastSessionCardData.overall_rating / 2).toFixed(1) : 0, 5]
			: [!IsStringEmpty(lastSessionCardData.overall_rating)
				? lastSessionCardData.overall_rating.toFixed(1) : 0, 5]
	};

	// -------------------------- Current Week Data --------------------------
	let currentWeekReportCardData = data.current_week_report_card_data;

	let weeklyReportCardData = weeklyOrOverallReportCardData(currentWeekReportCardData);
	let newPieChartData = data.current_week_report_card_data.five_fields_data
	let newPieChartData2 = data.current_week_report_card_data.rating_boring_engaging


	// ---------- Last 7 Days Trend data ----------
	const last7DaysTrendData = data.last_seven_days_trends;

	let last7DaysData = sevenDaysTrendsData(last7DaysTrendData);

	// ---------- Weekly Trend data ----------
	const weeklyTrendData = data.weekly_trends_data;

	let weeklyData = weeklyTrendsData(weeklyTrendData);


	let overallData = {
		feedbackResponses: weeklyReportCardData.feedbackResponsesCW,
		pieChartData: weeklyReportCardData.chartDataCW,
		overallSessionRating: weeklyReportCardData.overallSessionRatingCW,
		currentTopicDetails: weeklyReportCardData.currentTopicDetailsCW,

		last7DaysRatings: last7DaysData.last7DaysRatings,
		last7DaysSessionEngagement: last7DaysData.last7DaysSessionEngagement,

		weeklyRatings: weeklyData.weeklyRatings,
		weeklySessionEngagement: weeklyData.weeklySessionEngagement,
		newPieChartData: newPieChartData,
		newPieChartData2: newPieChartData2
	};

	return {
		topicsList: topicsList,
		feedbacksList: [],

		// ----- Last Session Data ----- 
		feedbackResponses: feedbackResponses,
		feedbackType: feedbackType,
		pieChartData: chartData,
		overallSessionRating: overallSessionRating,
		currentTopicDetails: currentTopicDetails,
		newPieChartData: newPieChartData,
		newPieChartData2: newPieChartData2,

		// ----- Current Week Data ----- 
		currentWeekData: overallData,

		// ------ flags ------
		isLastSessionDataEmpty: IsObjectEmpty(data.last_session_card_data),
		isDailyDataEmpty: IsListEmpty(data.last_seven_days_trends),
		isWeeklyDataEmpty: IsListEmpty(data.weekly_trends_data),
	};
}
const ParsedInstructorDailyFeedbackReportDataOverallNew = (data) => {
	const mappedData = {
		avgReportCardData: data.average_report_card_data,
		fiveFieldsData: data.average_report_card_data.five_fields_data,
		boringEngaging: data.average_report_card_data.rating_boring_engaging,
		attendance: data.average_report_card_data.attendance,
	}
	return mappedData;
}
const ParsedInstructorDailyFeedbackReportDataOverall = (data, duration) => {

	let weeklyReportCardData = {}, last7DaysData = {}, weeklyData = {}, dailyTrendEmpty = true, weeklyTrendEmpty = true;

	if (duration === 'overall') {
		const currentWeekReportCardData = data.module_average_report_card_data;
		weeklyReportCardData = weeklyOrOverallReportCardData(currentWeekReportCardData, duration);

		const last7DaysTrendData = data.overall_module_daily_trends_data;
		last7DaysData = sevenDaysTrendsData(last7DaysTrendData);
		dailyTrendEmpty = IsListEmpty(last7DaysTrendData);

		const weeklyTrendData = data.overall_module_weekly_trends_data;
		weeklyData = weeklyTrendsData(weeklyTrendData);
		weeklyTrendEmpty = IsListEmpty(weeklyTrendData);
	} else {
		const currentWeekReportCardData = data.current_week_average_report_card_data;
		weeklyReportCardData = weeklyOrOverallReportCardData(currentWeekReportCardData);

		const last7DaysTrendData = data.current_week_trends_data;
		last7DaysData = sevenDaysTrendsData(last7DaysTrendData);

		const weeklyTrendData = [];
		weeklyData = weeklyTrendsData(weeklyTrendData);
	}


	let overallData = {
		feedbackResponses: weeklyReportCardData.feedbackResponsesCW,
		pieChartData: weeklyReportCardData.chartDataCW,
		overallSessionRating: weeklyReportCardData.overallSessionRatingCW,
		currentTopicDetails: weeklyReportCardData.currentTopicDetailsCW,

		last7DaysRatings: last7DaysData.last7DaysRatings,
		last7DaysSessionEngagement: last7DaysData.last7DaysSessionEngagement,

		weeklyRatings: weeklyData.weeklyRatings,
		weeklySessionEngagement: weeklyData.weeklySessionEngagement,


		// ------ flags ------
		isDailyDataEmpty: dailyTrendEmpty,
		isWeeklyDataEmpty: weeklyTrendEmpty,
	};
	return {
		currentWeekData: overallData
	};
}

const parsedLastSessionDailyFeedbackData = (data) => {

	const lastSessionCardData = !IsObjectEmpty(data.last_session_report) ? data.last_session_report : {};
	let chartData = [];

	if (!IsObjectEmpty(lastSessionCardData.pie_chart_data) && !IsObjectEmpty(lastSessionCardData.pie_chart_data.submission)) {
		const statsData = lastSessionCardData.pie_chart_data.submission;
		chartData = [
			["Students", "Percentage"],
			["Completely Understood", !IsStringEmpty(statsData.completely_understood) ? statsData.completely_understood : 0],
			["Partially Understood", !IsStringEmpty(statsData.partially_understood) ? statsData.partially_understood : 0],
			["Did Not Understand", !IsStringEmpty(statsData.not_understood_at_all) ? statsData.not_understood_at_all : 0],
		];
	}

	let feedbackType = !IsStringEmpty(data.feedback_type) ? "new daily" : "daily";

	const currentTopicDetails = !IsObjectEmpty(lastSessionCardData) && !IsObjectEmpty(lastSessionCardData.pie_chart_data) ? {
		topicName: !IsStringEmpty(lastSessionCardData.pie_chart_data.name)
			? lastSessionCardData.pie_chart_data.name : '-',
		date: !IsStringEmpty(lastSessionCardData.pie_chart_data.schedule_date)
			? parseDateWithWeekDay(lastSessionCardData.pie_chart_data.schedule_date) : '',
		responsesReceived: !IsStringEmpty(lastSessionCardData.total_submissions)
			? lastSessionCardData.total_submissions : 0,
		feedbackType: feedbackType
	} : {};



	const subtopicsList = !IsListEmpty(lastSessionCardData.subtopics_understood) ? lastSessionCardData.subtopics_understood.map(subtopic => {

		const responseData = calculateProgress(subtopic.responses, data.total_submissions, false);

		return {
			title: subtopic.name,
			progressValue: responseData.value,
			progressLabel: responseData.label
		}
	}) : [];

	const areasOfImprovementObject = lastSessionCardData.areas_of_improvement;

	const areasOfImprovement = !IsObjectEmpty(areasOfImprovementObject) ? Object.keys(areasOfImprovementObject).map(item => {
		const responseData = calculateProgress(areasOfImprovementObject[item], lastSessionCardData.total_submissions, false);

		return {
			title: item.toUpperCase().replaceAll('_', ' '),
			progressValue: responseData.value,
			progressLabel: responseData.label
		}
	}) : [];

	const feedbackResponses = {
		feedbackAvailable: true,
		subtopics: !IsListEmpty(areasOfImprovement) ? areasOfImprovement : subtopicsList
	};

	const overallSessionRating = {
		value: IsListEmpty(areasOfImprovement)
			? !IsStringEmpty(lastSessionCardData.overall_rating)
				? Math.round(lastSessionCardData.overall_rating) : '0'
			: !IsStringEmpty(lastSessionCardData.overall_rating)
				? Math.round(lastSessionCardData.overall_rating) : '0',
		label: 'Overall Session Rating',
		fraction: IsListEmpty(areasOfImprovement)
			? [!IsStringEmpty(lastSessionCardData.overall_rating)
				? (lastSessionCardData.overall_rating / 2).toFixed(1) : 0, 5]
			: [!IsStringEmpty(lastSessionCardData.overall_rating)
				? lastSessionCardData.overall_rating.toFixed(1) : 0, 5]
	};

	return {
		feedbackResponses: feedbackResponses,
		feedbackType: feedbackType,
		pieChartData: chartData,
		overallSessionRating: overallSessionRating,
		currentTopicDetails: currentTopicDetails,
	}
}

const parsedWeekAndMonthFeedbackData = (data, duration) => {
	// -------------------------- Current Week Data --------------------------
	let currentWeekReportCardData = data.average_report_card_data;
	let weeklyReportCardData = weeklyOrOverallReportCardData(currentWeekReportCardData, duration, data.week_end_date, data.week_start_date);

	// ---------- 7 Days Trend data ----------
	const last7DaysTrendData = data.daily_trends_data;
	let last7DaysData = sevenDaysTrendsData(last7DaysTrendData);

	// ---------- Weekly Trend data ----------
	const weeklyTrendData = data.weekly_trends_data;
	let weeklyData = weeklyTrendsData(weeklyTrendData);

	return {
		feedbackResponses: weeklyReportCardData.feedbackResponsesCW,
		pieChartData: weeklyReportCardData.chartDataCW,
		overallSessionRating: weeklyReportCardData.overallSessionRatingCW,
		currentTopicDetails: weeklyReportCardData.currentTopicDetailsCW,

		last7DaysRatings: last7DaysData.last7DaysRatings,
		last7DaysSessionEngagement: last7DaysData.last7DaysSessionEngagement,

		weeklyRatings: weeklyData.weeklyRatings,
		weeklySessionEngagement: weeklyData.weeklySessionEngagement
	}
}

const parsedOverallFeedbackData = (data) => {
	// ---------- Weekly Trend data ----------
	const weeklyTrendData = data.weekly_trends_data;
	let weeklyData = weeklyTrendsData(weeklyTrendData);

	// ---------- Weekly Trend data ----------
	const monthlyTrendData = data.monthly_trends_data;
	let monthlyData = weeklyTrendsData(monthlyTrendData);

	return {
		weeklyRatings: weeklyData.weeklyRatings,
		weeklySessionEngagement: weeklyData.weeklySessionEngagement,
		monthlyRatings: monthlyData.weeklyRatings,
		monthlySessionEngagement: monthlyData.weeklySessionEngagement
	}

}

const ParsedInstructorDailyFeedbackReportPM = (data, duration) => {

	let resonseData = !IsObjectEmpty(data) ? data : {}, responseObj = {};

	if (duration === 'last_session') {
		responseObj = parsedLastSessionDailyFeedbackData(resonseData, duration);
	} else if (duration === 'current_week' || duration === 'last_week') {
		responseObj = parsedWeekAndMonthFeedbackData(resonseData, duration);
	} else if (duration === 'current_month' || duration === 'last_month') {
		responseObj = parsedWeekAndMonthFeedbackData(resonseData, duration);
	} else if (duration === 'overall') {
		responseObj = parsedOverallFeedbackData(resonseData);
	}

	return {
		feedbackResponses: responseObj.feedbackResponses,
		feedbackType: responseObj.feedbackType,
		pieChartData: responseObj.pieChartData,
		overallSessionRating: responseObj.overallSessionRating,
		currentTopicDetails: responseObj.currentTopicDetails,

		last7DaysRatings: responseObj.last7DaysRatings,
		last7DaysSessionEngagement: responseObj.last7DaysSessionEngagement,

		weeklyRatings: responseObj.weeklyRatings,
		weeklySessionEngagement: responseObj.weeklySessionEngagement,

		monthlyRatings: responseObj.monthlyRatings,
		monthlySessionEngagement: responseObj.monthlySessionEngagement
	};
}

const ParsedLiveSessionData = (liveSessionData) => {

	if (!IsObjectEmpty(liveSessionData)) {
		return {
			liveSessionId: liveSessionData.id,
			date: !IsStringEmpty(liveSessionData.schedule_date) ? parseDate(liveSessionData.schedule_date) : '',
			name: !IsStringEmpty(liveSessionData.topic_name) ? liveSessionData.topic_name : '',
			scheduleDate: !IsStringEmpty(liveSessionData.schedule_date) ? parseDate(liveSessionData.schedule_date) : '',
			scheduleTime: !IsStringEmpty(liveSessionData.schedule_date) ? parseTimeForDate(liveSessionData.schedule_date) : '',
			started: !IsStringEmpty(liveSessionData.status) && liveSessionData.status === 'started' ? true : false,

			signature: !IsStringEmpty(liveSessionData.signature) ? liveSessionData.signature : '',
			status: !IsStringEmpty(liveSessionData.status) ? liveSessionData.status : '',
			sessionEnded: !IsStringEmpty(liveSessionData.status) ? liveSessionData.status === 'ended' ? true : false : false,

			apiKey: liveSessionData.api_key,
			sdkKey: liveSessionData.api_key,
			meetingNumber: liveSessionData.meet_id,
			passWord: liveSessionData.password,
			encPassword: liveSessionData.enc_password,
			signature: liveSessionData.signature,
			topicId: liveSessionData.topic,
			moduleName: liveSessionData.module_name,
			batchCode: liveSessionData.batch_code,
		}
	}
	else {
		return {};
	}
}

const ParsedDailyFeedbackStudentsList = (list) => {

	const updatedList = !IsListEmpty(list) ? list.map(listItem => {
		return {
			userId: listItem.user_details.id,
			name: toTitleCase(listItem.user_details.name),
			submissionTime: !IsStringEmpty(listItem.submission_date) ? parseDate(listItem.submission_date, false, true) + ' - ' + parseTimeForDate(listItem.submission_date) : '-'
		}
	}) : [];

	return updatedList;
}

const ParsedInstructorWeeklyFeedbackReportData = (data) => {


	let weeksList = [];
	if (!IsObjectEmpty(data.weeks)) {
		for (var weekId in data.weeks) {
			const weekData = data.weeks[weekId];
			weeksList.push({
				feedbackId: weekData.id,
				weekName: !IsStringEmpty(weekData.week_name) ? weekData.week_name.split(' | ')[0] : '',
				weekDate: !IsStringEmpty(weekData.week_name) ? weekData.week_name.split(' | ')[1] : '',
				name: weekData.week_name
			});
		}
	}

	const submissionsList = !IsListEmpty(data.submissions) ? data.submissions.map(submission => {
		return {
			userId: submission.user_details.id,
			name: toTitleCase(submission.user_details.name),
			submissionTime: !IsStringEmpty(submission.submission_date) ? parseDate(submission.submission_date, false, true) + ' - ' + parseTimeForDate(submission.submission_date) : '-',
			rating: !IsStringEmpty(submission.submitted) ? submission.submitted : 0,
		}
	}) : [];


	const updatedData = {
		weeksList: !IsListEmpty(weeksList) ? SortHelper.sortStudentsByName(weeksList, 'ascending') : [],
		submissionsList: submissionsList
	}

	return updatedData;

}

const parsedPerformersList = (list) => {
	const updatedList = !IsListEmpty(list) ? list.map(student => {
		return {
			name: toTitleCase(student.name),
			grade: !IsStringEmpty(student.overall_grades) ? Math.floor(student.overall_grades) : 0,
			profilePic: !IsStringEmpty(student.profilepicture_url) ? student.profilepicture_url : iconDefaultAvatar
		};
	}) : [];
	return updatedList;
}

const ParsedInstructorOverallReportData = (data) => {

	const weekStart = !IsStringEmpty(data.last_week_monday) ? parseDate(data.last_week_monday) : '',
		weekEnd = !IsStringEmpty(data.last_sunday) ? parseDate(data.last_sunday) : '';

	const updatedData = {
		overallReportData: {
			myRating: !IsStringEmpty(data.my_rating) ? parseInt(data.my_rating) : 0,
			activeStudents: calculateProgress(data.active_students, data.total_students, true),
			classGrade: !IsStringEmpty(data.class_avg_grades) ? Math.floor(data.class_avg_grades) : 0,
			previousWeekDate: weekStart + ' - ' + weekEnd
		},
		highPerformers: parsedPerformersList(data.high_performance),
		lowPerformers: parsedPerformersList(data.low_performance)
	};

	return updatedData;
}


const returnNumber = (value) => {
	return !IsStringEmpty(value) ? value : 0;
}

const ParsedInstructorAttendanceReportData = (data) => {

	let updatedWeekArray = [], daysMissed = 0;
	if (!IsObjectEmpty(data.table_data) && !IsObjectEmpty(data.table_data.weeks)) {
		const weeksData = data.table_data.weeks;
		for (var item in weeksData) {
			let week = weeksData[item];

			let totalSessions = !IsStringEmpty(week.total_sessions) ? week.total_sessions : 0,
				sessionsHappened = !IsStringEmpty(week.sessions_happened) ? week.sessions_happened : 0,
				sessionsMissed = totalSessions - sessionsHappened;

			daysMissed = daysMissed + sessionsMissed;

			let weekDates = !IsStringEmpty(week.week_dates) ? parseDate(week.week_dates.split(' - ')[0], false, true) + " - " + parseDate(week.week_dates.split(' - ')[1], false, true) : '-';

			updatedWeekArray.push({
				weekName: week.week_name,
				weekDates: weekDates,

				number: 1,
				from: "1 FEB 2021",
				to: "6 FEB 2021",

				Mo: returnNumber(week.session_days.monday),
				Tu: returnNumber(week.session_days.tuesday),
				We: returnNumber(week.session_days.monday),
				Th: returnNumber(week.session_days.wednesday),
				Fr: returnNumber(week.session_days.friday),
				Sa: returnNumber(week.session_days.saturday),
				Su: returnNumber(week.session_days.sunday),

				count: sessionsHappened + '/' + totalSessions,
				total: totalSessions,
				missed: sessionsMissed,
			});
		}
	}
	const updatedData = {
		reportData: {
			sessionsConducted: calculateProgress(data.conducted_sessions, data.scheduled_sessions, true),
			totalSessionsScheduled: calculateProgress(data.scheduled_sessions, data.total_sessions, true),
			totalSessions: !IsStringEmpty(data.total_sessions) ? data.total_sessions : 0,
			daysMissed: daysMissed,
			instructorProfilePic: !IsStringEmpty(data.instructor_profilepicture_url) ? data.instructor_profilepicture_url : iconDefaultAvatar,
			moduleLogo: !IsStringEmpty(data.module_logo) ? data.module_logo : '',
			instructorName: !IsStringEmpty(data.instructor_full_name) ? data.instructor_full_name : '',
		},
		week: updatedWeekArray
	}

	return updatedData;
}

const ParsedInstructorClassGradesReportData = (data) => {
	const gradesList = [];

	if (!IsObjectEmpty(data.submissions)) {
		for (var id in data.submissions) {

			const parsedGradesList = !IsObjectEmpty(data.submissions[id]) && !IsListEmpty(data.submissions[id].assignmentQuizGradesList)
				? data.submissions[id].assignmentQuizGradesList.map(item => {
					return {
						percentage: item.percentage.toFixed(1),
						status: item.status
					}
				}) : [];

			gradesList.push({
				name: toTitleCase(data.submissions[id].name),
				profilePic: !IsListEmpty(data.submissions[id].profilepicture_url) ? data.submissions[id].profilepicture_url : iconDefaultAvatar,
				overallGrade: !IsStringEmpty(data.submissions[id].overall_grades) ? data.submissions[id].overall_grades : 0,
				grades: parsedGradesList
			})
		}
	}


	const columnData = !IsListEmpty(data.topic_details) ? data.topic_details.map(topic => {
		return {
			dueDate: !IsStringEmpty(topic.due_date) ? parseDate(topic.due_date) : '-',
			title: !IsStringEmpty(topic.name) ? topic.name : '-',
			submissions: returnNumber(topic.total_submissions_received),
			totalStudents: returnNumber(topic.total_students_count),
			pass: returnNumber(topic.passed_students_count),
			colHead: returnNumber(topic.overall_grades).toFixed(1)
		}
	}) : [];

	let updatedData = {
		reportData: {
			passedStudents: !IsStringEmpty(data.passed) ? data.passed : '-',
			totalStudents: !IsStringEmpty(data.total_students) ? data.total_students : '-',
			classGrade: !IsStringEmpty(data.class_grades) ? data.class_grades.toFixed(1) : 0,
		},
		gradesList: gradesList,
		columnData: columnData
	};

	return updatedData;
}

const ParsedInstructorStudentAttendanceReportData = (data) => {

	let parsedAttendenceList = [];
	if (!IsObjectEmpty(data.attendance)) {
		for (var id in data.attendance) {
			const attendanceData = data.attendance[id];

			const parsedAttendanceWeeksList = [];

			if (!IsObjectEmpty(attendanceData.weekly_attendance)) {
				for (var week in attendanceData.weekly_attendance) {
					const weekData = attendanceData.weekly_attendance[week];
					let daysCount = [];
					if (!IsObjectEmpty(weekData.days)) {
						daysCount[0] = weekData.days.monday;
						daysCount[1] = weekData.days.tuesday;
						daysCount[2] = weekData.days.wednesday;
						daysCount[3] = weekData.days.thursday;
						daysCount[4] = weekData.days.friday;
						daysCount[5] = weekData.days.saturday;
						daysCount[6] = weekData.days.sunday;
					}

					parsedAttendanceWeeksList.push({
						weekName: week,
						weekAttendance: daysCount
					})
				}
			}

			parsedAttendenceList.push({
				name: toTitleCase(attendanceData.student_fullname),
				profilePic: !IsListEmpty(attendanceData.profilepicture_url) ? attendanceData.profilepicture_url : iconDefaultAvatar,
				overallGrade: !IsStringEmpty(attendanceData.average_attendance) ? attendanceData.average_attendance : '-',
				weeks: parsedAttendanceWeeksList,
			})
		}
	}

	let columnData = [];
	if (!IsObjectEmpty(data.weekList)) {
		for (var week in data.weekList) {
			const weekData = data.weekList[week];

			let attendanceList = [];
			if (!IsObjectEmpty(weekData.daywise_attendance_count)) {
				for (var day in weekData.daywise_attendance_count) {
					attendanceList[0] = weekData.daywise_attendance_count.monday;
					attendanceList[1] = weekData.daywise_attendance_count.tuesday;
					attendanceList[2] = weekData.daywise_attendance_count.wednesday;
					attendanceList[3] = weekData.daywise_attendance_count.thursday;
					attendanceList[4] = weekData.daywise_attendance_count.friday;
					attendanceList[5] = weekData.daywise_attendance_count.saturday;
				}
			}

			columnData.push({
				weekName: week,
				from: !IsStringEmpty(weekData.start_date) ? parseDate(weekData.start_date, false, true) : '',
				to: !IsStringEmpty(weekData.end_date) ? parseDate(weekData.end_date, false, true) : '',
				sessionsConducted: returnNumber(weekData.sessions_conducted),
				totalSessions: returnNumber(weekData.sessions_scheduled),
				uniqueStudents: returnNumber(weekData.unique_students),
				pass: 'None',
				colHead: returnNumber(weekData.sessions_conducted),
				attendance: attendanceList
			})
		}
	}

	let updatedData = {
		reportData: {
			activeStudents: calculateProgress(data.total_active_students, data.total_studetns, true),
			classAttendance: returnNumber(data.course_average_attendance),
		},
		attendenceList: parsedAttendenceList,
		columnData: columnData,
	};

	return updatedData;
}

const ParsedStudentDailyFeedbackResponse = (response) => {

	const data = response.submissions, feedbackType = response.feedback_type;

	let updatedData = {
		isOldFeedback: !IsListEmpty(data) && data.length > 2 ? false : true,
		feedbackData: {},
		subtopicsList: [],
		newDailyFeedbackResponse: [],
		clearedDoubts: 'yes',
		sessionRating: { value: 0, fraction: [0, 10] },
		feedbackType: feedbackType
	};

	if (!IsListEmpty(data)) {
		if (feedbackType === "daily") {
			for (var i = 0; i < data.length; i++) {
				if (data[i].description === "Did you understand the following topics?") {
					if (!IsObjectEmpty(data[i].submitted)) {
						let subtopicsList = [];
						for (var subtopic in data[i].submitted) {
							subtopicsList.push({ title: subtopic, response: data[i].submitted[subtopic] });
						}
						updatedData.subtopicsList = subtopicsList;
					}
				} else if (data[i].description === "Were the doubts solved in today's session?") {
					updatedData.clearedDoubts = !IsListEmpty(data[i].submitted) && !IsStringEmpty(data[i].submitted[0]) ? data[i].submitted[0] : 'No';
				} else if (data[i].description === "Please rate today's session. (Where 10 is excellent and 1 is poor)") {
					updatedData.sessionRating = calculateProgress(data[i].submitted[0], 10, true);
					updatedData.feedbackData = {
						studentName: toTitleCase(data[i].user_details.name),
						topicName: data[i].topic_name,
						submissionDate: !IsStringEmpty(data[i].submission_date) ? parseDate(data[i].submission_date) + ' - ' + parseTimeForDate(data[i].submission_date) : '-',
					}
				}
			}
		} else {
			for (var i = 0; i < data.length; i++) {
				updatedData.newDailyFeedbackResponse.push({
					title: data[i].description,
					value: data[i].submitted
				});
			}
			updatedData.feedbackData = {
				studentName: toTitleCase(data[0].user_details.name),
				topicName: data[0].topic_name,
				submissionDate: !IsStringEmpty(data[0].submission_date) ? parseDate(data[0].submission_date) + ' - ' + parseTimeForDate(data[0].submission_date) : '-',
			}
		}
	}

	return updatedData;
}

const ParsedStudentWeeklyFeedbackResponse = (data) => {
	let updatedResponseList = [], studentName = '', submissionDate = '', rating = 0, mostLiked = '';

	if (!IsListEmpty(data)) {

		studentName = toTitleCase(data[0].user_details.name);
		submissionDate = !IsStringEmpty(data[0].submission_date) ? parseDate(data[0].submission_date) + ' - ' + parseTimeForDate(data[0].submission_date) : '';


		for (var i = 0; i < data.length; i++) {
			if (data[i].description === 'How likely are you to recommend EdYoda Program to your family/friends?') {
				rating = !IsStringEmpty(data[i].submitted) ? parseInt(data[i].submitted, 10) : 0;
				rating = calculateProgress(rating, 10, true);
			} else if (data[i].description === 'What is the best thing you like about this program?') {
				mostLiked = data[i].submitted;
			} else {
				updatedResponseList.push(
					{
						title: data[i].description,
						value: data[i].submitted
					}
				);
			}
		}
	}

	const updatedData = {
		weeklyResponse: {
			studentName: studentName,
			submissionDate: submissionDate,
			weekName: 'Week 1',
			responsesList: updatedResponseList
		},
		edyodaRating: rating,
		mostLiked: mostLiked
	}

	return updatedData;
}

const parsedStudentQuizSubmissionProblems = (problemsList) => {
	const quizProblems = !IsListEmpty(problemsList) ? problemsList.map((problemItem) => {

		// const problem = problemItem['question - ' + (index + 1)];
		let problem = {};
		for (var key in problemItem) {
			problem = problemItem[key];
		}

		if (!IsObjectEmpty(problem)) {
			const problemStatus = !IsStringEmpty(problem.status)
				? problem.status === 'correct'
					? 'CORRECT' : problem.status === 'incorrect' ? 'INCORRECT' : 'NOT ATTEMPTED' : 'NOT ATTEMPTED';

			// console.log('ProblemsList => ', problem.status, problemStatus)

			let correctAnsCount = 0;

			const optionsList = !IsListEmpty(problem.options) ? problem.options.map(optionItem => {

				let optionStatus = '';
				if (problem.status === 'not attempted') {
					optionStatus = 'not attempted';
				} else if (optionItem.is_correct === true && !IsListEmpty(problem.submitted_option_ids) && problem.submitted_option_ids.indexOf(`${optionItem.id}`) !== -1) {
					optionStatus = 'correct';
				} else if (optionItem.is_correct === false && !IsListEmpty(problem.submitted_option_ids) && problem.submitted_option_ids.indexOf(`${optionItem.id}`) !== -1) {
					optionStatus = 'incorrect';
				}

				correctAnsCount = optionItem.is_correct ? correctAnsCount + 1 : correctAnsCount;

				return {
					id: optionItem.id,
					correct: optionItem.is_correct,
					isCorrect: optionItem.is_correct,
					option: !IsStringEmpty(optionItem.option) ? optionItem.option : !IsStringEmpty(optionItem.img_option) ? optionItem.img_option : '',
					optionStatus: optionStatus,
					selected: !IsListEmpty(problem.submitted_option_ids) && problem.submitted_option_ids.indexOf(`${optionItem.id}`) !== -1 ? true : false,
					type: !IsStringEmpty(optionItem.img_option) ? 'image' : !IsStringEmpty(optionItem.option) ? 'text' : 'text',
				};
			}) : [];

			let updatedProblemObj = {
				id: problem.id,
				maxScore: !IsStringEmpty(problem.max_score) ? problem.max_score : 0,
				problem: !IsStringEmpty(problem.question) ? problem.question : '',
				selectedOptions: !IsListEmpty(problem.submitted_option_ids) && problemStatus !== 'NOT ATTEMPTED' ? problem.submitted_option_ids : [],
				status: problemStatus,
				type: correctAnsCount < 2 ? 'single' : 'multiple',
				options: optionsList,
			}

			return updatedProblemObj;
		}

	}) : [];
	return quizProblems;
}

const ParsedStudentQuizSubmission = (data) => {

	const not_attempted = !IsStringEmpty(data.submission.overview.not_attempted) ? data.submission.overview.not_attempted : 0;
	const incorrect = !IsStringEmpty(data.submission.overview.incorrect) ? data.submission.overview.incorrect : 0;
	const correct = !IsStringEmpty(data.submission.overview.correct) ? data.submission.overview.correct : 0;
	const total = !IsStringEmpty(data.submission.overview.total_questions) ? data.submission.overview.total_questions : 0;

	const dueDate = !IsStringEmpty(data.submission.due_date) ? data.submission.due_date : '';
	const submittedDate = !IsStringEmpty(data.submission.submitted_on) ? data.submission.submitted_on : '';
	const lateSubmission = !IsStringEmpty(data.submission.is_late_submitted) ? data.submission.is_late_submitted : false;
	// const submissionData = calculateProgress(data.quiz.submissions, data.quiz.total_students, true);

	const studentsList = !IsListEmpty(data.users) ? data.users.map(student => {
		return {
			id: student.id,
			label: toTitleCase(student.name)
		}
	}) : [];

	let updatedData = {
		quizResult: {
			id: !IsStringEmpty(data.submission.id) ? data.submission.id : '',
			name: !IsStringEmpty(data.submission.name) ? data.submission.name : '',
			lateSubmission: lateSubmission,
			score: !IsStringEmpty(data.submission.score) ? data.submission.score : '-',
			totalScore: !IsStringEmpty(data.submission.total_points) ? data.submission.total_points : '-',
			correct: correct,
			incorrect: incorrect,
			notAttempted: not_attempted,
			submitDate: !IsStringEmpty(submittedDate) ? parseDate(submittedDate, false, true) : '--', // '11 Mar 2021'
			submitTime: !IsStringEmpty(submittedDate) ? parseTimeForDate(submittedDate) : '-- PM', // '02:39 PM'
			dueDate: !IsStringEmpty(dueDate) ? parseDate(dueDate, false, true) : '--',
			dueTime: !IsStringEmpty(dueDate) ? parseTimeForDate(dueDate) : '-- PM',
			result: !IsStringEmpty(data.submission.status) ? data.submission.status : 'PENDING',
			quizTime: !IsStringEmpty(data.submission.timer) ? data.submission.timer : '00',
			total: total
		},
		quizProblems: parsedStudentQuizSubmissionProblems(data.submission.problems),
		studentsList: studentsList,
		studentDetails: {
			name: toTitleCase(data.submission.user_details.name),
			profilePic: !IsStringEmpty(data.submission.user_details.profile_pic) ? data.submission.user_details.profile_pic : iconDefaultAvatar
		}
	}

	return updatedData;
}

// const ParsedPMHomepageData = (data) => {

// 	const updatedProgramsList = !IsListEmpty(data.programs) ? data.programs.map((item) => {
// 		return (
// 			{
// 				activeStudents: !IsStringEmpty(item.active_students) ? item.active_students : '',
// 				programLogo: !IsStringEmpty(item.logo_url) ? item.logo_url : iconDefaultAvatar,
// 				batchCode: !IsStringEmpty(item.batch_code) ? item.batch_code : '',
// 				programId: !IsStringEmpty(item.id) ? item.id : '',
// 				programName: !IsStringEmpty(item.name) ? item.name : '',
// 				overallGrade: !IsStringEmpty(Math.floor(item.overall_grades)) ? Math.floor(item.overall_grades) : '',
// 				overallNPS: !IsStringEmpty(Math.floor(item.overall_nps)) ? Math.floor(item.overall_nps) : '',
// 				progress: !IsStringEmpty(Math.floor(item.progress)) ? Math.floor(item.progress) : '',
// 				startDate: !IsStringEmpty(item.start_date) ? parseDate(item.start_date, false, true) : '--',
// 				totalStudents: !IsStringEmpty(item.total_students) ? item.total_students : '',
// 				activeStudentsPercentage: calculateProgress(item.active_students, item.total_students, true),
// 				ongoingModule: !IsObjectEmpty(item.ongoing_module) ? {
// 					ongoingModuleId: !IsStringEmpty(item.ongoing_module.id) ? item.ongoing_module.id : '',
// 					instructorName: !IsStringEmpty(item.ongoing_module.instructor_name) ? item.ongoing_module.instructor_name : '',
// 					moduleLogo: !IsStringEmpty(item.ongoing_module.logo_url) ? item.ongoing_module.logo_url : iconDefaultAvatar,
// 					moduleName: !IsStringEmpty(item.ongoing_module.name) ? item.ongoing_module.name : '',
// 					instructorProfilePic: !IsStringEmpty(item.ongoing_module.profilepicture_url) ? item.ongoing_module.profilepicture_url : iconDefaultAvatar,

// 				} : {
// 					ongoingModuleId: '',
// 					instructorName: '',
// 					moduleLogo: iconDefaultAvatar,
// 					moduleName: '',
// 					instructorProfilePic: iconDefaultAvatar
// 				},
// 			}
// 		)
// 	}) : [];

// 	const ongoingModulesData = !IsListEmpty(data.ongoing_module_data)
// 		? data.ongoing_module_data.map(module => {

// 			const batchCode = !IsStringEmpty(module.batch_code) ? module.batch_code : '',
// 				moduleName = !IsStringEmpty(module.name) ? module.name : '';

// 			let topicsList = !IsObjectEmpty(module.todays_plan) && !IsListEmpty(module.todays_plan.todays_topics)
// 				? module.todays_plan.todays_topics.map(item => {
// 					return (item.type !== 'live' && item.type !== 'daily' && item.type !== 'weekly')
// 						? {
// 							name: item.name,
// 							type: 'Topic',
// 							scheduledTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
// 							url: !IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)
// 								? RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + moduleName + '/curriculum/topic/' + item.id : ''
// 						}
// 						: null
// 				}) : [];

// 			let assignmentsList = !IsObjectEmpty(module.todays_plan) && !IsListEmpty(module.todays_plan.todays_assignment)
// 				? module.todays_plan.todays_assignment.map(item => {
// 					return {
// 						name: item.name,
// 						type: 'Assignment',
// 						scheduledTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
// 						url: !IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)
// 							? RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + moduleName + '/curriculum/assignment/' + item.id : ''
// 					}
// 				}) : [];

// 			let quizList = !IsObjectEmpty(module.todays_plan) && !IsListEmpty(module.todays_plan.todays_quiz)
// 				? module.todays_plan.todays_quiz.map(item => {
// 					return {
// 						name: item.name,
// 						type: 'Quiz',
// 						scheduledTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
// 						url: !IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)
// 							? RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + moduleName + '/curriculum/quiz/' + item.id : ''
// 					}
// 				}) : [];

// 			const sessionPlanTopicsList = [...topicsList, ...assignmentsList, ...quizList];

// 			return {
// 				moduleName: !IsStringEmpty(module.name) ? module.name : '',
// 				moduleLogo: !IsStringEmpty(module.logo_url) ? module.logo_url : '',
// 				moduleProgress: !IsStringEmpty(module.progress) ? module.progress : 0,
// 				instructorName: !IsStringEmpty(module.instructor_name) ? module.instructor_name : '',
// 				instructorProfilePic: !IsStringEmpty(module.profilepicture_url) ? module.profilepicture_url : iconDefaultAvatar,
// 				date: !IsStringEmpty(module.start_date) ? parseDate(module.start_date, false, true) : '',
// 				endDate: !IsStringEmpty(module.end_date) ? parseDate(module.end_date, false, true) : '',
// 				batchCode: !IsStringEmpty(module.batch_code) ? module.batch_code : '',
// 				activeStudents: {
// 					active: !IsStringEmpty(module.active_students) ? module.active_students : 0,
// 					total: !IsStringEmpty(module.total_students) ? module.total_students : 0,
// 					percentage: calcPercentage(module.active_students, module.total_students),
// 					rank: "Up",
// 					rankDifference: 4
// 				},
// 				NPS: {
// 					value: !IsStringEmpty(module.nps) ? Math.ceil(module.nps) : 0,
// 					rank: "Down",
// 					rankDifference: 4
// 				},
// 				instructorRating: {
// 					value: !IsStringEmpty(module.module_instructor_rating) ? Math.ceil(module.module_instructor_rating) : 0,
// 					rank: "Up",
// 					rankDifference: 4
// 				},
// 				feedback: {
// 					value: !IsStringEmpty(module.feedback_response_rate) ? Math.ceil(module.feedback_response_rate) : 0,
// 					rank: "Up",
// 					rankDifference: 4
// 				},
// 				sessionPlan: {
// 					topic: "Session Plan",
// 					date: parseDate(Date.now(), false, true),
// 					topicsList: sessionPlanTopicsList
// 				}
// 			}
// 		}
// 		) : [];

// 	let updatedData = {
// 		overallNPS: !IsStringEmpty(data.avg_nps) ? parseInt(data.avg_nps.toFixed(2)) : '',
// 		activeStudents: !IsStringEmpty(data.active_students) ? parseInt(data.active_students) : '',
// 		instructorRating: !IsStringEmpty(data.avg_instructor_rating) ? parseInt(data.avg_instructor_rating.toFixed(2)) : '',
// 		totalStudents: !IsStringEmpty(data.total_students) ? parseInt(data.total_students) : '',
// 		overallAttendance: calculateProgress(data.active_students, data.total_students, true),
// 		programs: !IsListEmpty(updatedProgramsList) ? updatedProgramsList : [],
// 		ongoingModulesData: !IsListEmpty(data.ongoing_module_data) ? ongoingModulesData : []
// 	}
// 	return updatedData;
// }

const ParsedPMHomepageStats = (data) => {
	let updatedData = {
		overallNPS: !IsStringEmpty(data.avg_nps) ? parseInt(data.avg_nps.toFixed(2)) : '',
		activeStudents: !IsStringEmpty(data.active_students) ? parseInt(data.active_students) : '',
		instructorRating: !IsStringEmpty(data.avg_instructor_rating) ? parseInt(data.avg_instructor_rating.toFixed(2)) : '',
		totalStudents: !IsStringEmpty(data.total_students) ? parseInt(data.total_students) : '',
		overallAttendance: calculateProgress(data.active_students, data.total_students, true),
	}
	return updatedData;
}

const ParsedPMHomepageOngoingModulesData = (data) => {
	const ongoingModulesData = !IsListEmpty(data.ongoing_module_data)
		? data.ongoing_module_data.map(module => {

			const batchCode = !IsStringEmpty(module.batch_code) ? module.batch_code : '',
				moduleName = !IsStringEmpty(module.name) ? module.name : '';

			let topicsList = !IsObjectEmpty(module.todays_plan) && !IsListEmpty(module.todays_plan.todays_topics)
				? module.todays_plan.todays_topics.map(item => {
					return (item.type !== 'live' && item.type !== 'daily' && item.type !== 'weekly')
						? {
							name: item.name,
							type: 'Topic',
							scheduledTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
							url: !IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)
								? RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(moduleName) + '/curriculum/topic/' + item.id : ''
						}
						: null
				}) : [];

			let assignmentsList = !IsObjectEmpty(module.todays_plan) && !IsListEmpty(module.todays_plan.todays_assignment)
				? module.todays_plan.todays_assignment.map(item => {
					return {
						name: item.name,
						type: 'Assignment',
						scheduledTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
						url: !IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)
							? RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(moduleName) + '/curriculum/assignment/' + item.id : ''
					}
				}) : [];

			let quizList = !IsObjectEmpty(module.todays_plan) && !IsListEmpty(module.todays_plan.todays_quiz)
				? module.todays_plan.todays_quiz.map(item => {
					return {
						name: item.name,
						type: 'Quiz',
						scheduledTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
						url: !IsStringEmpty(batchCode) && !IsStringEmpty(moduleName)
							? RouteEndPoints.PROGRAMS_PAGE + '/' + batchCode + '/modules/' + encodeURIComponent(moduleName) + '/curriculum/quiz/' + item.id : ''
					}
				}) : [];

			const sessionPlanTopicsList = [...topicsList, ...assignmentsList, ...quizList];

			return {
				moduleName: !IsStringEmpty(module.name) ? module.name : '',
				moduleLogo: !IsStringEmpty(module.logo_url) ? module.logo_url : '',
				moduleProgress: !IsStringEmpty(module.progress) ? module.progress : 0,
				instructorName: !IsStringEmpty(module.instructor_name) ? module.instructor_name : '',
				instructorProfilePic: !IsStringEmpty(module.profilepicture_url) ? module.profilepicture_url : iconDefaultAvatar,
				date: !IsStringEmpty(module.start_date) ? parseDate(module.start_date, false, true) : '',
				endDate: !IsStringEmpty(module.end_date) ? parseDate(module.end_date, false, true) : '',
				batchCode: !IsStringEmpty(module.batch_code) ? module.batch_code : '',
				activeStudents: {
					active: !IsStringEmpty(module.active_students) ? module.active_students : 0,
					total: !IsStringEmpty(module.total_students) ? module.total_students : 0,
					percentage: calcPercentage(module.active_students, module.total_students),
					rank: "Up",
					rankDifference: 4
				},
				NPS: {
					value: !IsStringEmpty(module.nps) ? Math.ceil(module.nps) : 0,
					rank: "Down",
					rankDifference: 4
				},
				instructorRating: {
					value: !IsStringEmpty(module.module_instructor_rating) ? Math.ceil(module.module_instructor_rating) : 0,
					rank: "Up",
					rankDifference: 4
				},
				feedback: {
					value: !IsStringEmpty(module.feedback_response_rate) ? Math.ceil(module.feedback_response_rate) : 0,
					rank: "Up",
					rankDifference: 4
				},
				sessionPlan: {
					topic: "Session Plan",
					date: parseDate(Date.now(), false, true),
					topicsList: sessionPlanTopicsList
				}
			}
		}
		) : [];
	return !IsListEmpty(data.ongoing_module_data) ? ongoingModulesData : []
}
const ParsedPMAllLearnersList = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map(learner => {

		const name = getName(learner.first_name, learner.last_name, '');

		const lastVisitedDateTime = !IsStringEmpty(learner.last_login) ?
			parseDate(learner.last_login, false, true) + ' - ' + parseTimeForDate(learner.last_login)
			: '-';
		return {
			name: name,
			username: !IsStringEmpty(learner.username) ? learner.username : '',
			profilePic: !IsStringEmpty(learner.profilepicture_url) ? learner.profilepicture_url : iconDefaultAvatar,
			email: !IsStringEmpty(learner.email) ? learner.email : '-',
			enrollmentNumber: !IsStringEmpty(learner.enrollment_number) ? learner.enrollment_number : '-',
			selected: false,
			programsEnrolled: !IsListEmpty(learner.enrolled_programs) ? learner.enrolled_programs.join(', ') : '-',
			lastVisited: lastVisitedDateTime, //"11 FEB 2021 - 11:45 AM"
			dropOut: learner.is_active === true ? "No" : "Yes",
			dropOutDate: !IsStringEmpty(learner.dropout_date) && learner.is_active === false ? parseDate(learner.dropout_date) : 'N/A',
			status: learner.status
		}
	}) : [];

	return updatedList;
}

const ParsedPMAllProgramsList = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map((program, i) => {
		return {
			id: i + 1,
			batchCode: !IsStringEmpty(program.batch_code) ? program.batch_code : '',
			name: !IsStringEmpty(program.batch_code) && !IsStringEmpty(program.name) ? program.batch_code + ' | ' + program.name : ''
		}
	}) : [];

	return updatedList;
}
const ParsedPMAllCertificationList = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map(certification => {
		return {
			certificationCode: !IsStringEmpty(certification.certification_code) ? certification.certification_code : '',
			name: !IsStringEmpty(certification.certification_name) ? certification.certification_name + " - " + certification.certification_code : '',
			id: certification.certification_id,
		}
	}) : [];

	return updatedList;
}
const ParsedPMAllRoundList = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map(round => {
		return {
			roundCode: !IsStringEmpty(round.round_code) ? round.round_code : '',
			name: !IsStringEmpty(round.round_name) ? round.round_name + " - " + round.round_code : '',
			id: round.round_id,
		}
	}) : [];

	return updatedList;
}
const parsedCertificationReports = (data) => {
	let reportsList = [];
	for (var i = 0; i < data.length; i++) {
		reportsList.push({
			attempt_number: data[i].attempt_number,
			batch_code: data[i].batch_code,
			certification_code: data[i].certification_code,
			email: data[i].email,
			fullname: data[i].fullname,
			grades: data[i].grades,
			result: data[i].result,
			scheduled_date: data[i].scheduled_date,
			status: data[i].status,
			selected: false
		})
	}
	return reportsList;
}

const ParsedPMAllInstructorsList = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map(instructor => {

		const name = getName(instructor.first_name, instructor.last_name, '');

		const lastVisitedDateTime = !IsStringEmpty(instructor.last_login) ?
			parseDate(instructor.last_login, false, true) + ' - ' + parseTimeForDate(instructor.last_login)
			: '-';

		const modulesList = !IsListEmpty(instructor.module_taken) ? instructor.module_taken.map(module => module.name + ' ' + `(${module.program__batch_code})`) : [];

		return {
			name: name,
			username: !IsStringEmpty(instructor.username) ? instructor.username : '',
			profilePic: !IsStringEmpty(instructor.profilepicture_url) ? instructor.profilepicture_url : iconDefaultAvatar,
			email: !IsStringEmpty(instructor.email) ? instructor.email : '-',
			rating: !IsStringEmpty(instructor.rating) ? instructor.rating : '0',
			selected: false,
			modulesTaken: !IsListEmpty(modulesList) ? modulesList.join(', ') : '-',
			lastVisited: lastVisitedDateTime, //"11 FEB 2021 - 11:45 AM"
		}
	}) : [];

	return updatedList;
}

const ParsedPMAllModulesList = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map((module, i) => {
		return {
			id: i + 1,
			name: !IsStringEmpty(module.name) ? module.name : ''
		}
	}) : [];

	return updatedList;
}

const ParsedUserAccountData = (data) => {
	const enrolledProgramsList = !IsListEmpty(data.programs) ? data.programs.map((program, index) => {
		return { id: (index + 2), label: program.batch_code, value: program.batch_code, name: program.name, batchStatus: program.status };
	}) : [];

	let parsedData = {
		username: !IsStringEmpty(data.username) ? data.username : '',
		fullName: getName(data.first_name, data.last_name, ''),
		email: !IsStringEmpty(data.email_id) ? data.email_id : '',
		phoneNumber: !IsStringEmpty(data.phonenumber) ? data.phonenumber : '',
		profilePic: !IsStringEmpty(data.profilepicture_url) ? data.profilepicture_url : iconDefaultAvatar,
		accountType: data.usercategory === 'student' ? 'learner' : data.usercategory === 'instructor' ? 'instructor' : 'learner',
		accountStatus: !IsStringEmpty(data.status) ? data.status : '',
		token: data.token,
		errorMessage: !IsStringEmpty(data.message) ? data.message : '',
		enrolledPrograms: enrolledProgramsList,
		rcrm_slug: !IsStringEmpty(data.rcrm_slug) ? data.rcrm_slug : "",
		userId: !IsStringEmpty(data.user_id) ? data.user_id : "",
	}

	return parsedData;
}

const ParsedPMAllProgramsData = (data) => {
	let updatedList = !IsListEmpty(data.all_programs) ? data.all_programs.map(program => {
		return {
			name: program.name + ' | ' + program.batch_code,
			instructorCount: !IsStringEmpty(program.instructor_count) ? program.instructor_count : '0',
			learnerCount: !IsStringEmpty(program.learner_count) ? program.learner_count : '0',
			moduleCount: !IsStringEmpty(program.module_count) ? program.module_count : '0',
			programName: !IsStringEmpty(program.name) ? program.name : '',
			batchCode: !IsStringEmpty(program.batch_code) ? program.batch_code : '0',
			date: parseDate(program.start_date),
			status: !IsStringEmpty(program.status) ? program.status : '',
			programPic: !IsStringEmpty(program.thumbnail) ? program.thumbnail : iconDefaultAvatar,
			programType: !IsStringEmpty(program.type) ? program.type : 'edyoda'
		}
	}) : [];

	let parsedData = {
		allPrograms: updatedList,
		uniquePrograms: !IsListEmpty(data.unique_programs) ? data.unique_programs : [],
		completedPrograms: !IsStringEmpty(data.completed_programs) ? Math.floor(data.completed_programs) : '0',
		ongoingPrograms: !IsStringEmpty(data.ongoing_programs) ? Math.floor(data.ongoing_programs) : '0',
		totalPrograms: !IsStringEmpty(data.total_programs) ? Math.floor(data.total_programs) : '0',
		upcomingPrograms: !IsStringEmpty(data.upcoming_programs) ? Math.floor(data.upcoming_programs) : '0',
		instructorRating: !IsStringEmpty(data.avg_instructor_rating) ? Math.floor(data.avg_instructor_rating) : '0',
		avgNPS: !IsStringEmpty(data.avg_nps) ? Math.floor(data.avg_nps) : '0',
		programRetention: !IsStringEmpty(data.program_retention) ? Math.floor(data.program_retention) : '0'
	}

	return parsedData
}
const parsePaginatedProgramsData = (data) => {
	let updatedList = !IsListEmpty(data.all_programs.program_list) ? data.all_programs.program_list.map(program => {
		return {
			name: program.name + ' | ' + program.batch_code,
			instructorCount: !IsStringEmpty(program.instructor_count) ? program.instructor_count : '0',
			learnerCount: !IsStringEmpty(program.learner_count) ? program.learner_count : '0',
			moduleCount: !IsStringEmpty(program.module_count) ? program.module_count : '0',
			programName: !IsStringEmpty(program.name) ? program.name : '',
			batchCode: !IsStringEmpty(program.batch_code) ? program.batch_code : '0',
			date: parseDate(program.start_date),
			status: !IsStringEmpty(program.status) ? program.status : '',
			programPic: !IsStringEmpty(program.thumbnail) ? program.thumbnail : iconDefaultAvatar,
			programType: !IsStringEmpty(program.type) ? program.type : 'edyoda',
			nextPage: data.all_programs.next,
			totalCount: data.total_programs,
		}
	}) : [];

	let parsedData = {
		allPrograms: updatedList,
		uniquePrograms: !IsListEmpty(data.unique_programs) ? data.unique_programs : [],
		completedPrograms: !IsStringEmpty(data.completed_programs) ? Math.floor(data.completed_programs) : '0',
		ongoingPrograms: !IsStringEmpty(data.ongoing_programs) ? Math.floor(data.ongoing_programs) : '0',
		totalPrograms: !IsStringEmpty(data.total_programs) ? Math.floor(data.total_programs) : '0',
		upcomingPrograms: !IsStringEmpty(data.upcoming_programs) ? Math.floor(data.upcoming_programs) : '0',
		instructorRating: !IsStringEmpty(data.avg_instructor_rating) ? Math.floor(data.avg_instructor_rating) : '0',
		avgNPS: !IsStringEmpty(data.avg_nps) ? Math.floor(data.avg_nps) : '0',
		programRetention: !IsStringEmpty(data.program_retention) ? Math.floor(data.program_retention) : '0'
	}

	return parsedData
}

const parseFilteredPaginatedProgramsData = (data) => {
	let updatedList = !IsListEmpty(data.all_programs.program_list) ? data.all_programs.program_list.map(program => {
		return {
			name: program.name + ' | ' + program.batch_code,
			instructorCount: !IsStringEmpty(program.instructor_count) ? program.instructor_count : '0',
			learnerCount: !IsStringEmpty(program.learner_count) ? program.learner_count : '0',
			moduleCount: !IsStringEmpty(program.module_count) ? program.module_count : '0',
			programName: !IsStringEmpty(program.name) ? program.name : '',
			batchCode: !IsStringEmpty(program.batch_code) ? program.batch_code : '0',
			date: parseDate(program.start_date),
			status: !IsStringEmpty(program.status) ? program.status : '',
			programPic: !IsStringEmpty(program.thumbnail) ? program.thumbnail : iconDefaultAvatar,
			programType: !IsStringEmpty(program.type) ? program.type : 'edyoda',
			nextPage: data.all_programs.next,
			totalCount: data.total_programs,
		}
	}) : [];

	let parsedData = {
		allPrograms: updatedList,
		uniquePrograms: !IsListEmpty(data.unique_programs) ? data.unique_programs : [],
		completedPrograms: !IsStringEmpty(data.completed_programs) ? Math.floor(data.completed_programs) : '0',
		ongoingPrograms: !IsStringEmpty(data.ongoing_programs) ? Math.floor(data.ongoing_programs) : '0',
		totalPrograms: !IsStringEmpty(data.total_programs) ? Math.floor(data.total_programs) : '0',
		upcomingPrograms: !IsStringEmpty(data.upcoming_programs) ? Math.floor(data.upcoming_programs) : '0',
		instructorRating: !IsStringEmpty(data.avg_instructor_rating) ? Math.floor(data.avg_instructor_rating) : '0',
		avgNPS: !IsStringEmpty(data.avg_nps) ? Math.floor(data.avg_nps) : '0',
		programRetention: !IsStringEmpty(data.program_retention) ? Math.floor(data.program_retention) : '0'
	}

	return parsedData
}


const ParseSearchProgramsData = (data) => {
	let updatedList = !IsListEmpty(data) ? data.map(program => {
		return {
			name: program.name + ' | ' + program.batch_code,
			instructorCount: !IsStringEmpty(program.instructor_count) ? program.instructor_count : '0',
			learnerCount: !IsStringEmpty(program.learner_count) ? program.learner_count : '0',
			moduleCount: !IsStringEmpty(program.module_count) ? program.module_count : '0',
			batchCode: program.batch_code,
			date: parseDate(program.start_date),
			status: program.status || '',
			programPic: program.thumbnail || iconDefaultAvatar,
			programType: program.type || 'edyoda'
		};
	}) : [];

	return updatedList;
};


const ParsedProgramsOverviewData = (data) => {

	let parsedData = {
		activeStudents: Math.floor(data.active_students),
		overallAttendance: Math.floor(data.overall_attendance),
		overallGrade: Math.floor(data.overall_grades),
		overallNPS: Math.floor(data.overall_nps),
		totalStudents: Math.floor(data.total_students),
	}

	return parsedData
}

const ParsedInstructorsData = (data) => {
	let parsedData = !IsListEmpty(data.instructors) ? data.instructors.map((instructor) => {
		let updatedList = !IsListEmpty(instructor.module_taken) ? instructor.module_taken.map((item) => {
			return {
				name: item.name,
				logo: item.logo_url,
				rating: !IsStringEmpty(item.rating) ? Math.floor(item.rating) : '0',
				sessionsConducted: !IsStringEmpty(item.session_conducted) ? Math.floor(item.session_conducted) : '0',
				sessionsMissed: !IsStringEmpty(item.session_missed) ? Math.floor(item.session_missed) : '0',
				sessionsScheduled: !IsStringEmpty(item.session_scheduled) ? Math.floor(item.session_scheduled) : '0',
			}
		}) : []
		return {
			email: !IsStringEmpty(instructor.email) ? instructor.email : '',
			name: getName(instructor.first_name, instructor.last_name, instructor.username),
			lastLogin: !IsStringEmpty(instructor.last_login) ? instructor.last_login : '',
			profilePic: !IsStringEmpty(instructor.profilepicture_url) ? instructor.profilepicture_url : '',
			username: !IsStringEmpty(instructor.username) ? instructor.username : '',
			modulesTaken: updatedList
		}
	}) : []
	return parsedData
}

const ParsedCurriculumOverviewData = (data) => {
	let date = '';

	const allTopicsList = !IsObjectEmpty(data.todays_topic_data) && !IsListEmpty(data.todays_topic_data.todays_topics)
		? data.todays_topic_data.todays_topics.map((item) => {
			date = !IsStringEmpty(data.todays_topic_data.todays_topics[0].schedule_date)
				? parseDate(data.todays_topic_data.todays_topics[0].schedule_date) : '';

			let itemData = null;
			if (item.type === 'topic') {
				itemData = {
					topicId: item.id,
					moduleId: item.module_id,
					moduleName: item.module_name,
					topicName: !IsStringEmpty(item.name) ? item.name : '',
					type: item.type
				};
			} else if (item.type === 'daily' || item.type === 'weekly') {
				itemData = {
					topicId: item.topic,
					feedbackId: item.id,
					feedbackName: item.name,
					scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
					type: item.type
				};
			} else if (item.type === 'live') {
				const enableButton = new Date(item.schedule_date).getTime() < Date.now() ? true : false;
				itemData = {
					scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '',
					status: !IsStringEmpty(item.status) ? item.status : '',
					started: !IsStringEmpty(item.status) && item.status === 'started' ? true : false,
					sessionEnded: !IsStringEmpty(item.status) && item.status === 'ended' ? true : false,
					meetingNumber: !IsStringEmpty(item.meet_id) ? item.meet_id : '',
					password: !IsStringEmpty(item.meet_id) ? item.password : '',
					role: 0,
					signature: !IsStringEmpty(item.signature) ? item.signature : '',
					apiKey: !IsStringEmpty(item.api_key) ? item.api_key : '',
					liveSessionId: !IsStringEmpty(item.id) ? item.id : '',
					topicName: !IsStringEmpty(item.topic_name) ? item.topic_name : '',
					topicId: !IsStringEmpty(item.topic) ? item.topic : '',
					startURL: !IsStringEmpty(item.start_url) ? item.start_url : '',
					enableButton: enableButton,
					type: item.type
				}
			}
			return itemData;

		}) : [];

	const quizList = !IsObjectEmpty(data.todays_topic_data) && !IsListEmpty(data.todays_topic_data.todays_quiz)
		? data.todays_topic_data.todays_quiz.map(item => {
			return ({
				topicId: item.id,
				moduleId: item.module_id,
				moduleName: item.module_name,
				quizName: item.name,
				scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
				type: item.type
			});
		}) : [];

	const assignmentList = !IsObjectEmpty(data.todays_topic_data) && !IsListEmpty(data.todays_topic_data.todays_assignment)
		? data.todays_topic_data.todays_assignment.map(item => {
			return ({
				topicId: item.id,
				moduleId: item.module_id,
				moduleName: item.module_name,
				assignmentName: item.name,
				scheduleTime: !IsStringEmpty(item.schedule_date) ? parseTimeForDate(item.schedule_date) : '-',
				type: item.type
			});
		}) : [];

	const liveSessionList = !IsObjectEmpty(data.todays_topic_data) && !IsListEmpty(data.todays_topic_data.todays_live_session)
		? data.todays_topic_data.todays_live_session.map(liveSession => {
			return ({
				scheduleTime: !IsStringEmpty(liveSession.schedule_date) ? parseTimeForDate(liveSession.schedule_date) : '',
				status: !IsStringEmpty(liveSession.status) ? liveSession.status : '',
				started: !IsStringEmpty(liveSession.status) && liveSession.status === 'started' ? true : false,
				sessionEnded: !IsStringEmpty(liveSession.status) && liveSession.status === 'ended' ? true : false,
				meetingNumber: !IsStringEmpty(liveSession.meet_id) ? liveSession.meet_id : '',
				password: !IsStringEmpty(liveSession.meet_id) ? liveSession.password : '',
				role: 0,
				signature: !IsStringEmpty(liveSession.signature) ? liveSession.signature : '',
				apiKey: !IsStringEmpty(liveSession.api_key) ? liveSession.api_key : '',
				liveSessionId: !IsStringEmpty(liveSession.id) ? liveSession.id : '',
				topicName: !IsStringEmpty(liveSession.topic_name) ? liveSession.topic_name : '',
				topicId: !IsStringEmpty(liveSession.topic) ? liveSession.topic : '',
			});
		}) : [];

	let parsedData = {
		completedAssignments: !IsStringEmpty(data.assignment_completed) ? data.assignment_completed : '-',
		totalAssignments: !IsStringEmpty(data.total_assignments) ? data.total_assignments : '-',
		completedLiveSessions: !IsStringEmpty(data.live_session_completed) ? data.live_session_completed : '-',
		totalLiveSessions: !IsStringEmpty(data.total_live_sessions) ? data.total_live_sessions : '-',
		completedQuizzes: !IsStringEmpty(data.quiz_completed) ? data.quiz_completed : '-',
		totalQuizzes: !IsStringEmpty(data.total_quizzes) ? data.total_quizzes : '-',
		completedTopics: !IsStringEmpty(data.topic_completed) ? data.topic_completed : '-',
		totalTopics: !IsStringEmpty(data.total_topic) ? data.total_topic : '-',

		todaysPlan: {
			date: date,
			allTopicsList: allTopicsList,
			quizList: quizList,
			assignmentList: assignmentList,
			liveSessionList: liveSessionList
		},
		module: { name: data.module.name, logo: data.module.thumbnail },
		instructor: {
			profilePic: !IsStringEmpty(data.module.current_instructor.profilepicture_url) ? data.module.current_instructor.profilepicture_url : iconDefaultAvatar,
			name: getName(data.module.current_instructor.first_name, data.module.current_instructor.last_name, data.module.current_instructor.username)
		},
	}
	return parsedData;
}

const ParsedPMInstructorPerformanceData = (data) => {


	const modulesList = !IsListEmpty(data.modules) ? data.modules.map(item => {
		let batchCodes = [];

		batchCodes = !IsListEmpty(item.program__batch_code) ? item.program__batch_code.map(batchCode => {
			return { name: batchCode }
		}) : [{ name: 'Not Found' }];

		batchCodes.unshift({ name: '' })

		return { name: item.name, batchCodesList: batchCodes };
	}) : [{ name: 'Not Found' }];

	// const batchCodes = !IsListEmpty(data.modules) ? data.modules.map(item => {
	// 	return { name: item.program__batch_code };
	// }) : [{ name: 'Not Found' }];

	const overallStatsData = {
		hoursTaught: !IsStringEmpty(data.hours_taught) ? data.hours_taught : 0,
		studentsTaught: !IsStringEmpty(data.students_taught) ? data.students_taught : 0,
		overallRating: !IsStringEmpty(data.rating) ? Math.floor(data.rating) : 0,
	};

	const attendanceStatsData = {
		sessionsConducted: calculateProgress(data.session_conducted, data.session_scheduled, true),
		sessionsScheduled: calculateProgress(data.session_conducted, data.session_scheduled, true),
		daysMissed: !IsStringEmpty(data.session_missed) ? data.session_missed : 0
	};


	let updatedData = {
		modulesList: modulesList,
		batchCodesList: !IsListEmpty(modulesList) ? modulesList[0].batchCodesList : [{ name: 'Not Found' }],
		overallStatsData: overallStatsData,
		attendanceStatsData: attendanceStatsData,
		selectedModule: {
			name: data.selected_module.name,
			batchCode: data.selected_module.batch_code,
		}
	}

	return updatedData;
}
const ParsedModulePerformanceData = (data) => {
	let parsedData = {
		activeStudents: !IsStringEmpty(data.active_students) ? data.active_students : '-',
		overallAttendance: !IsStringEmpty(data.overall_attendance) ? Math.round(data.overall_attendance) : '-',
		overallGrade: !IsStringEmpty(data.overall_grades) ? Math.round(data.overall_grades) : '-',
		overallNPS: !IsStringEmpty(data.overall_nps) ? Math.round(data.overall_nps) : '-',
		totalStudents: !IsStringEmpty(data.total_students) ? data.total_students : '-',
		highPerformers: !IsListEmpty(data.high_performance) ? data.high_performance : [],
		lowPerformers: !IsListEmpty(data.low_performance) ? data.low_performance : [],
		moduleProgress: !IsStringEmpty(data.progress) ? data.progress : 0,
		moduleLogo: !IsStringEmpty(data.module_thumbnail) ? data.module_thumbnail : null,
		programType: !IsStringEmpty(data.program_type) ? data.program_type : ''
	}
	return parsedData;
}


const ParsedAllModulesDataForProgram = (data) => {
	let modulesList = !IsListEmpty(data.modules) ? data.modules.map((module) => {
		return {
			assignments: !IsStringEmpty(module.assignment_count) ? module.assignment_count : '',
			weeks: !IsStringEmpty(module.duration) ? module.duration : '',
			id: !IsStringEmpty(module.id) ? module.id : '',
			title: !IsStringEmpty(module.name) ? module.name : '',
			quizzes: !IsStringEmpty(module.quiz_count) ? module.quiz_count : '',
			logo: !IsStringEmpty(module.thumbnail) ? module.thumbnail : '',
		}
	}) : []

	const programData = {
		name: data.program.name,
		batchCode: data.program.batch_code,
		programId: data.program.id,
		progress: !IsStringEmpty(data.progress) ? data.progress : 0,
		programType: !IsStringEmpty(data.program.type) ? data.program.type : ''
	}

	let updatedData = {
		overallAttendance: !IsStringEmpty(data.avg_attendance) ? data.avg_attendance : '',
		overallGrade: !IsStringEmpty(data.avg_grades) ? data.avg_grades.toFixed(2) : '',
		overallNPS: !IsStringEmpty(data.avg_nps) ? data.avg_nps.toFixed(2) : '',
		modulesList: modulesList,
		activeStudents: !IsStringEmpty(data.total_students) && !IsStringEmpty(data.total_students) ? [data.active_students, data.total_students] : '',
		programData: programData
	}

	return updatedData;
}

const ParsedModuleTempalte = (module) => {
	return ({
		moduleId: module.id,
		moduleName: module.name,
		programBatchCode: module.batch_code,
		logo: module.thumbnail
	});
}
const ParsedBatchmate = (batchmate) => {
	return ({
		name: batchmate.name,
		title: batchmate.title,
		profilePic: batchmate.profile_picture,
		learnerStatus: batchmate.learner_status,
		group: batchmate.group,
		username: batchmate.username,
	});
}

const ParsedGroupData = (badge, groupNames) => {
	let arr = [];
	for (let i = 0; i < groupNames.length; i++) {
		if (groupNames[i] !== "None") {
			arr.push(badge.data[groupNames[i]])
		}
	}
	return ({
		status: badge.learnerStatus,
		data: arr,
	});
}

const ParsedModuleTempalteList = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map((program) => {
		return ParsedModuleTempalte(program);
	}) : [];

	return updatedList
}
const ParsedBatchmateDetails = (obj) => {
	let list = Object.values(obj.data)
	let updatedList = !IsListEmpty(list) ? list.map((batchmate) => {
		return ParsedBatchmate(batchmate);
	}) : [];

	const updatedBatchmateDetails = { updatedList }

	return updatedBatchmateDetails;
}
const ParsedGroupDetails = (list) => {
	const objArray = [];
	Object.keys(list.data).forEach(key => objArray.push({
		learnerStatus: key,
		data: list.data[key]
	}));
	let groupNames = [];
	// console.log(objArray);
	let updatedList = !IsListEmpty(objArray) ? objArray.map((badge) => {
		groupNames = Object.keys(badge.data)
		return ParsedGroupData(badge, groupNames)
	}) : [];

	const pos = groupNames.findIndex(item => item === 'None');
	if (pos > -1) {
		groupNames.splice(pos, 1);
	}

	const updatedGroupDetails = { groupNames, updatedList }

	return updatedGroupDetails;
}
const ParsedLiveSessionScheduleData = (data) => {
	let sortedList1 = SortHelper.sortLIVESessionsByInstructorName(data.live_session_schedule_data)
	let sortedList = SortHelper.sortLIVESessionsByDate(sortedList1)

	let updatedList = !IsListEmpty(sortedList) ? sortedList.map((module) => {

		// let sessionRating = !IsObjectEmpty(module.rating_boring_engaging_data) && !IsStringEmpty(module.rating_boring_engaging_data.submission.rating) ? module.rating_boring_engaging_data.submission.rating > 5 ? (module.rating_boring_engaging_data.submission.rating / 2) : module.rating_boring_engaging_data.submission.rating : 0;

		let sessionRating = !IsObjectEmpty(module.rating_boring_engaging_data) && !IsStringEmpty(module.rating_boring_engaging_data.submission.rating) ? module.rating_boring_engaging_data.submission.feedback_type === 'daily' ? (module.rating_boring_engaging_data.submission.rating / 2) : module.rating_boring_engaging_data.submission.rating : 0;

		let feedbackSubmissions = !IsObjectEmpty(module.rating_boring_engaging_data) && !IsObjectEmpty(module.rating_boring_engaging_data.submission) ? module.rating_boring_engaging_data.submission.total_submissions : !IsStringEmpty(module.feedback_responses) ? module.feedback_responses : 0;

		return {
			batchCode: !IsStringEmpty(module.batch_code) ? module.batch_code : '-',
			instructorName: !IsStringEmpty(module.instructor_name) ? module.instructor_name : '-',
			logo: !IsStringEmpty(module.logo_url) ? module.logo_url : '-',
			moduleName: !IsStringEmpty(module.module_name) ? module.module_name : '-',
			recordingStatus: !IsStringEmpty(module.recording_status) ? module.recording_status : '-',
			scheduledTime: !IsStringEmpty(module.schedule_time) ? parseTimeForDate(module.schedule_time) : '-',
			// sessionRating: !IsStringEmpty(module.session_raitng) ? Math.round(module.session_raitng / 10) : '-',
			startTime: !IsStringEmpty(module.start_time) ? parseTimeForDate(module.start_time) : 'NA',
			status: !IsStringEmpty(module.status) ? module.status : '-',
			studentsAttended: !IsStringEmpty(module.student_attended) ? module.student_attended : '-',
			topicCovered: !IsStringEmpty(module.topic_covered) ? module.topic_covered : '-',
			topicName: !IsStringEmpty(module.topic_name) ? module.topic_name : '-',
			totalActiveStudents: !IsStringEmpty(module.total_active_students) ? module.total_active_students : '-',
			topicID: !IsStringEmpty(module.topic_id) ? module.topic_id : '-',
			zoomAccount: !IsStringEmpty(module.zoom_account) ? module.zoom_account : "-",
			feedbackResponses: !IsStringEmpty(feedbackSubmissions) ? feedbackSubmissions : !IsStringEmpty(module.feedback_responses) ? module.feedback_responses : 0,
			sessionRating: sessionRating.toFixed(1),
			sessionEngagementCount: !IsObjectEmpty(module.rating_boring_engaging_data)
				? {
					boring: module.rating_boring_engaging_data.submission.boring_count,
					engaging: module.rating_boring_engaging_data.submission.engaging_count
				}
				: { boring: 0, engaging: 0 }
		}
	}) : []

	let updatedData = {
		liveSessionScheduleData: updatedList,
	}
	return updatedData;
}

const ParsedProgramTemplateData = (data) => {

	const modulesList = !IsListEmpty(data.modules)
		? data.modules.map(module => {
			return { id: module.id, name: module.name, selected: false }
		})
		: [{ name: 'Not Found', selected: false, id: -1 }];

	const programManagersList = !IsListEmpty(data.program_managers)
		? data.program_managers.map(pm => {
			let fullName = getName(pm.user__first_name, pm.user__last_name, '');
			return { id: pm.user__id, name: fullName + " (" + pm.user__email + ")", selected: false }
		})
		: [{ id: -1, name: 'Not Found' }];

	const mdCoursesList = !IsListEmpty(data.course_list) ? data.course_list.map((course) => {
		return { id: course.course_id, name: course.title }
	}) : [];

	mdCoursesList.unshift({ id: -1, name: '-' })

	let updatedData = {
		modulesList,
		programManagersList,
		mdCoursesList,
		programName: !IsObjectEmpty(data.template) && !IsStringEmpty(data.template.name) ? data.template.name : '',
		certificationsCount: !IsObjectEmpty(data.template) && !IsStringEmpty(data.template.no_of_certifications) ? data.template.no_of_certifications : 0
	}

	return updatedData;
}

const ParsedModuleTemplateData = (data, forEditForm) => {

	let updatedData = {};

	if (forEditForm === true) {

		const selectedInstructorsList = !IsListEmpty(data.module.instructors)
			? data.module.instructors.map(instructor => {
				let fullName = getName(instructor.first_name, instructor.last_name, '');
				return {
					id: instructor.id,
					name: fullName,
					email: instructor.email,
					selected: true
				}
			}) : [];

		const instructorsList = !IsListEmpty(data.instructors)
			? data.instructors.map(item => {
				const isSelected = !IsListEmpty(data.module.instructors)
					? data.module.instructors.findIndex(instructor => instructor.email === item.user__email) !== -1 ? true : false
					: false

				return {
					id: item.user__id,
					name: getName(item.user__first_name, item.user__last_name, ''),
					email: item.user__email,
					selected: isSelected
				}
			})
			: [{ name: 'Not Found' }];

		const moduleDetails = !IsObjectEmpty(data.module) ? {
			id: data.module.id,
			moduleName: data.module.name,
			startDate: !IsStringEmpty(data.module.start_date) ? parseDateForInputField(data.module.start_date) : '',
			endDate: !IsStringEmpty(data.module.end_date) ? parseDateForInputField(data.module.end_date) : '',
			logo: data.module.thumbnail,
			batchCode: data.module.batch_code,
			currentInstructor: {
				id: data.module.current_instructor.id,
				name: getName(data.module.current_instructor.first_name, data.module.current_instructor.last_name, ''),
				email: data.module.current_instructor.email,
			},
			moduleDescription: data.module.live_course_description,
			moduleThumbnail: data.module.live_course_thumbnail,
			title: data.module.live_course_title,
			whatWillYouLearn: data.module.live_course_what_will_you_learn,
			skillsYouLearn: data.module.skills,
			categories: data.module.categories,
			courseRating: data.module.live_course_rating,
			instructorRating: data.module.live_course_instructor_rating,
			isLive: data.is_live,
		} : { id: '', name: '', logo: '', batchCode: '' };

		updatedData = {
			instructorsList: instructorsList,
			moduleDetails: moduleDetails,
			selectedInstructorsList: selectedInstructorsList
		}
	} else {
		let instructorsList = !IsListEmpty(data.instructors)
			? data.instructors.map(item => {
				return {
					instructorId: item.id,
					id: item.user__id,
					name: getName(item.user__first_name, item.user__last_name, ''),
					email: item.user__email,
					userName: !IsStringEmpty(item.user__username) ? item.user__username : ''
				}
			})
			: [{ name: 'Not Found' }];
		instructorsList = SortHelper.sortInstructorListByName(instructorsList);
		let programsList = !IsListEmpty(data.programs)
			? data.programs.map(item => {
				return { name: item.batch_code }
			})
			: [{ name: 'Not Found' }];
		programsList = SortHelper.sortProgramListByBatchCode(programsList);

		let programList = !IsListEmpty(data.my_programs) ?
			data.my_programs.map(item => {
				return { name: item.batch_code }
			})
			: [{ name: 'Not Found' }];
		programList = SortHelper.sortProgramListByBatchCode(programList);

		updatedData = {
			instructorsList, programsList, programList
		}
	}
	return updatedData;
}

const ParsedPerformanceAttendanceByWeeks = (data) => {
	const dataList = !IsListEmpty(data.week_wise_data) ? data.week_wise_data.map((week) => {
		return {
			attendancePercentage: !IsStringEmpty(week.attendance_percentage) ? week.attendance_percentage : '',
			weekEndDate: !IsStringEmpty(week.week_end_date) ? parseDate(week.week_end_date, false, true) : '',
			weekStartDate: !IsStringEmpty(week.week_start_date) ? parseDate(week.week_start_date, false, true) : '',
		}
	}) : [];
	let updatedList = {
		performanceChartData: dataList
	}

	return updatedList;
}

const ParsedPerformanceAttendanceByMonths = (data) => {
	const dataList = !IsListEmpty(data.week_wise_data) ? data.week_wise_data.map((item) => {
		return {
			attendancePercentage: item.attendance_percentage,
			month: item.month
		}
	}) : [];
	let updatedList = {
		performanceChartData: dataList
	}

	return updatedList;
}

const ParsedPerformanceClassGradesByWeeks = (data) => {
	const dataList = !IsListEmpty(data.week_wise_data) ? data.week_wise_data.map((week) => {
		return {
			avgGrades: !IsStringEmpty(week.avg_grades) ? Math.floor(week.avg_grades) : '',
			weekEndDate: !IsStringEmpty(week.week_end_date) ? parseDate(week.week_end_date, false, true) : '',
			weekStartDate: !IsStringEmpty(week.week_start_date) ? parseDate(week.week_start_date, false, true) : '',
		}
	}) : [];
	let updatedList = {
		performanceChartData: dataList
	}

	return updatedList;
}

const ParsedPerformanceClassGradesByMonths = (data) => {
	const dataList = !IsListEmpty(data.week_wise_data) ? data.week_wise_data.map((item) => {
		return {
			avgGrades: !IsStringEmpty(item.avg_grades) ? Math.floor(item.avg_grades) : '',
			month: item.month
		}
	}) : [];
	let updatedList = {
		performanceChartData: dataList
	}

	return updatedList;
}

const ParsedEditProgramData = (data) => {

	const programManagersList = !IsListEmpty(data.program_managers)
		? data.program_managers.map(pm => {
			let fullName = getName(pm.user__first_name, pm.user__last_name, '');

			const isSelected = !IsListEmpty(data.program.program_managers)
				? data.program.program_managers.findIndex(item => item.email === pm.user__email) !== -1 ? true : false
				: false

			return {
				id: pm.user__id,
				name: fullName + " (" + pm.user__email + ")",
				selected: isSelected
			}
		})
		: [{ id: -1, name: 'Not Found' }];

	const selectedPMList = !IsListEmpty(data.program.program_managers)
		? data.program.program_managers.map(pm => {
			let fullName = getName(pm.first_name, pm.last_name, '');
			return {
				id: pm.id,
				name: fullName + " (" + pm.email + ")",
				selected: true
			}
		}) : [];

	const programData = !IsObjectEmpty(data.program) ? {
		name: !IsStringEmpty(data.program.name) ? data.program.name : '',
		programBatchcode: !IsStringEmpty(data.program.batch_code) ? data.program.batch_code : '',
		startDate: !IsStringEmpty(data.program.start_date) ? parseDateForInputField(data.program.start_date) : '',
		endDate: !IsStringEmpty(data.program.end_date) ? parseDateForInputField(data.program.end_date) : '',
		logo: !IsStringEmpty(data.program.thumbnail) ? data.program.thumbnail : '',
		gamification: data.program.is_b2c,
		placements: data.program.placements,
		community: data.program.community,
		programType: data.program.type,
		enableJRS: data.program.enable_jrs,
		certificationsCount: data.program.no_of_certifications,
		courseId: !IsStringEmpty(data.program.course_id) ? data.program.course_id : -1
	} : {
		name: '',
		programBatchcode: '',
		startDate: '',
		endDate: '',
		logo: '',
		gamification: false,
		placements: false,
		community: false,
		programType: 'edyoda',
		enableJRS: false,
		courseId: 0
	}

	const mdCoursesList = !IsListEmpty(data.course_list) ? data.course_list.map((course) => {
		return { id: course.course_id, name: course.title }
	}) : [];

	mdCoursesList.unshift({ id: -1, name: '-' })

	let updatedData = { programManagersList, selectedPMList, programData, mdCoursesList }

	return updatedData;
}

const parsedDashboardCertificationsData = (response) => {

	let activeCertifications = [], completedCertifications = [], data = {};

	for (var i = 0; i < response.length; i++) {
		data = response[i];
		if (data.result.toLowerCase() !== 'passed' && data.result.toLowerCase() !== 'failed') {
			const progressObj = calculateProgress(data.rounds_completed, data.total_rounds, false);
			activeCertifications.push({
				id: data.certification_id,
				attemptNumber: data.attempt_number,
				logo: data.logo,
				title: data.title,
				status: !IsStringEmpty(data.status) ? data.status.toUpperCase() : '-',
				result: !IsStringEmpty(data.result) ? data.result.toUpperCase() : '-',
				maxScore: !IsStringEmpty(data.max_score) ? data.max_score : 0,
				totalRounds: !IsStringEmpty(data.total_rounds) ? data.total_rounds : 0,
				roundsCompleted: !IsStringEmpty(data.rounds_completed) ? data.rounds_completed : 0,
				progress: progressObj.value,
				progressLabel: progressObj.label,
				overallTotalScore: returnNumber(data.max_score),
				certificationCode: !IsStringEmpty(data.certification_code) ? data.certification_code : '-',
				completionDate: !IsStringEmpty(data.certification_completion_date) ? parseDate(data.certification_completion_date, false, false) : '-'
			});
		} else {
			const progressObj = calculateProgress(data.rounds_completed, data.total_rounds, false);
			completedCertifications.push({
				id: data.certification_id,
				attemptNumber: data.attempt_number,
				logo: data.logo,
				title: data.title,
				status: !IsStringEmpty(data.status) ? data.status.toUpperCase() : '-',
				result: !IsStringEmpty(data.result) ? data.result.toUpperCase() : '-',
				maxScore: !IsStringEmpty(data.max_score) ? data.max_score : 0,
				totalRounds: !IsStringEmpty(data.total_rounds) ? data.total_rounds : 0,
				roundsCompleted: !IsStringEmpty(data.rounds_completed) ? data.rounds_completed : 0,
				progress: progressObj.value,
				progressLabel: progressObj.label,
				overallTotalScore: returnNumber(data.max_score),
				certificationCode: !IsStringEmpty(data.certification_code) ? data.certification_code : '-',
				completionDate: !IsStringEmpty(data.certification_completion_date) ? parseDate(data.certification_completion_date, false, false) : '-'
			});
		}
	}

	return {
		activeCertifications: activeCertifications,
		completedCertifications: completedCertifications
	}
}

const parsedAllDashboardCertificationsData = (data) => {
	const parsedData = data.map((data) => {
		const progressObj = calculateProgress(data.rounds_completed, data.total_rounds, false);
		return {
			id: data.certification_id,
			batchCode: !IsListEmpty(data.batch_code) ? data.batch_code : 'Not Added',
			enrolmentId: !IsStringEmpty(data.enrolment_id) ? data.enrolment_id : null,
			attemptNumber: data.attempt_number,
			logo: data.logo,
			title: data.title,
			status: !IsStringEmpty(data.status) ? data.status : '-',
			result: !IsStringEmpty(data.result) ? data.result : '-',
			maxScore: !IsStringEmpty(data.max_score) ? data.max_score : 0,
			totalRounds: !IsStringEmpty(data.total_rounds) ? data.total_rounds : 0,
			roundsCompleted: !IsStringEmpty(data.rounds_completed) ? data.rounds_completed : 0,
			progress: progressObj.value,
			progressLabel: progressObj.label,
			overallTotalScore: returnNumber(data.max_score),
			certificationCode: !IsStringEmpty(data.certification_code) ? data.certification_code : '-',
			completionDate: !IsStringEmpty(data.certification_completion_date) ? parseDate(data.certification_completion_date, false, false) : '-',
			scheduledDate: !IsStringEmpty(data.certification_scheduled_date) ? data.certification_scheduled_date : "-"
		}
	})

	return parsedData;
}

const parseActiveCertificationData = (data) => {
	const progressObj = calculateProgress(data.rounds_completed, data.total_rounds, false);
	return {
		logo: data.logo,
		title: data.title,
		status: !IsStringEmpty(data.status) ? data.status.toUpperCase() : '-',
		result: !IsStringEmpty(data.result) ? data.result.toUpperCase() : '-',
		maxScore: !IsStringEmpty(data.max_score) ? data.max_score : 0,
		totalRounds: !IsStringEmpty(data.total_rounds) ? data.total_rounds : 0,
		roundsCompleted: !IsStringEmpty(data.rounds_completed) ? data.rounds_completed : 0,
		progress: progressObj.value,
		progressLabel: progressObj.label,
		overallTotalScore: returnNumber(data.max_score),
		certificationCode: !IsStringEmpty(data.certification_code) ? data.certification_code : '-',
		completionDate: !IsStringEmpty(data.certification_completion_date) ? parseDate(data.certification_completion_date, false, false) : '-',
		certificateURL: !IsStringEmpty(data.certificate) ? data.certificate : '',
		autoGraded: data.auto_graded === "No" ? false : true,
		scheduledDatesList: !IsStringEmpty(data.scheduled_dates_list) ? data.scheduled_dates_list.split(",") : [],
	}
}

const ParsedCertificationDetailsData = (data, isPM) => {

	let certificationData = parseActiveCertificationData(data);

	const totalRounds = !IsObjectEmpty(data.round_data) ? Object.keys(data.round_data) : [];

	let roundsData = [], round = null, overallScoreReceived = 0, overallPassingScore = 0;

	if (totalRounds.length > 0) {
		for (var i = 0; i < totalRounds.length; i++) {
			round = data.round_data[totalRounds[i]];

			const activeButton = !IsStringEmpty(round.schedule_date) && new Date(round.schedule_date).getTime() < Date.now() ? true : false;

			overallScoreReceived += returnNumber(round.marks_scored);
			overallPassingScore += returnNumber(round.passing_marks);

			const linksSubmitted = !IsStringEmpty(round.project_links.code_file_url) ||
				!IsStringEmpty(round.project_links.hosted_web_url) || !IsStringEmpty(round.project_links.public_video_url)
				? true : false;

			let enableStartButton = true;
			let hideSubmitButton = false;
			let scheduledDateTime = new Date(round.schedule_date);
			let dueDateTime = new Date(scheduledDateTime.getTime() + (round.duration < 60 ? round.duration * 60 : round.duration) * 60 * 1000);
			if (i > 0) {
				const prevRound = data.round_data[totalRounds[i - 1]];
				enableStartButton = !IsObjectEmpty(prevRound) && scheduledDateTime < new Date() ? true : false;
			}

			// Above 60 is used in condition because in backend the condition is added like => duration is in minutes if its > 60 and consider the duration in Hours if its < 60
			// Need to change this in next code push
			hideSubmitButton = dueDateTime.getTime() < Date.now();

			let resultDate = !IsStringEmpty(dueDateTime) ? new Date(dueDateTime.getTime() + 21 * 86400 * 1000) : '';
			// Here 21 is used for 21 days = 3 Weeks

			roundsData.push({
				round: i + 1,
				title: round.title,
				mcq: round.mcq,
				roundStatus: !IsStringEmpty(round.status) ? isPM ? round.status : round.status.toUpperCase() : '-',
				roundResult: !IsStringEmpty(round.result) ? isPM ? round.result : round.result.toUpperCase() : '-',
				certificationStatus: !IsStringEmpty(data.status) ? data.status.toUpperCase() : '-',
				certificationResult: !IsStringEmpty(data.result) ? data.result.toUpperCase() : '-',
				coding: round.coding,
				project: round.project,
				duration: !IsStringEmpty(round.duration) ? round.duration : 0,
				totalMarks: !IsStringEmpty(round.total_marks) ? round.total_marks : 0,
				passingMarks: !IsStringEmpty(round.passing_marks) ? round.passing_marks : 0,
				marksScored: !IsStringEmpty(round.marks_scored) ? round.marks_scored : 0,
				instructions: !IsListEmpty(round.instructions) ? round.instructions : [],
				curriculumLink: !IsStringEmpty(round.curriculum) ? round.curriculum : '',
				scheduleDate: !IsStringEmpty(round.schedule_date) ? isPM ? round.schedule_date : parseDate(round.schedule_date, false, true) : '-',
				scheduleTime: !IsStringEmpty(round.schedule_date) ? parseTimeForDate(round.schedule_date, false, true) : '-',
				dueDate: !IsStringEmpty(dueDateTime) ? parseDate(dueDateTime, false, true) : '-',
				dueTime: !IsStringEmpty(dueDateTime) ? parseTimeForDate(dueDateTime, false, true) : '-',
				examUrl: !IsStringEmpty(round.exam_url) ? round.exam_url : '',
				reportLink: !IsStringEmpty(round.student_report) ? round.student_report : '',
				activateStartButton: activeButton,
				roundCode: !IsStringEmpty(round.round_code) ? round.round_code : '-',
				projectLinks: {
					codeFileUrl: round.project_links.code_file_url,
					hostedWebUrl: round.project_links.hosted_web_url,
					publicVideoUrl: round.project_links.public_video_url
				},
				projectLinksSubmitted: linksSubmitted,
				enableStartExamButton: enableStartButton,
				hideSubmitButton: hideSubmitButton,
				resultDate: !IsStringEmpty(resultDate) ? parseDate(resultDate, false, true) : '-',
				examSet: !IsStringEmpty(round.exam_set) ? round.exam_set : "None",
				autoGraded: !IsStringEmpty(data.auto_graded) ? data.auto_graded : "-",
				scheduledList: !IsStringEmpty(data.scheduled_dates_list) ? data.scheduled_dates_list.split(",") : [],
			});
		}
	}


	certificationData['overallScoreReceived'] = overallScoreReceived;
	certificationData['overallPassingScore'] = overallPassingScore;

	let passingPercentage = calculateProgress(overallPassingScore, certificationData.overallTotalScore, false),
		receivedScorePercentage = calculateProgress(overallScoreReceived, certificationData.overallTotalScore, false);

	certificationData['percentagePass'] = passingPercentage.value;
	certificationData['percentageScored'] = (overallScoreReceived / certificationData.overallTotalScore * 100).toFixed(2);
	certificationData['nextRoundEnrolled'] = data.next_attempt_enrollment_status;
	certificationData['batchCode'] = data.batch_code;



	const updatedData = {
		activeCertificationData: certificationData,
		roundsData: roundsData,
		freeCertificationReattemptReward: {
			rewardStatus: data.certification_reattempt_reward_status,
			rewardId: data.certification_reattempt_reward_id
		}
	}

	return updatedData;
}

const parsedCertificationResources = (data) => {

	const videoFiles = !IsListEmpty(data.video_file) ? data.video_file.map((video) => {
		return {
			videoId: !IsStringEmpty(video.video_id) ? video.video_id : '',
			videoTitle: !IsStringEmpty(video.name) ? video.name : '',
			duration: !IsStringEmpty(video.duration) ? video.duration : '00:00'
		}
	}) : [];

	const pdfFiles = !IsListEmpty(data.pdf_file) ? data.pdf_file.map(pdfFile => {
		return {
			type: 'pdf',
			id: pdfFile.id,
			title: pdfFile.name,
			link: pdfFile.pdf_url
		}
	}) : [];

	const slideFiles = !IsListEmpty(data.slide_file) ? data.slide_file.map(slideFile => {
		return {
			type: 'slide',
			id: slideFile.id,
			title: slideFile.name,
			link: slideFile.slide_url
		}
	}) : [];

	const otherFiles = !IsListEmpty(data.other_file) ? data.other_file.map(otherFile => {
		return {
			type: 'other',
			id: otherFile.id,
			title: otherFile.name,
			link: otherFile.other_file_url,
			fileContent: otherFile.file_content
		}
	}) : [];

	const embedFiles = !IsListEmpty(data.embed_link) ? data.embed_link.map(embedLink => {
		return {
			type: 'embed',
			id: embedLink.id,
			title: embedLink.name,
			link: embedLink.link
		}
	}) : [];


	const resources = {
		videoFiles: videoFiles,
		files: [...pdfFiles, ...slideFiles, ...otherFiles, ...embedFiles]
	}

	return resources;
}

const ParsedUpcomingCertificates = (list) => {
	let updatedList = !IsListEmpty(list) ? list.map((certificate) => {
		let roundDetails = certificate.round_details.map((round) => {
			return ({
				roundNumber: round.round_number,
				roundTypes: round.round_types
			})
		})
		return ({
			logo: certificate.logo,
			attemptNumber: certificate.attempt_number,
			certificationName: certificate.certification_name,
			status: certificate.status,
			roundDetails: roundDetails,
			scheduleDate: certificate.schedule_date,
			certificationCode: certificate.certification_code,
			batchCode: certificate.batch_code
		});
	}) : [];
	// console.log(updatedList)
	return updatedList
}

const ParsedCertificationList = (certifications) => {

	let rounds = certifications.active_certification.rounds.map((round) => {
		return ({
			certification: round.certification,
			code: round.code,
			coding: round.coding,
			description: round.description,
			duration: round.duration,
			enrolmentDate: round.enrolment_date,
			marksScored: round.marks_scored,
			enrolmentDate: round.enrolment_date,
			mcq: round.mcq,
			paymentStatus: round.payment_status,
			project: round.project,
			result: round.result,
			round: round.round,
			roundNumber: round.round_number,
			scheduledDate: parseDate(round.scheduled_date, false, true),
			scheduledTime: parseTimeForDate(round.scheduled_date),
			dueDate: round.due_date,
			status: round.status,
			totalMarks: round.total_marks,
			scheduledDatesList: !IsStringEmpty(round.scheduled_dates_list) ? round.scheduled_dates_list.split(',') : []
		})
	})

	let updatedList = !IsListEmpty(certifications.certifications_list) ? certifications.certifications_list.map((certificate) => {
		return ({
			certificationCode: certificate.certification_code,
			certification: certificate.certification,
			scheduledDate: certificate.scheduled_date,
			certificationId: certificate.certification_id,
			enrolmentId: certificate.enrolment_id,
			logo: certificate.logo,
			status: certificate.status,
			result: certificate.result,
			numberOfAttempts: certifications.active_certification.number_of_attempts_enrolled
		});
	}) : [];

	let activeCertification = {
		certificationCode: certifications.active_certification.certification_code,
		logo: certifications.active_certification.logo,
		numberOfAttemptsEnrolled: certifications.active_certification.number_of_attempts_enrolled,
		overallScore: certifications.active_certification.overall_score,
		certificationDetails: rounds,
		latestAttemptResult: certifications.latest_attempt_result,
		latestAttemptStatus: certifications.latest_attempt_status
	}

	return {
		certificationsList: updatedList,
		activeCertification: activeCertification
	}
}

const ParsedCertificationSectionCertificateDetails = (certification) => {

	let certificationCode = "";

	let updatedList = !IsListEmpty(certification.certification_details) ? certification.certification_details.map((round) => {
		certificationCode = round.code
		return ({
			attemptNumber: round.attempt_number,
			batchCode: round.batch_code,
			certification: round.certification,
			code: round.code,
			coding: round.coding,
			description: round.description,
			duration: round.duration,
			enrolmentDate: round.enrolment_date,
			marksScored: round.marks_scored,
			enrolmentDate: round.enrolment_date,
			mcq: round.mcq,
			paymentStatus: round.payment_status,
			project: round.project,
			result: round.result,
			round: round.round,
			roundNumber: round.round_number,
			scheduledDate: parseDate(round.scheduled_date, false, true),
			scheduledTime: parseTimeForDate(round.scheduled_date),
			dueDate: round.due_date,
			status: round.status,
			totalMarks: round.total_marks,
		});
	}) : [];

	return {
		certificationCode,
		certificationDetails: updatedList,
		numberOfAttemptsEnrolled: certification.number_of_attempts_enrolled,
		overallScore: certification.overall_score,
		logo: certification.logo,
		latestAttemptResult: certification.latest_attempt_result,
		latestAttemptStatus: certification.latest_attempt_status,
		scheduledDatesList: !IsStringEmpty(certification.scheduled_dates_list) ? certification.scheduled_dates_list.split(",") : []
	}
}

const ParsedCompleteCertificationData = (certifications) => {

	let updatedList = !IsListEmpty(certifications.certifications_enrolled) ? certifications.certifications_enrolled.map((certificate) => {
		return ({
			certificationCode: certificate.certification_code,
			certification: certificate.certification,
			scheduledDate: certificate.scheduled_date,
			certificationId: certificate.certification_id
		});
	}) : [];

	let rounds = certifications.certification_details.map((round) => {
		return ({
			attemptNumber: round.attempt_number,
			batchCode: round.batch_code,
			certification: round.certification,
			code: round.code,
			coding: round.coding,
			description: round.description,
			duration: round.duration,
			enrolmentDate: round.enrolment_date,
			marksScored: round.marks_scored,
			enrolmentDate: round.enrolment_date,
			mcq: round.mcq,
			paymentStatus: round.payment_status,
			project: round.project,
			result: round.result,
			round: round.round,
			roundNumber: round.round_number,
			scheduledDate: parseDate(round.scheduled_date, false, true),
			scheduledTime: parseTimeForDate(round.scheduled_date),
			dueDate: round.due_date,
			status: round.status,
			totalMarks: round.total_marks,
		})
	})

	let activeCertification = {
		certificationCode: certifications.certification_details[0].code,
		logo: certifications.logo,
		numberOfAttemptsEnrolled: certifications.number_of_attempts_enrolled,
		overallScore: certifications.overall_score,
		certificationDetails: rounds,
		latestAttemptResult: certifications.latest_attempt_result,
		latestAttemptStatus: certifications.latest_attempt_status,
		scheduledDatesList: !IsStringEmpty(certifications.scheduled_dates_list) ? certifications.scheduled_dates_list.split(",") : []
	}

	// console.log(updatedList)

	return {
		certificationsList: updatedList,
		activeCertification: activeCertification
	}
}

const numDifferentiation = (value) => {
	var val = Math.abs(value)
	if (val >= 10000000) {
		val = (val / 10000000).toFixed(1) + ' Cr';
	} else if (val >= 100000) {
		val = (val / 100000).toFixed(1) + ' Lac';
	}
	return val;
}

const ParsedAllJobs = (data) => {
	const parsedData = data.reduce((result, job) => {
		if (job.custom_fields[5].value !== "Classroom")
			result.push({
				id: job.id,
				slug: job.slug,
				title: job.name,
				location: job.city,
				numberOfOpenings: job.number_of_openings,
				ctc: `${numDifferentiation(job.min_annual_salary)} - ${numDifferentiation(job.max_annual_salary)}`,
				customFields: job.custom_fields,
				applyBy: parseDate(job.custom_fields.find(field => field.field_name === "Due Date to Apply").value) + ", " + "10:00 PM",
				createdOn: Math.round((new Date() - new Date(job.created_on)) / (60 * 60 * 24 * 1000)),
				date: job.created_on
			})
		return result;
	}, []);
	return parsedData
}

const ParsedJobDetails = (data) => {
	const applyBy = parseDate(data.custom_fields.find(field => field.field_name === "Due Date to Apply").value) + ", " + "10:00 PM"
	const parsedData = {
		id: data.id,
		slug: data.slug,
		title: data.name,
		location: data.city,
		numberOfOpenings: data.number_of_openings,
		ctc: `${numDifferentiation(data.min_annual_salary)} - ${numDifferentiation(data.max_annual_salary)}`,
		customFields: data.custom_fields,
		aboutCompany: data.job_description_text,
		applyBy: applyBy,
		date: data.created_on,
		createdOn: Math.round((new Date() - new Date(data.created_on)) / (60 * 60 * 24 * 1000)),
		jobStatus: data.job_status.label
	}
	return parsedData
}

const ParsedCompanyData = (data) => {
	const parsedData = {
		id: data.id,
		companyName: data.company_name,
		logo: data.logo,
		slug: data.slug
	}
	return parsedData
}

const ParsedStageHistoryOfAllJobs = (data) => {
	if (data === 'Not Assigned')
		return [];
	const parsedData = data.map(job => {
		return ({
			jobSlug: job.job_slug,
			status: job.status
		})
	})
	return parsedData
}

const ParsedJobsReportResponse = (data) => {
	let studentsList = data.student_list;
	let updatedList = studentsList.sort(function (a, b) {
		return b[1].days_since_last_applied - a[1].days_since_last_applied;
	});

	const updatedData = {
		student_list: updatedList,
		student_applied_for_job: data.student_applied_for_job,
		total_student_in_batch: data.total_student_in_batch,
		student_active_inlast_seven_days: data.student_active_inlast_seven_days,
	}
	return updatedData;
}

const ParsedMissedSessionsResponse = (data) => {
	let studentsList = !IsObjectEmpty(data.student_list) ? Object.values(data.student_list) : [];
	let updatedList = !IsListEmpty(studentsList) ? studentsList.sort(function (a, b) {
		return b.max_consecutive_session_missed - a.max_consecutive_session_missed;
	}) : [];

	const updatedData = {
		student_list: updatedList
	}
	return updatedData;
}

const ParsedInstructorPaymentReportResponse = (value) => {
	const mappedData = {
		totalDurations: value.total_durations,
		totalPayment: value.total_payment,
		data: value.data.map(value => {
			return {
				batchCode: value.batch_code,
				moduleName: value.module_name,
				scheduleDateTime: value.schedule_date_time,
				sessionDuration: value.session_duration,
				sessionPayment: value.session_payment,
				topicName: value.topic_name,
				instructor: value.instructor,
				startedBy: !IsStringEmpty(value.instructor_full_name) ? value.instructor_full_name : '-',
			}
		})
	}
	return mappedData;
}
const ParsedEmailReportResponse = (value) => {
	const mappedData = {
		data: value.map(value => {
			return {
				id: value.id,
				name: value.name,
				state: value.state,
				positionalArguments: value.positional_arguments,
				resultData: value.result_data,
				traceback: value.traceback,
				completedDateTime: getFullDateTime(value.completed_date_time),
			}
		})
	}
	return mappedData;
}

const ParsedAttendanceDashboardReportResponse = (value) => {
	const mappedData = {
		totalAttendance: value.total_attendance,
		data: value.data.map(value => {
			return {
				moduleName: value.module_name,
				scheduleDateTime: value.schedule_date_time,
				topicName: value.topic_name,
				studentAttended: value.attendance_count
			}
		})
	}
	return mappedData;
}
const ParsedInstructoreDashboardReportResponse = (value) => {
	const mappedData = {
		avgReportCardData: value.average_report_card_data,
		boringEngaging: value.average_report_card_data.rating_boring_engaging,
		attendance: value.average_report_card_data.attendance,
	}
	return mappedData;
}
const ParsedModuleCostResponse = (response) => {
	const mappedPayments = response.data.map(value => value.total_payment);

	const mappedData = response.data.map(value => {

		return {
			batchCode: value.batch_code,
			instructor: value.instructor_name,
			moduleName: value.module_name,
			sessionDuration: value.session_duration,
			totalPayment: value.total_payment,
		}
	})

	const updatedData = {
		totalPayments: mappedPayments.reduce((value, a) => value + a, 0),
		data: mappedData
	}
	return updatedData;
}

const ParsedActiveFor30Days = (response) => {
	const mappedData = response.student_list.map((value) => {
		const filteredBatchcode = value.batch_code.filter((value) => {
			if (value !== "PPT160522" && value !== "ATP161220" && value !== "PY041220" && value !== "WD071120") {
				return value
			};
		})
		return {
			batchCode: filteredBatchcode,
			contact: !IsStringEmpty(value.contact) ? value.contact : "-",
			dateLastApplied: value.days_since_last_applied,
			email: value.email,
			name: value.name,
			totalJobsApplied: value.total_jobs_applied,
		}
	});
	return mappedData;
}

const ParsedBatchwiseCertificationData = (data) => {
	let parsedData = [];

	let allKeys = data.map(val => Object.keys(val));

	for (let i = 0; i < data.length; i++) {
		let newData = {
			name: allKeys[i][0],
			certificationName: allKeys[i][0],
			certificationCode: data[i][allKeys[i][0]].certification_code,
			totalCompleted: data[i][allKeys[i][0]].total_completed,
			totalEnrolled: data[i][allKeys[i][0]].total_enrolled,
			totalFailed: data[i][allKeys[i][0]].total_failed,
			totalInProgress: data[i][allKeys[i][0]].total_in_progress,
			totalNotAttempted: data[i][allKeys[i][0]].total_not_attempted,
			totalPassed: data[i][allKeys[i][0]].total_passed,
			totalUpcoming: data[i][allKeys[i][0]].total_upcoming,
			certificateCode: data[i][allKeys[i][0]].certification_code,
		}
		parsedData.push(newData)
	}

	return parsedData;
}
const ParsedBatchwiseActiveStudentData = (data) => {
	const parsedData = data.map(value => {
		return {
			batchCode: !IsStringEmpty(value.batch_code) ? value.batch_code : "-",
			name: !IsStringEmpty(value.batch_code) ? value.batch_code : "-",
			totalEnrolled: value.total_students,
			active: value.active_students,
			dropOut: value.inactive_students,
			accessRevoked: value.access_revoked_students,
		}
	})
	return parsedData;
}

const ParsedActiveStudentData = (data) => {

	const parsedData = data.map(value => {

		return {
			name: !IsStringEmpty(value.name) ? value.name : "-",
			email: !IsStringEmpty(value.email) ? value.email : "-",
			userName: !IsStringEmpty(value.username) ? value.username : "",
			status: value.status === 'inactive' ? 'DROP OUT' : value.status.toUpperCase(),
		}
	})

	return parsedData;
}

const ParsedBatchwiseCertificationPassStudentData = (data) => {

	const parsedData = data.map(value => {

		return {
			name: !IsStringEmpty(value.name) ? value.name : "-",
			email: !IsStringEmpty(value.email) ? value.email : "-",
			contact: !IsStringEmpty(value.contact) ? value.contact : "-",
			percentage: (value.percentage !== 0) ? value.percentage.toFixed(2) : 0,
			attemptNumber: !IsStringEmpty(value.attempt_number) ? value.attempt_number : "-",
			status: value.status,
			result: value.result,
			scheduled_at: value.scheduled_at,
		}
	})

	return parsedData;
}

const ParsedBatchwiseAttendance = (data) => {
	let attendanceList = data.attendance;

	let allUserId = Object.keys(data.attendance);

	let allAttendance = [];

	for (let i = 0; i < allUserId.length; i++) {
		allAttendance.push(attendanceList[allUserId[i]]);
	}

	let finalArray = [];

	for (let i = 0; i < allAttendance.length; i++) {
		finalArray.push({
			name: allAttendance[i].student_fullname,
			attendance: allAttendance[i].average_attendance,
			weeklyAttendanceList: allAttendance[i].weekly_attendance
		})
	}

	let weeklyAttendanceWeeks = Object.keys(finalArray[0].weeklyAttendanceList);

	let weeksResults = [];

	for (let i = 0; i < weeklyAttendanceWeeks.length; i++) {
		let daysKeys = Object.keys(finalArray[0].weeklyAttendanceList[weeklyAttendanceWeeks[i]].days);

		daysKeys.sort((a, b) => {
			return parseTimeForInputField(a.split(",").slice(-1).join("")) < parseTimeForInputField(b.split(",").slice(-1).join("")) ? -1 : 1;
		})

		weeksResults.push({
			days: finalArray[0].weeklyAttendanceList[weeklyAttendanceWeeks[i]].days,
			daysKeys,
			total: finalArray[0].weeklyAttendanceList[weeklyAttendanceWeeks[i]].total,
			totalSessions: finalArray[0].weeklyAttendanceList[weeklyAttendanceWeeks[i]].total_sessions,
			weekName: weeklyAttendanceWeeks[i],
		})
	}

	return {
		userDetails: finalArray,
		userAttendanceList: weeksResults
	};
}

const ParsedLearnerCertificationsListData = (list) => {

	let updatedList = !IsListEmpty(list) ? list.map(item => {

		let overallScoreArr = !IsStringEmpty(item.overall_score) ? item.overall_score.split(' / ') : [];
		let overallScore = !IsListEmpty(overallScoreArr) ? (overallScoreArr[0] / overallScoreArr[1] * 100).toFixed(2) : 0;

		return {
			fullName: !IsStringEmpty(item.full_name) ? item.full_name : '',
			email: !IsStringEmpty(item.email) ? item.email : '',
			userId: !IsStringEmpty(item.user_id) ? item.user_id : '',
			overallStatus: !IsStringEmpty(item.overall_status) ? item.overall_status : '',
			overallResult: !IsStringEmpty(item.overall_result) ? item.overall_result : '',
			scheduledDate: !IsStringEmpty(item.scheduled_date) ? item.scheduled_date : '',
			overallScore: overallScore,
			exam: !IsStringEmpty(item.Exam) ? item.Exam : '',
			batchCode: !IsStringEmpty(item.batch_code) ? item.batch_code : '',
			roundOneStatus: !IsStringEmpty(item.round_one_status) ? item.round_one_status : '',
			roundOneMarks: !IsStringEmpty(item.round_one_marks) ? Math.round(item.round_one_marks) : '',
			roundOneResult: !IsStringEmpty(item.round_one_result) ? item.round_one_result : '',
			roundTwoStatus: !IsStringEmpty(item.round_two_status) ? item.round_two_status : '',
			roundTwoMarks: !IsStringEmpty(item.round_two_marks) ? Math.round(item.round_two_marks) : '',
			roundTwoResult: !IsStringEmpty(item.round_two_result) ? item.round_two_result : '',

			roundTwoLinkCode: !IsStringEmpty(item.round_two_code_file_url) ? item.round_two_code_file_url : '',
			roundTwoLinkHosted: !IsStringEmpty(item.round_two_hosted_web_url) ? item.round_two_hosted_web_url : '',
			roundTwoLinkVideo: !IsStringEmpty(item.round_two_public_video_url) ? item.round_two_public_video_url : '',

			enrollmentId: !IsStringEmpty(item.enrolment_id) ? item.enrolment_id : '',
			course: !IsStringEmpty(item.course) ? item.course : '',
			certificateURL: !IsStringEmpty(item.certificate_url) ? item.certificate_url : '',
		}
	}) : [];

	return updatedList;
}

export const ParsedProgramDates = (data) => {
	if (data !== null && data !== undefined && data.length > 0) {
		const programData = data.map((item) => {
			return {
				batchStartDate: item.batch_start_date,
				saleStartDate: item.sale_start_date,
				startDate: item.start_date,
				url: item.url
			};
		})
		return programData;
	} else {
		return [];
	}
}

export const ParsedCoursesList = (data) => {
	if (!IsListEmpty(data)) {
		const coursesList = data.map((item) => {
			return {
				id: item.id,
				title: item.title,
				logo: item.thumbnail,
				url: item.slug, // Needs to be implemented
				ratings: item.rating,
				startDate: parseDate(item.start_date),
				category: item.category_name,
				level: item.level,
			};
		})
		return coursesList;
	} else {
		return [];
	}
}

export const ParsedCourseDetails = (data) => {
	if (!IsObjectEmpty(data)) {

		const instructorsList = !IsListEmpty(data.instructors) ? data.instructors.map(item => {
			return {
				image: item.profilepicture,
				name: item.name,
				designation: item.bio,
				experience: item.experience.split('|')[0],
				details: item.experience.split('|')[1],
			}
		}) : [];

		const outcomes = !IsStringEmpty(data.learning_outcome) ? data.learning_outcome.split(';').map(item => {
			return {
				title: item.split('|')[0],
				description: item.split('|')[1]
			}
		}) : [];

		const coursesList = {
			id: data.id,
			title: data.title,
			category: data.category_name,
			rating: parseFloat(data.rating),
			duration: data.duration,
			level: data.level,
			shortDescription: data.short_description,
			description: data.overview,
			instructors: instructorsList, // needs to be updated
			cohortStartDate: parseDate(data.start_date),
			courseThumbnail: data.thumbnail,
			courseAudience: data.course_for.split(';'),
			learningOutcomes: outcomes,
			curriculumData: data.curriculum,
			prerequisites: data.prerequisites
		};
		return coursesList;
	} else {
		return [];
	}
}

export const ParsedWhatsappTemplate = (data) => {
	let parameters = !IsStringEmpty(data.parameters) ? data.parameters.split(',') : [];
	let pos = -1
	if (!IsListEmpty(parameters)) {
		pos = parameters.indexOf('name');
		if (pos > -1) {
			parameters.splice(pos, 1)
		}
	}

	let formFields = !IsListEmpty(parameters) ? parameters.map((item) => {
		const name = item.split("_").join(" ")
		return {
			elementType: 'textarea',
			elementConfig: {
				type: 'text'
			},
			value: '',
			label: name,
			disabled: false,
			validation: {
				required: {
					value: true,
					errorMessage: 'This is a required field'
				}
			},
			valid: true,
			touched: false,
			errorMessage: `Please enter a valid ${name}`
		}
	}) : [];

	let formFieldsData = {};

	if (!IsListEmpty(parameters)) {
		parameters.forEach((item, index) => {
			formFieldsData[item.trim()] = formFields[index];
		});
	}

	return {
		name: data.name,
		id: data.template_id,
		preview: data.template,
		fieldsList: parameters,
		formFieldsData
	}
}

export const ParsedWATemplatesList = (list) => {

	const parsedData = !IsListEmpty(list) ? list.map((template) => {
		return {
			id: template.template_id,
			name: template.name
		}
	}) : [];

	return parsedData;
}

export const getParsedRecommendedCourses = (list) => {

	const parsedList = !IsListEmpty(list) ? list.map(category => {

		const coursesList = !IsListEmpty(category.course_list) ? category.course_list.map(course => {
			return {
				id: course.course_id,
				comboIdsList: course.combo_ids,
				title: course.name,
				duration: course.duration + ' Weeks',
				commitment: "Full Time/Part Time",
				mode: "Live Instructor-led Sessions",
				startDate: "",
				seatsFull: false,
				logo: course.course_thumbnail,
				url: course.course_url,
				enrollCount: generateUniqueNumber(course.total_cost, course.course_id),
				actualPrice: course.total_cost,
				discountedPrice: Math.round(course.total_cost * (100 - course.discount_percentage) / 100),
				type: course.course_type,
			}
		}) : [];

		return {
			categoryHeading: category.category_name,
			coursesList: coursesList
		}
	}) : [];

	return parsedList;
}


const calculateDiscountedFees = (total_cost, discount_percentage) => {
	const discounted_cost = total_cost * (1 - discount_percentage / 100);
	const rounded_cost = Math.round(discounted_cost / 50) * 50;
	return rounded_cost;
}

function generateUniqueNumber(totalPrice, courseId) {
	// Combine totalPrice and courseId using a formula that introduces variability
	const combined = totalPrice * (courseId + 1.23); // Add a constant to ensure variation

	// Normalize the combined value to a range between 0 and 1
	const normalized = (Math.sin(combined) + 1) / 2; // Sine function introduces variation and maps to 0-1

	// Scale the normalized value to the range 4 to 9
	const uniqueNumber = 4 + normalized * 5; // Scale to the range of 4-9

	// Limit to one decimal place
	return parseFloat(uniqueNumber.toFixed(1));
}

const ParsedRecommendedMDCourse = (course) => {

	const comboIDs = (course.combo_ids || '').split(',').map(id => Number(id));

	return {
		id: course.course_id,
		comboIDsList: comboIDs,
		title: course.name,
		fullName: course.name,
		duration: course.duration,
		mode: "Live Instructor-led Sessions",
		seatsFull: course.seats_full ? true : false,
		logo: course.course_thumbnail,
		url: course.course_url,
		enrollCount: generateUniqueNumber(course.total_cost, course.course_id),
		actualPrice: course.total_cost,
		discountedPrice: calculateDiscountedFees(course.total_cost, course.discount_percentage),
		type: course.course_type,
		fees: {
			totalFees: course.total_cost,
			discountedFees: calculateDiscountedFees(course.total_cost, course.discount_percentage)
		}
	}
}

export const ParsedMDCourseListingData = (data, forSearch) => {
	if (IsListEmpty(data.course_list_bycategory)) {
		return [];
	}
	// Parse each category and its courses
	const parsedCategories = data.course_list_bycategory.map((category) => {
		const { category_name, category_order, course_list } = category;
		// visibility might be provided under different keys by backend
		const category_visible = (category && (category.category_visible !== undefined
			? category.category_visible
			: (category.visible !== undefined
				? category.visible
				: (category.is_visible !== undefined ? category.is_visible : true))));

		// Parse each course in the category
		const parsedCourses = course_list.map((course) => {
			return ParsedRecommendedMDCourse(course)
		});

		return {
			categoryName: category_name,
			categoryOrder: category_order,
			visible: category_visible,
			courses: parsedCourses,
		};
	});

	if (forSearch !== true) {
		let coursesListForDropdown = [];
		data.course_list_bycategory.forEach(category => {
			category.course_list.map(course => {
				const comboIDs = (course.combo_ids || '').split(',').map(id => Number(id));
				if (coursesListForDropdown.findIndex(courseItem => courseItem.id === course.course_id) === -1) {
					coursesListForDropdown.push({
						id: course.course_id,
						name: course.course_id + '. ' + course.name,
						selected: false,
						idsList: comboIDs,
						type: course.course_type
					})
				}
			});
		})

		return {
			categoryCoursesList: parsedCategories,
			coursesListForPM: coursesListForDropdown.sort((a, b) => a.id - b.id)
		};
	} else {
		return parsedCategories
	}
};

export {
	ParsedError, ParsedEducationSummaryList, parseEducationItem,

	// newly added
	ParsedContinueLearningData, ParsedEnrolledPrograms, parsedProgram, parseFilteredPaginatedProgramsData, parsePaginatedProgramsData, ParseSearchProgramsData, parsedPreviousTopicFeedback, ParsedHomepageModulesData, ParsedModulesPageModulesList, ParsedTopicsList, ParsedModulesList, ParsedUpcomingCertificates,
	ParsedTopicDetails, ParsedNotificationList, ParsedQuizData, ParsedInstructorsList, ParsedInstructorDetails, ParsedQuizResult, ParsedBasicInfo, ParsedCertificationList, ParsedCompleteCertificationData,
	ParsedWorkExperienceList, parseWorkExperienceItem, ParsedAssignmentDetails, ParsedSubmissionsList, ParsedFeedbackDetails, ParsedFeedbackQuestions, ParsedCertificationSectionCertificateDetails,
	ParsedAssignmentResult, ParsedOverallPerformanceData, ParsedOverallAttendanceData, ParsedOverallGradesData, ParsedJRSData, ParsedOverallSubmissionsData, ParsedModuleOverviewData,
	ParsedEnrolledModules, ParsedOngoingModuleData, ParsedFeedbackData, ParsedBadgeData, ParsedSubmissionData, ParseNavigationTopicsList, ParseNavigationBatchCodeList, ParsePMNavigationTopicsList, ParsedPlannerData, ParsedAllModulesPageData,
	ParsedEvaluationCardsData, ParsedQuizSubmissionMetadata, ParsedQuizStudentSubmissionsList, ParseAssignmentStudentSubmissionData, ParsedAssignmentNewProblem,
	parsedQuizProblems, ParsedInstructorDailyTopicFeedbackReport, ParsedInstructorDailyFeedbackReportData, ParsedLiveSessionData, ParsedDailyFeedbackStudentsList,
	ParsedInstructorWeeklyFeedbackReportData, ParsedInstructorOverallReportData, ParsedInstructorAttendanceReportData, ParsedInstructorClassGradesReportData,
	ParsedInstructorStudentAttendanceReportData, ParsedStudentDailyFeedbackResponse, ParsedStudentWeeklyFeedbackResponse, ParsedStudentQuizSubmission,
	ParsedPMInstructorPerformanceData, ParsedPMAllLearnersList, ParsedPMAllProgramsList, ParsedPMAllCertificationList, ParsedPMAllRoundList, parsedCertificationReports, ParsedPMAllInstructorsList, ParsedPMAllModulesList, ParsedUserAccountData, ParsedPMAllProgramsData, ParsedProgramsOverviewData,
	ParsedInstructorsData, ParsedCurriculumOverviewData, ParsedModulePerformanceData, ParsedAllModulesDataForProgram, ParsedBatchmateDetails, ParsedGroupDetails,
	ParsedModuleTempalteList, ParsedLiveSessionScheduleData, ParsedProgramTemplateData, ParsedModuleTemplateData, ParsedPerformanceClassGradesByWeeks, ParsedPerformanceClassGradesByMonths, ParsedPerformanceAttendanceByWeeks, ParsedPerformanceAttendanceByMonths, ParsedEditProgramData,
	ParsedCertificationDetailsData, parseActiveCertificationData, parsedCertificationResources, parsedDashboardCertificationsData, parsedAllDashboardCertificationsData, ParsedCoursesAndCertifications, ParsedHonorsAndAccomplishments, ParsedAllJobs, ParsedJobDetails, ParsedCompanyData, ParsedStageHistoryOfAllJobs,
	ParsedJobsReportResponse, ParsedMissedSessionsResponse, ParsedInstructoreDashboardReportResponse, ParsedMyRewardsData, ParsedEditRewardsData, ParsedInstructorPaymentReportResponse, ParsedEmailReportResponse, ParsedAttendanceDashboardReportResponse, ParsedModuleCostResponse, ParsedActiveFor30Days, ParsedBatchwiseCertificationData, ParsedBatchwiseActiveStudentData, ParsedBatchwiseCertificationPassStudentData, ParsedActiveStudentData, ParsedBatchwiseAttendance, ParsedInstructorDailyFeedbackReportDataOnPageLoad, ParsedInstructorDailyFeedbackReportDataOnPageLoadNew, ParsedInstructorDailyFeedbackReportDataOverall, ParsedInstructorDailyFeedbackReportDataOverallNew, ParsedInstructorDailyFeedbackReportPM, ParsedPMHomepageStats, ParsedPMHomepageOngoingModulesData, ParsedLearnerCertificationsListData
};